import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
        en: {
    translation: {
        "social_publish_this_video": "Publish this Video",
        "tab_social_sub_upload": "Upload & Video",
        "tab_social_sub_skill_videos": "Skill Videos",
        "tab_social_sub_connectors": "API Connectors",
        "tab_social_sub_comments": "Comments & AI Moderation",
        "tab_social_sub_history": "Publish History",
        "social_tab_skill_videos": "My Skill Videos",
        "social_skill_videos_title": "My Skill Videos (Ready to Publish)",
        "social_skill_videos_empty": "No published skills with a video file found.",

        "gen_new_posts": "Generate New Posts",
        "copy_content": "Copy Content",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% VAT (one-time)",

        "pricing_options_title": "Publishing Options & Pricing",
        "pricing_yt": "1. YouTube Link (requires PRO plan)",
        "pricing_mp4": "2. Upload MP4 file to our server",
        "pricing_mp4_non_pro": "1. Upload MP4 file to our server",
        "pricing_order": "3. Order video recording from us",
        "pricing_order_non_pro": "2. Order video recording from us",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Showcase Video Link (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Skill Package (.zip, .json, .py)",
      "skill_package_placeholder": "Select skill file...",
      "skill_description": "Skill Description & Instructions",
      "skill_description_placeholder": "How to use this skill?",
      "skill_tags": "Tags / Technologies",
      "skill_tags_placeholder": "Select technologies...",
      "login_action": "Log in",
      "create_account_action": "Create account",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "SEO Audit",
        "seo_audit_title": "Global SEO Audit",
        "seo_audit_desc": "Scans all client websites for SEO correctness, SSL, RWD, and Google indexing.",
        "seo_audit_resume": "Resume audit",
        "seo_audit_new": "New audit",
        "seo_audit_scanning": "Scanning...",
        "seo_audit_confirm": "Are you sure you want to start a completely new audit? The previous report will be saved as an archival version.", "btn_compose": "Compose","label_system": "System",
      "label_basic_package": "Basic Package", 
      "label_premium_modules": "Premium Modules", 
      "tab_google_maps": "Google Maps (AI)", 
      "tab_affiliate": "Affiliate Program",
      
      "cart_btn": "Cart",
      "your_cart": "Your Cart",
      "cart_empty": "Cart is empty.",
      "clear_cart": "Clear cart",
      "checkout_cart": "Checkout (Pay together)",
      "payment_error": "Payment error",
      "go_to_chats": "Go to chats",
      "dashboard_quick_actions": "Quick Actions & Tools",
      "unread_chats": "Unread Chats",
      "ai_requests_today": "Today:",
      "ai_requests_btn": "AI Settings",
      "go_to_inbox": "Go to inbox",
      "remaining_appointments": "Remaining appointments",
      "go_to_calendar": "Go to calendar",
      "total_customers": "Total Customers",
      "view_database": "View Database",
      "folder_inbox": "📥 Inbox",
      "folder_sent": "📤 Sent",
      "folder_starred": "⭐ Starred",
      "folder_spam": "🛑 Spam / Offers",
      "tab_public_profile": "Company Public Profile",

      "ai_search_empty_alert": "Enter a query in the search field to use AI.",
      "ai_search_error": "Connection error with the AI service.",
      "ai_summary_title": "AI Summary",
      "ask_ai_search_btn": "Search with AI",
        ask_ai: "Ask AI",
        btn_clear_to_trash: "Clear to Trash",
        empty_trash_btn: "Empty Trash",
        filter_unread_btn: "🔵 Show Unread",
        filter_unread_active: "🔵 Only Unread (Active)",

      "register_card_title": "🚀 Start Selling Your AI Skills - Sign Up",
      "register_card_desc": "Register using your email address to immediately upload and publish your AI skill to the marketplace!",
      "login_first_to_create_card": "ℹ️ Sign in or create an account to start configuring your AI website and use CRM.",
      "social_login_title": "Quick social login (Recommended)",
      "login_with_google": "Continue with Google",
      "login_with_facebook": "Continue with Facebook",
      "login_with_apple": "Continue with Apple",
      "or_register_email": "OR REGISTER WITH EMAIL",
      "or_pin_login": "OR LOGIN TRADITIONALLY WITH PIN",
      "chat_consent_label": "I agree to the terms and",
      "privacy_policy_link": "Privacy Policy",
      "btn_send_register_pin": "🚀 Create account & Send PIN",
      "have_account_login": "Already have an account? Go to login",
      "need_account_start": "✨ Want to upload skills? Create an account!",
      "back_to_home": "← Back to Home",
      "create_free_account": "Order account",
      "email_address": "Email Address",
      "security_pin": "Security PIN (6 digits)",
      "forgot_pin": "Forgot PIN?",
      "login_with_pin": "Login with PIN",
      "sign_in": "Sign In",
      "welcome_back": "Welcome Back",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Configure your Twilio phone number and OpenAI API key to enable the voice assistant.",
      calls_instruction_title: "Setup Instructions",
      calls_instruction_desc: "Don't know how to create and configure an OpenAI account or purchase a Twilio number? Download our step-by-step guide: ",
      calls_instruction_link: "Download Guide (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Voice Agent Instructions (Prompt)",
      ai_voice_system_prompt_desc: "Leave blank to use default behavior (assistant collects caller details and reason), or enter your custom conversational rules.",
      ai_voice_system_prompt_placeholder: "Default: You are a voice assistant...\n(Optional) If number 00000 calls, bypass agent and connect directly.",
      webhook_config_title: "Twilio Webhook Configuration",
      webhook_config_desc: "Copy the URL below and paste it in your Twilio phone number settings:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Copy",
      btn_copied: "Copied",
      btn_save_config: "Save Configuration",
      save_success_title: "Saved",
      save_success_desc: "AI Voice settings saved successfully.",
      save_error_title: "Error",
      save_error_desc: "Failed to save settings. Check server logs.",
      tab_voice_config: "AI Voice Configuration",
      tab_voice_history: "Voice Calls History",

      analytics_buy_tokens: "Buy AI Tokens", analytics_package_desc: "1 package = 100,000 tokens (50 PLN net)", analytics_buy_btn: "Buy for {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Days", time_30d: "30 Days", time_3m: "3 Months", time_6m: "6 Months",
      
      analytics_chart2_legend: "Active Calls (Redis)",
      analytics_chart2_desc: "Number of active Redis voice sessions over time",
      analytics_chart2_title: "Live Active Voice Calls",
      analytics_chart1_legend_voice: "Voice Session Tokens",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Historical and current breakdown of text chat and voice session token usage",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Account status: Blocked (403)",
      analytics_status_ok: "Account status: Active (OK)",
      analytics_available_credits_title: "Available AI Credits",
      analytics_active_calls_desc: "Fetched directly from Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Active Voice Sessions (Redis)",
      analytics_refresh: "Refresh metrics",
      analytics_last_updated: "Last updated: ",
      analytics_panel_desc: "Voice session metrics, AI token usage and real-time credit balance",
      analytics_panel_title: "Analytics Panel & Resource Usage (Recharts)",
      analytics_model: "Model",
      analytics_cost: "Cost (Credits)",
      analytics_tokens_comp: "Completion Tokens",
      analytics_tokens_prompt: "Prompt Tokens",
      analytics_date: "Date",
      analytics_history: "LLM Query History (Last 10)",
      analytics_limit_exceeded: "⚠️ Credits limit exceeded! AI Services (Chat and Voice) have been blocked.",
      analytics_limit_total: "Total limit: ",
      analytics_credits_used: "Used credits: ",
      analytics_credits_available: "Available credits: ",
      analytics_credits_available_pct: "Available",
      analytics_credits_progress: "AI Credits Usage (Progress Bar)",
      analytics_voice_minutes_rate: "Converted per-minute rate for phone sessions",
      analytics_voice_minutes: "Voice AI Minutes Usage",
      openai_api_key_voice: "OpenAI API Key (Realtime Voice)",
      tab_calls: "Phone Calls",
      calls_title: "Phone Calls & AI Voice Settings",
      twilio_phone_number: "Twilio Phone Number",
      save_calls_settings: "Save Voice Settings",
      add_product: "Add Product / Service",
      new_product_def: "Definition of new product / service",
      product_name: "Product / Service Name",
      price: "Price",
      currency: "Currency",
      hidden_ai_only: "Hidden on public profile (AI only)",
      ai_knowledge_desc: "Description (What should AI learn about this product?)",
      save_product: "Save Product / Service",
      update_product: "Save changes",
      confirm_delete: "Are you sure you want to delete this product?",
      delete: "Delete",
      no_products_yet: "No products or services yet. Add your first product.",
      "logout": "Logout",
      "bg_color_tab": "Background Color", "ai_image_tab": "AI Image", "bg_color_label": "Select header color", "bg_color_placeholder": "e.g. #4f46e5", "ai_image_title": "Generate AI Header (ComfyUI)", "ai_image_desc": "Generate a header background by entering your own prompt. The image will be automatically attached to your profile.", "ai_image_prompt_placeholder": "e.g. Modern office, city skyline, bright colors", "ai_image_btn": "Generate image", "ai_image_email_req": "Please enter your email in the registration form first.", "ai_image_timeout": "Wait time for image generation has expired.",
      "ai_requests_stat_title": "AI Usage (Agentic AI)",
      "ai_requests_today": "Today:",
      "ai_requests_btn": "AI Settings",
      ai_greeting: "Hello! I am your AI Assistant. Ask about products and services, or let me set up a professional website with an AI Chatbot for you! By continuing this conversation, you automatically consent to the processing and saving of all data provided here.",
      search_results_title: "Search results on map for",
      all_companies_list_title: "AILinkB Verified Directory & Interactive Map",
      landing_ai_title_simple: "How can we help you today? (Global Search)",
      landing_ai_subtitle_simple: "Looking for a company, service, or product? Ask me via voice or text, and I will search the entire AILinkB database.",
      landing_ai_placeholder_simple: "Speak or type what you are looking for...",
      search_by_voice_title: "Search by voice",
      bug_tab_submit: "📝 Report New Issue",
      bug_tab_history: "📋 My Submitted Issues & Work Status",
      bug_tab_history_admin: "📋 All Bug Reports (Admin AI Triage Panel)",
      bug_reporter_label: "Reporter / Account:",
      bug_status_open: "🔴 Open (New)",
      bug_status_in_progress: "⏳ In Progress (Engineering Working)",
      bug_status_resolved: "✅ Resolved (Fixed & User Notified)",
      bug_status_duplicate: "🔗 Duplicate (Cluster Linked by AI)",
      bug_ai_diagnosis: "🤖 AI Triage & Technical Diagnosis:",
      bug_admin_btn_progress: "⏳ Working on this (In Progress)",
      bug_admin_btn_resolve: "✅ Fixed! (Set Resolved & Send English Email to Reporter)",
      bug_admin_btn_delete: "🗑️ Delete Ticket",
      bug_no_tickets: "No bug tickets found. Thank you for helping us make AILinkB bug-free!",
      bug_status_updated_msg: "Bug status updated successfully! If marked as Resolved, an automated notification email in English has been sent to the reporter.",
      tab_social_studio: "Social Media",
      social_toggle_autoban_label: "Automatic spam deletion & offender banning",
      social_toggle_autoban_desc: "When off, AI flags toxic comments or scam and asks for your final decision (Ban). When on, AI bans offenders unconditionally on autopilot!",
      social_toggle_approval_label: "Require my approval before publishing AI replies",
      social_toggle_approval_desc: "When on, AI drafts friendly promotional answers in your queue for inspection and editing. When off, AI responds and likes comments instantly 24/7!",
      social_comments_tab_active: "📥 Approval Queue & Active Feed",
      social_comments_tab_banned: "🚫 Banned Accounts & Deleted Comments Log",
      social_btn_approve_reply: "✓ Approve, Publish & Add Heart (❤️)",
      social_btn_ban_user: "🛑 Delete comment & ban this account (Ban)",
      social_btn_ignore: "✕ Dismiss from queue",
      social_status_pending_approval: "⏳ PENDING REPLY APPROVAL",
      social_status_flagged_mod: "⚠️ TOXICITY / SPAM FLAGGED (READY TO BAN)",
      social_banned_user_notice: "🚫 ACCOUNT BANNED & DELETED",
      social_no_banned_logs: "No banned accounts or deleted spam in your archive yet.",
      social_tab_comments: "🛡️ AI Comment Shield & Engagement",
      social_comments_title: "Automated Comment Moderation & Interaction (TikTok, FB, IG, YT)",
      social_comments_desc: "AILinkB AI (powered by Agentic AI) inspects 24/7 every comment across your social streams. Positive comments are automatically liked and given smart promotional answers. Spam, scam, and toxic hate speech are deleted instantly and offenders are blocked permanently!",
      social_comments_scan_btn: "🛡️ Run AI Comment Scan & Validation",
      social_no_comments: "No comment logs yet. Click 'Run AI Comment Scan' to analyze comments from your connected social feeds!",
      social_action_replied_liked: "❤️ AUTO-LIKED & AI REPLIED",
      social_action_blocked_deleted: "🛑 DELETED & ACCOUNT BANNED",
      social_author: "Author / Account:",
      social_sentiment: "AI Sentiment / Diagnosis:",
      social_studio_title: "Social Media",
      social_pro_locked_title: "Feature Available Only in PRO Plan",
      social_pro_locked_desc: "Automated uploading and simultaneous API broadcasting of marketing materials across your connected TikTok, Facebook, Instagram, and YouTube accounts requires an Active PRO Plan (2000 PLN / month).",
      social_tab_upload: "🚀 Upload & Omnichannel Publishing",
      social_tab_connectors: "🔌 API Connectors (TikTok, FB, IG, YT)",
      social_tab_history: "📋 History & AI Text Generator",
      social_upload_media_label: "Upload photo or video (TikTok / Reels / YouTube Shorts)",
      social_caption_label: "Post caption, script and hashtags",
      social_caption_placeholder: "Enter an engaging caption or generate via AI...",
      social_ai_caption_btn: "✨ Generate Viral Caption (AI)",
      social_target_label: "Select target channels for instant publication:",
      social_publish_btn: "🚀 Publish to All Connected Accounts Simultaneously",
      social_publishing_inprogress: "Uploading and publishing to social networks via API...",
      social_connectors_desc: "Enter your API tokens and channel IDs so AILinkB can automatically broadcast videos and graphics directly from your CRM dashboard.",
      social_save_connectors: "💾 Save API Connectors Configuration",
      social_connected: "Connected",
      social_not_connected: "Missing API Token",
      "social_login_error": "Social Login error. Please try again.",
      search_by_voice_title: "Search by voice",
      bug_tab_submit: "📝 Report New Issue",
      bug_tab_history: "📋 My Submitted Issues & Work Status",
      bug_tab_history_admin: "📋 All Bug Reports (Admin AI Triage Panel)",
      bug_reporter_label: "Reporter / Account:",
      bug_status_open: "🔴 Open (New)",
      bug_status_in_progress: "⏳ In Progress (Engineering Working)",
      bug_status_resolved: "✅ Resolved (Fixed & User Notified)",
      bug_status_duplicate: "🔗 Duplicate (Cluster Linked by AI)",
      bug_ai_diagnosis: "🤖 AI Triage & Technical Diagnosis:",
      bug_admin_btn_progress: "⏳ Working on this (In Progress)",
      bug_admin_btn_resolve: "✅ Fixed! (Set Resolved & Send English Email to Reporter)",
      bug_admin_btn_delete: "🗑️ Delete Ticket",
      bug_no_tickets: "No bug tickets found. Thank you for helping us make AILinkB bug-free!",
      bug_status_updated_msg: "Bug status updated successfully! If marked as Resolved, an automated notification email in English has been sent to the reporter.",
      tab_social_studio: "Social Media",
      social_toggle_autoban_label: "Automatic spam deletion & offender banning",
      social_toggle_autoban_desc: "When off, AI flags toxic comments or scam and asks for your final decision (Ban). When on, AI bans offenders unconditionally on autopilot!",
      social_toggle_approval_label: "Require my approval before publishing AI replies",
      social_toggle_approval_desc: "When on, AI drafts friendly promotional answers in your queue for inspection and editing. When off, AI responds and likes comments instantly 24/7!",
      social_comments_tab_active: "📥 Approval Queue & Active Feed",
      social_comments_tab_banned: "🚫 Banned Accounts & Deleted Comments Log",
      social_btn_approve_reply: "✓ Approve, Publish & Add Heart (❤️)",
      social_btn_ban_user: "🛑 Delete comment & ban this account (Ban)",
      social_btn_ignore: "✕ Dismiss from queue",
      social_status_pending_approval: "⏳ PENDING REPLY APPROVAL",
      social_status_flagged_mod: "⚠️ TOXICITY / SPAM FLAGGED (READY TO BAN)",
      social_banned_user_notice: "🚫 ACCOUNT BANNED & DELETED",
      social_no_banned_logs: "No banned accounts or deleted spam in your archive yet.",
      social_tab_comments: "🛡️ AI Comment Shield & Engagement",
      social_comments_title: "Automated Comment Moderation & Interaction (TikTok, FB, IG, YT)",
      social_comments_desc: "AILinkB AI (powered by Agentic AI) inspects 24/7 every comment across your social streams. Positive comments are automatically liked and given smart promotional answers. Spam, scam, and toxic hate speech are deleted instantly and offenders are blocked permanently!",
      social_comments_scan_btn: "🛡️ Run AI Comment Scan & Validation",
      social_no_comments: "No comment logs yet. Click 'Run AI Comment Scan' to analyze comments from your connected social feeds!",
      social_action_replied_liked: "❤️ AUTO-LIKED & AI REPLIED",
      social_action_blocked_deleted: "🛑 DELETED & ACCOUNT BANNED",
      social_author: "Author / Account:",
      social_sentiment: "AI Sentiment / Diagnosis:",
      social_studio_title: "Social Media",
      social_pro_locked_title: "Feature Available Only in PRO Plan",
      social_pro_locked_desc: "Automated uploading and simultaneous API broadcasting of marketing materials across your connected TikTok, Facebook, Instagram, and YouTube accounts requires an Active PRO Plan (2000 PLN / month).",
      social_tab_upload: "🚀 Upload & Omnichannel Publishing",
      social_tab_connectors: "🔌 API Connectors (TikTok, FB, IG, YT)",
      social_tab_history: "📋 History & AI Text Generator",
      social_upload_media_label: "Upload photo or video (TikTok / Reels / YouTube Shorts)",
      social_caption_label: "Post caption, script and hashtags",
      social_caption_placeholder: "Enter an engaging caption or generate via AI...",
      social_ai_caption_btn: "✨ Generate Viral Caption (AI)",
      social_target_label: "Select target channels for instant publication:",
      social_publish_btn: "🚀 Publish to All Connected Accounts Simultaneously",
      social_publishing_inprogress: "Uploading and publishing to social networks via API...",
      social_connectors_desc: "Enter your API tokens and channel IDs so AILinkB can automatically broadcast videos and graphics directly from your CRM dashboard.",
      social_save_connectors: "💾 Save API Connectors Configuration",
      social_connected: "Connected",
      social_not_connected: "Missing API Token",
      "social_login_error": "Social Login error. Please try again.",
      "auth_server_error": "Connection error with authorization server.",
      "register_card_title": "🚀 Start Selling Your AI Skills - Sign Up",
      "register_card_desc": "Register using your email address to immediately upload and publish your AI skill to the marketplace!",
      "or_register_email": "OR SIGN UP WITH EMAIL",
      "btn_send_register_pin": "🚀 Create account & Send PIN",
      "register_success_pin_sent": "🎉 Account created! We sent a security PIN to your email. Enter it below to sign in.",
      "have_account_login": "Already have an account? Sign In",
      "need_account_start": "✨ Want to upload skills? Create an account!",
      "plan_upgrade_success_basic": "Congratulations! Activated plan: AI Business Card + Chatbot (100 PLN + 23% VAT / 123 PLN brutto)",
      "plan_upgrade_success_pro": "Congratulations! Activated plan: Business PRO (2000 PLN netto / 2460 PLN brutto)",
      "social_modal_desc": "Authorizing login via social account. Please confirm your email address to sign in or start your 1-day free trial.",

      "affiliate_opt_in_title": "🤝 Join the Affiliate Partnership Program",
      "affiliate_opt_in_desc": "Activate the affiliate program for your business right from the start. Earn recurring commissions by referring new partners to AILinkB.",

      "social_login_title": "Quick Social Sign In (Recommended)",
      "social_login_desc": "Sign in with a single click using your social accounts:",
      "login_with_google": "Continue with Google",
      "login_with_facebook": "Continue with Facebook",
      "login_with_apple": "Continue with Apple",
      "login_first_to_create_card": "ℹ️ Please sign in or create an account first to start configuring your AI Business Card and access CRM.",
      "or_pin_login": "OR SIGN IN WITH SECURITY PIN",
      "trial_badge_text": "⏳ 1-Day Free Trial",
      "trial_expires_in": "Expires in",
      "days": "days",
      "trial_expired_title": "🛑 Payment Required",
      "trial_expired_desc": "To continue using your AI Business Card and business tools, please choose a subscription plan below to reactivate your account.",
      "plan_basic_title": "🥉 AI Business Card + Chatbot Plan",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN brutto) / month",
      "plan_basic_desc": "Ideal starting package. Includes full management of your AI public profile and intelligent chatbot training:",
      "plan_basic_f1": "✅ AI Business Card (Company Public Profile)",
      "plan_basic_f2": "✅ AI Chatbot training & service descriptions",
      "plan_basic_f3": "✅ Job postings and company events",
      "plan_basic_f4": "🔒 Ads, CRM, Mail & Google Maps tools are disabled",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Start earning now by selling your AI skills",
      "hero_title_discover": "Discover & Sell",
      "hero_title_skills": "AI Skills",
      "marketplace_search_placeholder": "What are you looking for? Ask AI...",
      "marketplace_popular_skills": "Popular Skills",
      "marketplace_new_prompts": "New AI Prompts",
      "plan_pro_f1": "✅ Everything in Basic Plan (AI Business Card)",
      "plan_pro_f2": "⚡ Dedicated CRM system with intelligent mail & folders",
      "plan_pro_f3": "⚡ AI Ad Campaign Generators (Google Ads & Meta Ads)",
      "plan_pro_f4": "⚡ Google Maps & Auto-Discovery B2B Lead Engine",
      "plan_pro_f5": "⚡ Social Media Post & Newsletter Generator",
      "btn_activate_subscription": "Activate Plan",
      "btn_active_current": "Current Plan",
      "pro_locked_title": "🔒 Feature available in Business PRO Plan",
      "pro_locked_desc": "You currently have the Basic plan (100 PLN + 23% VAT / 123 PLN brutto). This advanced module (CRM, Mail, Ads, or Google Maps) requires the Business PRO plan for 2000 PLN netto (2460 PLN brutto)/month.",
      "btn_upgrade_to_pro": "⚡ Upgrade to PRO Plan (2000 PLN netto / 2460 PLN brutto)",
      "admin_full_access": "👑 Administrator Plan (Full Access)",

      "folder_inbox": "📥 Inbox",
      "folder_sent": "📤 Sent",
      "folder_starred": "⭐ Starred",
      "folder_spam": "🛑 Spam / Offers",
      "folder_trash": "🗑️ Trash",
      "folder_all": "📁 All Mail",
      "custom_folders_title": "🗂️ My Custom Folders (Keywords)",
      "add_custom_folder": "Add Folder",
      "modal_add_folder_title": "Add Smart Custom Folder",
      "folder_name_label": "Folder Name",
      "folder_name_placeholder": "e.g. Invoices & Accounting",
      "folder_keywords_label": "Keywords (comma separated)",
      "folder_keywords_placeholder": "e.g. invoice, vat, billing, receipt",
      "folder_color_label": "Badge Color",
      "btn_save_folder": "Save Folder",
      "btn_delete_folder": "Delete Folder",
      "empty_trash_btn": "Empty Trash",
      "empty_trash_confirm": "Are you sure you want to permanently delete messages from Trash?",
      "folder_delete_confirm": "Are you sure you want to delete this folder?",
      "filtered_by_keywords": "Filtered by keywords:",

      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      company_public_profile_title: "Company Public Profile",
      company_public_profile_desc: "Share your dedicated link with clients featuring your services, meeting calendar, and intelligent AI assistant.",
      btn_view_public_profile: "Open Your Profile",
      btn_edit_public_profile: "Edit Profile Builder",
      btn_copy_link: "Copy Link",
      tab_public_profile: "Company Public Profile",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Background Synchronization",
      sync_in_progress: "Syncing emails in background...",
      sync_completed_refreshing: "Completed. Refreshing list...",
      no_messages_found: "No messages found.",
      welcome_back: "Welcome Back",
      login_to_dashboard: "Login to your dashboard",
      email_address: "Email Address",
      security_pin: "Security PIN (6 digits)",
      forgot_pin: "Forgot PIN?",
      login_with_pin: "Login with PIN",
      or: "OR",
      need_account: "Need an account? Start Setup",
      back_to_home: "← Back to Home",
      cancel_edit: "← Cancel Edit",
      save_profile: "Save Profile",
      save_profile_activate: "Save Profile & Activate AI",
      sign_in: "Sign In",
      "no_services_listed": "This company has not listed specific services yet.", "view_details": "View Details", "scan_mobile": "Scan to open on mobile:", "map_location": "Map & Location", "map_not_provided": "Map coordinates not provided.", "partner_program": "AILinkB Partner - Refer and earn!", "affiliate_code": "Affiliate Code:", "create_free_account": "Create an account", "tab_needs": "Needs", "tab_job_offers": "Job Offers",       "tab_services": "Our Products and Services",
      "setting_up_ai": "Setting up your AI...",
      "onboard_success_title": "Your AI Assistant is Ready!",
      "onboard_success_desc": "We've sent your access PIN to",
      "onboard_success_check_inbox": "Check your inbox!",
      "onboard_success_instructions": "You will receive the installation instructions and widget code to your email after your subscription is activated. You can also access it later in your dashboard.",
      "onboard_success_btn_login": "Go to Login & Full Dashboard",
      "onboard_live_test": "Live Test Widget",
      "admin_system_settings_title": "System Global Settings (Admin Only)",
      "admin_save_all_settings": "Save All Settings",
      "settings_saved": "Settings saved!",
      "admin_smtp_warning_text": "You cannot send campaigns or tests until you configure your SMTP settings.",
      "admin_go_to_settings": "Go to Settings now",
      "instagram_business_account_id": "Instagram Business Account ID",
      "bg_color_tab": "Background Color", "ai_image_tab": "AI Image", "bg_color_label": "Select header color", "bg_color_placeholder": "e.g. #4f46e5", "ai_image_title": "Generate AI Header", "ai_image_desc": "Generate a header background by entering your own prompt. The image will be automatically attached to your profile.", "ai_image_prompt_placeholder": "e.g. Modern office, city skyline, bright colors", "ai_image_btn": "Generate image", "ai_image_email_req": "Please enter your email in the registration form first.", "ai_image_timeout": "Wait time for image generation has expired.",
      "mark_as_read": "Mark as read",
      "conversations": "conversations",
      "live_editor_title": "Live Editor: Create your company profile",
      "preview_btn_top": "👁️ Preview (New Window)",
      "preview_btn_bottom": "👁️ Live Website Preview (New Window)",
      "preview_banner_title": "LIVE REAL-TIME WEBSITE PREVIEW",
      "preview_banner_desc": "This is how your completed website will look on AILinkB after saving the form.",
      "preview_banner_close": "✖ Close Preview",
      "our_services": "Our Services",
      "about_us": "About Us",
      "about_us_placeholder": "Enter information for the AI to use, e.g.:\n• Working hours and rules\n• Pricing policy and discounts\n• Your company's advantages\n• FAQ (frequently asked questions)\n• Instructions for AI (e.g., 'Address the client informally')",
      "live_ai_chat": "Live AI Chat Preview",
      "service_name": "Service Name",
      "brief_desc": "Brief description...",
      "add_service": "+ Add Service",
      "install_widget": "How to install widget on your site?",
      "profile_link": "Your Dedicated Profile Link",
      "copy": "Copy",
      "ai_learn_note": "Note: the AI will only learn your specific details after you click Save.",
      "chat_consent_label": "I accept the ",
      "privacy_policy_link": "Privacy Policy",
      "privacy_policy_title": "Privacy Policy",
      "privacy_policy_content": "Privacy Policy\nOverview\nThis Privacy Policy was created to explain the rules for processing personal data obtained via the https://ailinkb.com/ website (hereinafter: the Website). We indicate that we exercise due diligence to ensure that your personal data is processed in accordance with the requirements of applicable law, in particular in accordance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) (hereinafter: GDPR).\n\nData Management\nThe processing of personal data is based on lawfulness, fairness, and transparency of information. Data is collected by the Personal Data Administrator for a specific, explicit, and legitimate purpose, and the scope of data is limited to data necessary to achieve this purpose. The Personal Data Administrator makes every necessary effort to ensure the highest possible security and protection of the personal data processed by them. Providing data is voluntary. Each of you has the right to access and check your personal data, update it, and request its deletion.\nPersonal data was collected by us directly from you or from entities cooperating with us – administrators of mailing databases (Growbots Sp. z o.o., KRS number: 0000504714) to perform the contract concluded with you or - in the case of Cookies - based on your consent.\nPersonal Data Administrator\nThe Personal Data Administrator is: QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B Share capital 10 000 PLN (hereinafter: ailinkb or the Administrator).\nWith respect to your rights as data subjects (i.e., persons to whom the data relates) and with respect to mandatory legal provisions, including in particular the GDPR, the Polish Act on Personal Data Protection (hereinafter: the Act) and other relevant regulations on the protection of personal data, we commit to maintaining the security and confidentiality of all personal data you share with us. All our employees have been properly trained in the field of personal data protection, and ailinkb, as the Personal Data Administrator, has introduced new security measures and technical and organizational measures to ensure the highest possible level of personal data protection. We have introduced appropriate personal data processing procedures and policies in accordance with the GDPR, so that the processing of personal data takes place lawfully and fairly, and you, as data subjects, can exercise all your respective rights. Additionally, if necessary, we cooperate with the regulatory authority in the Republic of Poland, i.e., the President of the Personal Data Protection Office (hereinafter: PUODO).\nAll questions, requests, or complaints related to the processing of personal data in ailinkb (Personal Data Administrator) should be directed electronically to the e-mail address: support@ailinkb.com, or in writing to the postal address of the Personal Data Administrator, i.e. QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B.\nRequests should unambiguously contain:\nthe data of the person or persons to whom the request relates,\nthe event to which the request relates,\nthe requests made,\nthe desired method of resolving the matter.\nType of processed personal data and purposes of personal data processing\nOur Website collects the following personal data:\na) e-mail address - we collect your e-mail address to create an account for you on the Website,\n\nb) name, surname, residential address, and tax identification number (NIP) - we collect them from customers asking us to issue an invoice,\n\nc) credit card number, CVC code, and card expiry date - this information is necessary to make payments for our services,\n\nd) in the case of entrepreneurs, the above scope of data may be extended by: company name, other entrepreneur identification numbers (including REGON), business address.\n\ne) in connection with the use of the Website, additional data may be processed, in particular: IP address, domain name, browser type, access time or type of operating system, as well as navigation data, including information about links and references you decide to click on and other actions you take on our Website,\n\nIn connection with the use of the Website, your personal data may be collected by:\n\nsending an inquiry via the contact form,\n\ncommunication via e-mail messages, as well as instant messengers such as Messenger (Intercom),\n\nProviding the data specified in section 1 lit. a - d is voluntary and is exclusively a contractual requirement. Providing this data is, however, necessary to create an account on the Website and use its paid version, and thus to perform the contract regarding the local positioning of the business card (hereinafter: the Contract). Providing the data specified in section 1 lit. e takes place on the basis of your consent.\n\nYour personal data is processed for the following purposes: proper performance of the Contract or taking action at your request before concluding the Contract, in particular answering questions asked, e.g. via the contact form (Article 6(1)(b) of the GDPR); fulfilling a legal obligation incumbent on the Administrator (Article 6(1)(c) of the GDPR); possible determination, pursuit or defense against claims, as the legitimate interest of the Administrator (Article 6(1)(f) of the GDPR); proper use of the contact/login form service posted on the Website to perform the Contract (Article 6(1)(b) of the GDPR - necessity to perform the contract for the provision of the contact form service); signing up and receiving information about services and their functionalities available on the Website to perform the Contract, the subject of which is an electronic service. The Administrator may also collect navigation data from Website users, including information about links and references they decide to click on or other activities undertaken on the Website, used to facilitate the use of services provided electronically and to improve the functionality of these services, which constitutes the legitimate interest of the Administrator (Article 6(1)(f) of the GDPR),\nThe source of personal data processed by the Personal Data Administrator are the persons to whom the data relates.\nWhile filling out the login form on the Website, the User provides: e-mail address and confidential password only for the User's knowledge.\nThere is no automated decision-making as a result of personal data processing, including as a result of profiling this data.\nCookies and profiling\nThe Website uses Cookies technology to match its functionality to your individual needs. The user can therefore consent to saving the data and information entered by them so that they can be later used during subsequent visits to the site without having to enter them again. Owners of other websites will not have access to this data and information. However, if you do not agree to personalizing the Website, you can disable Cookies in your web browsers.\nEvery person using the Website can decide whether and how they want to use our services and share their data and information to a specific extent, in accordance with this Privacy Policy.\nPersonal data processing period\nYour data will be processed for the period necessary to perform the Contract and may be processed for the period necessary to pursue the legitimate interests of the Administrator (i.e. until the statute of limitations for any claims arising from the performance of the Contract),\nIn a situation where the basis for processing your personal data is consent, this data is processed by the Administrator until the consent is revoked.\nData recipients\nYour personal data may be transferred to entities cooperating with ailinkb, in particular entities providing IT services and support, accounting and IT companies servicing us, as well as all institutions entitled to process personal data under public law provisions, in particular Tax Offices and, if necessary, entities providing archiving services. In justified cases, your data may be sent outside the EU. In such a case, ailinkb will each time ensure the confidentiality of the transferred data and that only data necessary for the proper performance of the Contract is transferred, based on appropriate personal data safeguards required by applicable legal provisions.\n\nThe Administrator transfers personal data to third countries, outside the European Economic Area, only to the following entities, due to the international nature of these entities and their possession of part of the teleinformation infrastructure outside the EEA:\n\na) with respect to Users of the Website https://ailinkb.com/pl/ from the territory of the United States - the company operating under the name: Paddle.com Inc, having the address: 3811 Ditmars Blvd #1071 Astoria NY 11105-1803 - an entity responsible for keeping settlements and sending financial documents (invoices) to users of the https://ailinkb.com/pl/ website. Paddel.com Inc declares compliance of data transfer with GDPR requirements, e.g. by applying standard contractual clauses. Information on the processing of personal data can also be found at https://www.paddle.com/legal/data-sharing-addendum\n\nb) with respect to Users of the Website https://ailinkb.com/pl/ from the territory of other countries - the company operating under the name: Paddle.com Market Limited (registration number 08172165), having the address: 15 Briery Close, Great Oakley, Corby, Northamptonshire NN18 8JG, United Kingdom of Great Britain and Northern Ireland - an entity responsible for keeping settlements and sending financial documents (invoices) to Users of the Website https://ailinkb.com/pl/. Based on the European Commission's decision of June 28, 2021, it was confirmed that data transfer to the United Kingdom of Great Britain and Northern Ireland provides an adequate level of personal data protection (the first decision with ref. no. C(2021) 4800 final, was issued on the basis of Regulation (EU) 2016/679 (GDPR) and the second with ref. no. C(2021) 4801 final, was issued on the basis of Directive (EU) 2016/680.\n\nThe European Commission's recognition of a specific third country, in this case the United Kingdom, as providing an adequate level of personal data protection allows for the free transfer of such data from the European Economic Area without the need to obtain additional permissions or implement additional safeguards provided for in Chapter V of the GDPR, which are required if the third country does not provide such protection. Information on the processing of personal data can also be found at https://www.paddle.com/legal/data-sharing-addendum\n\nPersonal data may be shared with entities that process this data on our behalf, i.e., on behalf of the Personal Data Administrator. In such cases, as the Personal Data Administrator, we conclude a personal data processing agreement with such an entity. The processing entity processes the shared personal data exclusively for the purposes specified in the aforementioned agreement. Without sharing personal data with such entities, we would not be able to conduct business on our Website. As the Personal Data Administrator, we share personal data for processing with entities:\n\nproviding hosting services for the Website,\nproviding other services to us that are necessary for the proper functioning of the Website.\nIn accordance with the GDPR, any person whose personal data is processed by the personal data administrator has the right to demand from the administrator:\nto be informed about the processing of their personal data, in accordance with Art. 12 GDPR - The Administrator is obliged to provide the information specified in the GDPR (including regarding the data itself, contact details, purposes and legal bases for processing personal data, personal data recipients or categories of recipients, if any, or the period for which the data will be processed or the criteria on the basis of which such a period is determined) to the data subject; this obligation should be fulfilled immediately upon obtaining the data for the first time, and if the data was not obtained from the data subject, but from another source, then it should be fulfilled within a reasonable time depending on the circumstances; The Administrator may resign from providing this information to the data subject if this person has already been informed about it,\naccess to their personal data, in accordance with Art. 15 GDPR - by providing us with your personal data, you have the right to access and view them; however, this does not mean that you have access to all documents that contain your data, because these documents may contain confidential information; you have the right to information which of your data is processed and how, as well as the right to receive a copy of your personal data, the first copy being issued free of charge, and for each subsequent one, in accordance with the GDPR, we may charge an appropriate administrative fee related to making a copy,\nrectification of personal data, in accordance with Art. 16 GDPR - if your personal data has changed, please inform us, as the Administrator, of this fact so that the personal data stored by us corresponds to real information and is up to date; also in situations where personal data has not changed, but for some reason the data stored by us is incorrect or has been recorded incorrectly (e.g. as a result of an editorial error), please inform us so that we can correct the relevant data points,\nerasure of data (right to be forgotten), in accordance with Art. 17 GDPR - in other words, you have the right to demand from us, as the Administrator, to delete data in our possession and the right to demand that we, as the Administrator, inform other administrators with whom we have shared your data about your request for their deletion. You can request the deletion of your personal data primarily when:\n\nthe purposes for which personal data was provided have been fulfilled, e.g. we have fully performed the Contract concluded between us,\n\nthe basis for processing your personal data was explicit consent, which was subsequently withdrawn and there is no other legal basis for our further processing of your personal data,\nyou have objected to our processing of your personal data in accordance with Art. 21 GDPR and you believe that we have no other legal basis allowing us to further process your personal data,\nyour personal data was processed unlawfully, i.e. for purposes inconsistent with legal provisions or without a legal basis for processing them (please note that in such cases it will be necessary to provide the basis for such a request),\nthe necessity to delete your personal data results from mandatory legal provisions,\npersonal data concerns a minor and was collected as part of an information society service,\n\nRestriction of processing, in accordance with Art. 18 GDPR - you can request us to limit the scope of processing your personal data (which means that until the matter is clarified, we would limit ourselves only to storing the data), if:\n\nyou question the correctness of your personal data,\n\nyou believe that we process your personal data without a legal basis, but at the same time you do not want us to delete the personal data (i.e. you do not exercise the aforementioned right),\nyou have raised an objection,\nFurthermore, in accordance with the GDPR, any person whose personal data is processed by the personal data administrator has the right to:\n\ndata portability, in accordance with Art. 20 GDPR - you have the right to receive your data in a format allowing for viewing on a computer and the right to transfer the data in such a format to another administrator; you have this right only when the basis for processing your personal data was explicit consent or the data was processed automatically,\nobject to the processing of personal data in accordance with Art. 21 GDPR - you have the right to object if you do not agree to our processing of your personal data, which we have previously processed for specific purposes, in accordance with mandatory legal provisions,\nobject to data profiling, in accordance with Art. 22 (within the meaning of Art. 4 sec. 4 GDPR) - on our website you will not be subjected to automated decision-making or profiling, in accordance with the GDPR, unless you explicitly consent to it; furthermore, you will always be informed about any cases of profiling, if they occur,\nlodge a complaint with a regulatory body (i.e., the President of the Personal Data Protection Office), in accordance with Art. 77 GDPR - if you believe that we process your personal data unlawfully or in a manner that violates your rights resulting from mandatory personal data protection laws, or to the supervisory authority of another European Union Member State competent for the place of habitual residence or place of work or the place of the alleged infringement.\nIn the event that a Website User exercises a right resulting from the above rights, the Administrator will fulfill the request or refuse to fulfill it immediately, but no later than within a month from its receipt. However, it may happen that due to the complex nature of the request or the number of requests, the Administrator will not be able to fulfill the request within a month, referred to in the preceding sentence, then it will fulfill it within the next two months, simultaneously informing the user of the intended extension of the deadline and its reasons.\n\nAt any time, the Website user can submit any complaints, inquiries, and requests regarding the processing of their personal data and the exercise of their rights to the Administrator.\n\nConsent and information on the possibility of withdrawing consent\nIf the legal basis for processing your personal data is your consent, you have the right to withdraw your consent to the processing of personal data at any time, however, the withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal.\n\nFinal provisions\nIf you wish to exercise any of the rights mentioned above, please review the appropriate tabs on our Website, which allow you to delete your account and data collected by our Website, or send an e-mail to: support@ailinkb.com\nEvery identified case of a security breach is documented, and in the event of any of the events described in the GDPR or the Act, the data subjects, as well as PUODO, if applicable, are informed about it.\nAll matters not regulated in this Privacy Policy will be governed by relevant mandatory legal provisions. If any of the provisions of this Privacy Policy is inconsistent with the above-mentioned legal provisions, the legal provisions shall prevail.\nBy using the https://ailinkb.com/ website, you accept these terms of the privacy policy. Please be informed that Cookie settings can be changed at any time using your web browser settings.\nThe Privacy Policy may change, of which the Data Administrator will inform with 7 days' advance notice.\nQuestions regarding the Privacy Policy should be sent to: support@ailinkb.com.\n\n\nProhibited Use of the Service:\nIt is strictly forbidden to use the Service for any illegal purposes, including conducting criminal activities, fraud, or other activities violating generally applicable laws. In the event that an account is found to be used for illegal purposes, the Administrator reserves the absolute right to immediately block or permanently delete the User's account without prior notice.\n\nThe service operates in accordance with Polish law, and the place to resolve disputes is the court closest to where the company QR-SYSTEM is located.\n\nTrial Period and Account Retention Policy:\nEvery new user receives a free 1-day trial period. If subscription fees (Basic 100 PLN or PRO 2000 PLN package) are not settled before the trial expires, automated reminder emails are dispatched (at 3 days and 1 day remaining), and upon trial completion, account access is temporarily suspended (deactivated). If payment remains unfulfilled for an additional 7-day grace period following deactivation, the user account along with all associated database records and AI Business Card configs will be automatically and permanently terminated from AILinkB servers.\n\nDate of last modification: August 2, 2026\n\nContent Publication Policy:\nUsers publishing their own video materials (Prompts / Skills) on our service are required to explicitly state in the video content that the material is published and available on the AILinkB platform. By uploading, the user also grants permission for the AILinkB platform to publish and promote their video materials on our social media channels on their behalf.",
      "cookie_title": "This website uses cookies 🍪",
      "cookie_desc": "We use cookies to ensure you get the best experience on our website. By agreeing, you accept our cookie consent. Access to the site requires your consent.",
      "cookie_accept": "I Accept",
      "Find Service Near You": "Find Service Near You",
      "search_placeholder": "What are you looking for?",
      "search_services": "Services",
      "search_purchases": "Buying Needs",
      "search_jobs": "Pracovní nabídky",
      "search_events": "Události",
      "search_events": "Evenemang",
      "search_events": "Evenementen",
      "search_events": "Eventos",
      "search_events": "Eventi",
      "search_events": "Eventos",
      "search_events": "Événements",
      "search_events": "Veranstaltungen",
      "search_events": "Wydarzenia",
      "search_events": "Events",
      "title_services": "Find Services Near You",
      "title_purchases": "Find Buying Needs Near You",
      "title_jobs": "Find Jobs Near You",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Search",
      "no_companies_found": "No companies found yet.",
      "address": "Address:",
      "phone": "Phone:",
      "website": "Website:",
      "email": "Email:",
      "view_details": "View Details",
      "chat_ai": "Chat",
      "greeting": "Hi! I am the AI assistant for {{name}}.",
      "km_away": "km away",
      "company_details": "Company Details",
      "about_company": "About the Company:",
      "offered_services": "Offered Services:",
      "duration": "Duration",
      "mins": "mins",
      "start_ai_consultation": "Start AI Consultation",
      "no_details": "No details available.",
      "typing": "Typing...",
      "type_message": "Type your message...",
      "more": "more",
      "language": "Language",
      "tab_map_of_partners": "Map of Partners",
      "tab_dashboard": "Dashboard",
      "tab_system_logs": "System Logs",
      "tab_phone_calls": "Phone Calls",
      "tab_website": "My Website",

      "google_maps_title": "Google Maps Profiles",
      "google_maps_desc": "Manage your company visibility on Google Maps. Add location info, contacts, and integrate with the AI assistant.",
      "btn_new_profile": "New Profile",
      "btn_edit": "Edit",
      "status_pending_verification": "Pending Verification",
      "status_published": "Published",
      "btn_publish_map": "Publish to map",
      "google_maps_empty_title": "No Google Maps Profiles",
      "google_maps_empty_desc": "You don't have a configured company profile yet. Add it to make it easier for customers to find your business and sync data with the AI assistant.",
      "btn_add_first_profile": "Add first profile",
      "company_address": "Company Address",
      "no_company_desc": "No company description.",
      "company_category": "Category",
      "company_phone": "Phone",
      "modal_title_edit_profile": "Edit Profile",
      "modal_title_new_profile": "New Google Maps Profile",
      "btn_cancel": "Cancel",
      "btn_save": "Save Profile",
      "lbl_business_name": "Company name",
      "lbl_business_address": "Full address (street, city, zip code)",
      "lbl_business_category": "Business category",
      "lbl_business_phone": "Phone number",
      "lbl_business_website": "Website",
      "lbl_business_desc": "Company description",
      "lbl_business_desc_hint": "Short description of your business, visible on the Google Maps profile",
      "tab_customers": "Customers",
      "tab_appointments": "Appointments",
      "tab_email": "E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Drafts (AI)",
      "btn_ai_redact_reply": "✨ Draft / Edit with AI",
      "ai_draft_empty": "AI could not generate a draft for this message.",
      "ai_draft_error": "Error while connecting to AI service.",
      "ai_redact_no_incoming": "This automated drafting feature relies on an incoming email thread. Please open via the 'Reply' button.",
      "compose_email_title": "Compose Email",
      "compose_from": "From",
      "compose_to": "To",
      "compose_subject": "Subject",
      "compose_body": "Message Body",
      "compose_load_template": "Load template...",
      "btn_send_message": "Send Message",
      "smtp_not_configured": "SMTP Not Configured",
      "tab_visitor_chats": "Visitor Chats",
      "tab_orders": "Orders",
      "tab_mail_campaigns": "Mail Campaigns",
      "tab_ad_campaigns": "Ad Campaigns (AI)",
      "tab_email_templates": "Email Templates",
      "tab_blacklist": "Blacklist",
      "tab_services": "Products / Services",
      "tab_events": "Events",
      "chat_update_offline": "Software update in progress. You can continue the conversation in a moment...",
      "tab_settings": "Settings",
      "tab_admin_panel": "Admin Panel",
      "install_widget": "Install Widget",
      "unread_emails": "Unread Emails",
      "go_to_inbox": "Go to Inbox",
      "remaining_appointments": "Remaining Appointments",
      "go_to_calendar": "Go to Calendar",
      "new_orders_today": "New Orders Today",
      "view_orders": "View Orders",
      "total_customers": "Total Customers",
      "view_database": "View Database",
      "dashboard_chat_title": "AILinkB Dashboard Chat",
      "dashboard_chat_desc": "Ask questions based on your specific data sources.",
      "unread_chats": "Unread Chats",
      "knowledge_sources": "KNOWLEDGE SOURCES:",
      "ai_searching": "AI is searching your knowledge base...",
      "cal_daily_appointments": "Daily Appointments",
      "cal_new_appointment": "New Appointment",
      "cal_reminder": "Reminder",
      "cal_meeting_details": "Meeting Details",
      "cal_time": "Time",
      "cal_agenda": "Agenda / Notes",
      "cal_no_notes": "No notes.",
      "cal_confirm": "Confirm",
      "cal_delete": "Delete",
      "cal_delete_confirm": "Delete meeting?",
      "cal_schedule_new": "Schedule New Meeting",
      "cal_meeting_title": "Meeting Title",
      "cal_associated_lead": "Associated Lead",
      "cal_search_lead": "Search for a lead...",
      "cal_no_leads": "No leads found",
      "cal_start_time": "Start Time",
      "cal_end_time": "End Time",
      "cal_cancel": "Cancel",
      "cal_schedule": "Schedule",
      "admin_title": "Admin Panel - Users & Roles",
      "admin_search_email": "Search Email",
      "admin_search_email_placeholder": "Search by email...",
      "admin_filter_role": "Filter by Role",
      "admin_all_roles": "All Roles",
      "admin_filter_status": "Filter by Status",
      "admin_filter_plan": "Filter by Plan",
      "admin_clear": "Clear",
      "admin_id": "ID",
      "admin_email": "Email",
      "admin_company": "Company",
      "admin_role": "Role",
      "admin_subscription": "Subscription",
      "admin_plan": "Plan",
      "admin_no_users": "No users found matching your filters.",
      "admin_prompts_title": "Global AI Prompts & System Behavior (Admin Panel)",
      "admin_prompts_desc": "Configure core systemic behavior, conversational tone, and linguistic rules for all AI models. Do NOT add entity-specific descriptions here (use Client Profile settings instead).",
      "admin_global_rules_label": "Global AI Guardrails & Conversational Tone",
      "admin_global_rules_desc": "Primary rules enforcing natural human-like responses, conversational friendliness, conciseness, and greeting etiquette.",
      "admin_default_system_prompt_label": "Default System Prompt (For New Entities)",
      "admin_default_system_prompt_desc": "Baseline instructions defining how AI interacts with Context and RAG vector searches.",
      "admin_autoreply_prompt_label": "Email Auto-Reply Prompt",
      "admin_autoreply_prompt_desc": "Instructions for analyzing emails and formatting response drafts in JSON.",
      "admin_save_prompts": "Save Global Prompts",
      "admin_prompts_saved": "Global AI prompt configurations saved successfully!",
      "vpsMonitor.tabName": "VPS Monitor",
      "vpsMonitor.title": "VPS Server Resources",
      "vpsMonitor.cpu": "CPU Usage",
      "vpsMonitor.ram": "RAM Usage",
      "vpsMonitor.disk": "Disk Usage",
      "vpsMonitor.cpuChart": "CPU Usage Over Time",
      "vpsMonitor.ramChart": "RAM Usage Over Time",
      "vpsMonitor.diskChart": "Disk Usage Over Time",
      "vpsMonitor.range1h": "Last 1 hour",
      "vpsMonitor.range6h": "Last 6 hours",
      "vpsMonitor.range24h": "Last 24 hours",
      "vpsMonitor.range7d": "Last 7 days",
      "vpsMonitor.range30d": "Last 30 days"
}
  },

        pl: {
    translation: {
        "social_publish_this_video": "Publikuj to Wideo",
        "tab_social_sub_upload": "Wrzutka & Wideo",
        "tab_social_sub_skill_videos": "Wideo (Skille)",
        "tab_social_sub_connectors": "Konektory API",
        "tab_social_sub_comments": "Komentarze & AI Moderacja",
        "tab_social_sub_history": "Historia Publikacji",
        "social_tab_skill_videos": "Moje Filmy ze Skilli",
        "social_skill_videos_title": "Moje Filmy ze Skilli (Gotowe do publikacji)",
        "social_skill_videos_empty": "Brak opublikowanych skilli z wgranym plikiem wideo.",

        "gen_new_posts": "Wygeneruj nowe posty",
        "copy_content": "Kopiuj treść",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% VAT (jednorazowo)",

        "pricing_options_title": "Opcje i Cennik Publikacji",
        "pricing_yt": "1. Link z YouTube (wymaga planu PRO)",
        "pricing_mp4": "2. Wgranie pliku MP4 na nasz serwer",
        "pricing_mp4_non_pro": "1. Wgranie pliku MP4 na nasz serwer",
        "pricing_order": "3. Zlecenie nagrania wideo przez nas",
        "pricing_order_non_pro": "2. Zlecenie nagrania wideo przez nas",

      "order_video_tab": "Zleć wideo",
      "order_video_desc": "Nie masz własnego wideo? Nagramy profesjonalną prezentację Twojego Skilla za Ciebie! Koszt usługi to 25 EUR + 23% VAT. Wystarczy, że prześlesz nam pliki.",
      "skill_description_video": "Opis i instrukcje do nagrania wideo",
      "proceed_to_payment_order_video": "Zleć nagranie wideo i Opublikuj (25 EUR + 23% VAT)",

      "no_skills_yet": "Nie wystawiłeś jeszcze żadnych skilli na sprzedaż.",
      "preview": "Podgląd",
      "status_approved": "Opublikowany",
      "status_pending": "Oczekuje na weryfikację",
      "status_rejected": "Odrzucony",
      "chat_with_ai": "Zapytaj AI o naszą ofertę",
      "no_skills_listed": "Sprzedawca nie wystawił jeszcze żadnych Skilli AI.",
      "buy_skill": "Kup Skilla",

      "filter_tags_title": "Filtruj Tagami",
      "filter_tags_desc": "Wybierz technologie i modele AI, których szukasz w bazie:",
      "apply_filters_btn": "Zastosuj Filtry",
      "enter_email_for_access": "Podaj swój adres e-mail, na który wyślemy dostęp:",
      "payment_error": "Błąd płatności",
      "error_generic": "Błąd: ",
      "tab_publish_sell": "Opublikuj / Sprzedawaj",
      "tab_my_skills": "Moje Skille",
      "publish_sell_title": "Opublikuj i Sprzedawaj Swój Prompt / Skill",
      "publish_sell_desc": "Wybierz sposób wgrania wideo pokazującego twój produkt lub bota AI.",
      "my_published_skills": "Moje wystawione Skille AI",
      "publish_first_skill_desc": "Opublikuj swój pierwszy skill AI i zacznij zarabiać",
      "link_youtube": "Link z YouTube",
      "upload_mp4": "Wgraj Plik MP4",
      "skill_title": "Tytuł / Nazwa Promptu lub Skilla",
      "skill_package_url": "Link do Paczki ze Skillem (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Paczka Skilla (.zip, .py, .json)",
      "skill_tags": "Tagi / Technologie (np. Python, JS, Prompty)",
      "skill_price": "Cena (EUR)",
      "publish_for_verification": "Opublikuj Prompt / Skill do Weryfikacji",
      "free_publish_pro_only": "Opcja darmowej publikacji nielimitowanej przez linki z YouTube jest dostępna tylko dla posiadaczy subskrypcji PRO (5 EUR miesięcznie).",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Wideo",
      "table_title_desc": "Tytuł i Opis",
      "table_price": "Cena",
      "table_status": "Status",
      "table_actions": "Akcje",
      "confirm_delete_skill": "Czy na pewno chcesz usunąć ten skill ze sprzedaży?",
      "fill_all_fields": "Wypełnij wszystkie pola!",
      "generic_error": "Wystąpił błąd",
      "connection_error": "Błąd połączenia: ",
      "select_video_file": "Wybierz plik wideo (MP4)",
      "click_to_select": "Kliknij by wybrać...",
      "proceed_to_payment_publish": "Przejdź do płatności (5 EUR) i Opublikuj",
      "skill_video_link": "Link do wideo pokazowego (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Paczka ze skillem (.zip, .json, .py)",
      "skill_package_placeholder": "Wybierz plik ze skillem...",
      "skill_description": "Opis Skilla i Instrukcje",
      "skill_description_placeholder": "Jak używać tego skilla?",
      "skill_tags": "Tagi / Technologie",
      "skill_tags_placeholder": "Wybierz technologie...",
      "login_action": "Zaloguj się",
      "create_account_action": "Utwórz konto",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "SEO Audyt",
        "seo_audit_title": "Globalny Audyt SEO",
        "seo_audit_desc": "Skanuje wszystkie strony klientów pod kątem poprawności SEO, SSL, RWD i indeksacji w Google.",
        "seo_audit_resume": "Dokończ audyt",
        "seo_audit_new": "Nowy audyt",
        "seo_audit_scanning": "Skanowanie...",
        "seo_audit_confirm": "Czy na pewno chcesz rozpocząć całkowicie nowy audyt? Poprzedni raport zostanie zapisany jako wersja archiwalna.", "btn_compose": "Napisz","label_system": "System",
      "label_basic_package": "Podstawowy Pakiet", 
      "label_premium_modules": "Moduły Premium", 
      "tab_google_maps": "Google Maps (AI)", 
      "tab_affiliate": "Program Partnerski",
      
      "cart_btn": "Koszyk",
      "your_cart": "Twój Koszyk",
      "cart_empty": "Koszyk jest pusty.",
      "clear_cart": "Wyczyść koszyk",
      "checkout_cart": "Złóż jedno wspólne zamówienie (Zapłać)",
      "payment_error": "Błąd płatności",
      "dashboard_quick_actions": "Szybkie Akcje i Narzędzia",
      "unread_chats": "Nieprzeczytane Czaty",
      "go_to_chats": "Przejdź do czatów",
      "ai_requests_today": "Dzisiaj:",
      "ai_requests_btn": "Ustawienia AI",
      "go_to_inbox": "Przejdź do skrzynki",
      "remaining_appointments": "Pozostałe spotkania",
      "go_to_calendar": "Przejdź do kalendarza",
      "total_customers": "Wszyscy Klienci",
      "view_database": "Baza Danych",

      "ai_search_empty_alert": "Wpisz zapytanie w polu wyszukiwania, aby użyć AI.",
      "ai_search_error": "Błąd połączenia z usługą AI.",
      "ai_summary_title": "Streszczenie AI",
      "ask_ai_search_btn": "Szukaj przez AI",
        ask_ai: "Zapytaj AI",
        btn_clear_to_trash: "Wyczyść do Kosza",
        empty_trash_btn: "Opróżnij kosz",
        filter_unread_btn: "🔵 Pokaż nieprzeczytane",
        filter_unread_active: "🔵 Tylko nieprzeczytane (Aktywne)",

      "register_card_title": "🚀 Zacznij Sprzedawać Swoje Skille AI - Zarejestruj się",
      "register_card_desc": "Zarejestruj się używając adresu e-mail, aby natychmiast wrzucić i opublikować swój Skill AI na platformie!",
      "login_first_to_create_card": "ℹ️ Zaloguj się lub utwórz konto, aby rozpocząć konfigurację wizytówki AI oraz korzystać z CRM.",
      "social_login_title": "Szybkie logowanie social (Zalecane)",
      "login_with_google": "Kontynuuj z Google",
      "login_with_facebook": "Kontynuuj z Facebook",
      "login_with_apple": "Kontynuuj z Apple",
      "or_register_email": "LUB ZAREJESTRUJ SIĘ ADRESEM E-MAIL",
      "or_pin_login": "LUB ZALOGUJ SIĘ TRADYCYJNIE KODEM PIN",
      "chat_consent_label": "Zgadzam się na warunki i",
      "privacy_policy_link": "Politykę Prywatności",
      "btn_send_register_pin": "🚀 Utwórz konto i wyślij PIN",
      "have_account_login": "Masz już konto? Przejdź do logowania",
      "need_account_start": "✨ Chcesz wgrywać skille? Utwórz konto!",
      "back_to_home": "← Powrót na stronę główną",
      "create_free_account": "Zamów konto",
      "email_address": "Adres Email",
      "security_pin": "Bezpieczny PIN (6 cyfr)",
      "forgot_pin": "Nie pamiętasz PINu?",
      "login_with_pin": "Zaloguj się",
      "sign_in": "Zaloguj się",
      "welcome_back": "Witaj ponownie",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      calls_title: "Phone Calls & AI Voice Settings",
      calls_description: "Skonfiguruj numer telefonu Twilio oraz klucz API OpenAI, aby włączyć funkcję asystenta głosowego.",
      calls_instruction_title: "Instrukcja Konfiguracji",
      calls_instruction_desc: "Nie wiesz jak założyć i skonfigurować konto w OpenAI oraz jak wykupić numer w Twilio? Pobierz naszą instrukcję krok po kroku: ",
      calls_instruction_link: "Pobierz Instrukcję (PDF)",
      twilio_phone_number: "Twilio Phone Number",
      openai_voice_api_key: "OpenAI API Key (Voice)",
      ai_voice_system_prompt_label: "Instrukcje dla Agenta Głosowego (Voice Prompt)",
      ai_voice_system_prompt_desc: "Zostaw puste, aby użyć domyślnego zachowania (asystent zbiera dane dzwoniącego i powód kontaktu), lub wpisz własne zasady prowadzenia rozmowy.",
      ai_voice_system_prompt_placeholder: "Domyślnie: Jesteś asystentem głosowym...\n(Opcjonalnie) Jeśli dzwoni numer 00000, omiń agenta i połącz bezpośrednio.",
      webhook_config_title: "Konfiguracja Webhooka Twilio",
      webhook_config_desc: "Skopiuj poniższy adres URL i wklej go w ustawieniach numeru na platformie Twilio:",
      webhook_url: "Adres Webhooka (AILinkB)",
      btn_copy: "Kopiuj",
      btn_copied: "Skopiowano",
      btn_save_config: "Zapisz Konfigurację",
      save_success_title: "Zapisano",
      save_success_desc: "Pomyślnie zapisano ustawienia AI Voice.",
      save_error_title: "Błąd",
      save_error_desc: "Nie udało się zapisać ustawień. Sprawdź logi na serwerze.",
      tab_voice_config: "Konfiguracja AI Voice",
      tab_voice_history: "Historia Rozmów Głosowych",

      analytics_buy_tokens: "Dokup tokeny AI", analytics_package_desc: "1 pakiet = 100,000 tokenów (50 PLN netto)", analytics_buy_btn: "Kupuję za {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Dni", time_30d: "30 Dni", time_3m: "3 Mies.", time_6m: "6 Mies.",
      
      analytics_chart2_legend: "Aktywne Połączenia (Redis)",
      analytics_chart2_desc: "Liczba aktywnych sesji głosowych Redis w czasie",
      analytics_chart2_title: "Aktywne Połączenia Głosowe na Żywo",
      analytics_chart1_legend_voice: "Tokeny Sesje Głosowe",
      analytics_chart1_legend_text: "Tokeny Czat i Agenci",
      analytics_chart1_desc: "Historyczny i obecny podział zużycia tokenów czatu tekstowego oraz sesji głosowych",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokeny (Czat i Agenci)",
      analytics_status_blocked: "Status konta: Zablokowane (403)",
      analytics_status_ok: "Status konta: Aktywne (OK)",
      analytics_available_credits_title: "Dostępne Kredyty AI",
      analytics_active_calls_desc: "Pobrano bezpośrednio z Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Aktywne Sesje Głosowe (Redis)",
      analytics_refresh: "Odśwież metryki",
      analytics_last_updated: "Ostatnia aktualizacja: ",
      analytics_panel_desc: "Metryki sesji głosowych, zużycie tokenów AI oraz bilans kredytów w czasie rzeczywistym",
      analytics_panel_title: "Panel Analityczny i Zużycie Zasobów (Recharts)",
      analytics_model: "Model",
      analytics_cost: "Koszt (Kredyty)",
      analytics_tokens_comp: "Tokeny Completion",
      analytics_tokens_prompt: "Tokeny Prompt",
      analytics_date: "Data",
      analytics_history: "Historia Zapytań LLM (10 ostatnich)",
      analytics_limit_exceeded: "⚠️ Wyczerpano limit kredytów! Usługi AI (Czat i Voice) zostały zablokowane.",
      analytics_limit_total: "Limit całkowity: ",
      analytics_credits_used: "Zużyte kredyty: ",
      analytics_credits_available: "Dostępne kredyty: ",
      analytics_credits_available_pct: "Dostępne",
      analytics_credits_progress: "Wykorzystanie Kredytów AI (Progress Bar)",
      analytics_voice_minutes_rate: "Przeliczona stawka minutowa sesji telefonów",
      analytics_voice_minutes: "Zużycie Minut Voice AI",
      openai_api_key_voice: "Klucz API OpenAI (Realtime Voice)",
      tab_calls: "Połączenia",
      calls_title: "Ustawienia asystenta głosowego",
      twilio_phone_number: "Numer telefonu (Twilio)",
      save_calls_settings: "Zapisz ustawienia głosowe",
      add_product: "Dodaj Produkt / Usługę",
      new_product_def: "Definicja nowego produktu / usługi",
      product_name: "Nazwa Produktu / Usługi",
      price: "Cena",
      currency: "Waluta",
      hidden_ai_only: "Ukryte na profilu publicznym (tylko dla AI)",
      ai_knowledge_desc: "Opis (Czego AI ma się nauczyć o tym produkcie?)",
      save_product: "Zapisz Produkt / Usługę",
      update_product: "Zapisz zmiany",
      confirm_delete: "Czy na pewno chcesz usunąć ten produkt?",
      delete: "Usuń",
      no_products_yet: "Brak produktów lub usług. Dodaj swój pierwszy produkt.",
      "logout": "Wyloguj się",
      "bg_color_tab": "Kolor tła", "ai_image_tab": "AI Obraz", "bg_color_label": "Wybierz kolor nagłówka", "bg_color_placeholder": "np. #4f46e5", "ai_image_title": "Generuj nagłówek AI (ComfyUI)", "ai_image_desc": "Wygeneruj tło nagłówka wpisując własny opis. Obraz zostanie automatycznie przypisany do Twojej wizytówki.", "ai_image_prompt_placeholder": "np. Nowoczesne biuro, panorama miasta, jasne kolory", "ai_image_btn": "Generuj obraz", "ai_image_email_req": "Proszę najpierw podać e-mail w formularzu rejestracyjnym.", "ai_image_timeout": "Czas oczekiwania na generację obrazu upłynął.",
      "btn_activate_subscription": "Aktywuj ten pakiet",
      "btn_active_current": "Aktualny Pakiet",
      "error_accept_terms": "Musisz zaakceptować regulamin, aby kontynuować.",
      "trial_expired_title": "🛑 Wymagana płatność",
      "trial_expired_desc": "Aby dalej korzystać ze swojej wizytówki AI i modułów biznesowych, wybierz jeden z poniższych pakietów subskrypcji i odblokuj dostęp.",
      "plan_upgrade_success_basic": "Gratulacje! Pakiet został aktywowany: Wizytówka AI + Chatbot (100 PLN + 23% VAT / 123 PLN brutto)",
      "plan_upgrade_success_pro": "Gratulacje! Pakiet został aktywowany: Biznes PRO (2000 PLN netto / 2460 PLN brutto)",
      "plan_basic_title": "🥉 Pakiet Wizytówka AI + Chatbot",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN brutto) / mies.",
      "plan_basic_desc": "Idealny pakiet startowy. W cenie zyskujesz pełne zarządzenie swoją wizytówką AI oraz trenowanie inteligentnego chatbota:",
      "plan_basic_f1": "✅ Wizytówka AI (Company Public Profile)",
      "plan_basic_f2": "✅ Trenowanie Chatbota AI i opisy usług",
      "plan_basic_f3": "✅ Ogłoszenia o pracę i wydarzenia firmowe",
      "plan_basic_f4": "🔒 Kampanie Ads, CRM, Poczta i Google Maps są wyłączone",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Zacznij zarabiać już teraz sprzedając swoje skille do AI",
      "hero_title_discover": "Odkryj & Sprzedawaj",
      "hero_title_skills": "Skille AI",
      "marketplace_search_placeholder": "Czego szukasz? Zapytaj AI...",
      "marketplace_popular_skills": "Popularne Skille",
      "marketplace_new_prompts": "Nowości AI Prompts",
      "plan_pro_f1": "✅ Wszystko co w pakiecie podstawowym",
      "plan_pro_f2": "⚡ Własny CRM z inteligentnymi katalogami i mailami",
      "plan_pro_f3": "⚡ Generatory reklam Google Ads i Facebook Meta Ads",
      "plan_pro_f4": "⚡ Google Maps & Auto-Discovery pozyskiwania B2B",
      "plan_pro_f5": "⚡ Generator postów na Social Media i Newslettery",
      "ai_requests_stat_title": "Zużycie AI (Agentic AI)",
      "ai_requests_today": "Dzisiaj:",
      "ai_requests_btn": "Ustawienia AI",
      ai_greeting: "Cześć! Jestem Twoim Asystentem AI. Zapytaj o produkty i usługi, albo pozwól mi założyć dla Ciebie profesjonalną stronę internetową z Chatbotem AI! Kontynuowanie rozmowy oznacza automatyczne wyrażenie zgody na przetwarzanie i zapisywanie wszelkich przekazanych tutaj danych.",
      search_results_title: "Wyniki wyszukiwania na mapie dla",
      all_companies_list_title: "Katalog Zweryfikowanych Firm i Mapa Interaktywna AILinkB",
      landing_ai_title_simple: "Jak możemy Ci dzisiaj pomóc? (Global Search)",
      landing_ai_subtitle_simple: "Szukasz firmy, usługi lub produktu? Zapytaj mnie głosowo lub tekstowo, a przeszukam całą bazę AILinkB.",
      landing_ai_placeholder_simple: "Mów lub wpisz, czego szukasz...",
      "btn_upgrade_to_pro": "⚡ Awansuj na Pakiet PRO (2000 PLN)",
      "admin_full_access": "👑 Pakiet Administratora (Pełen dostęp)",

      "folder_inbox": "📥 Odebrane (Inbox)",
      "folder_sent": "📤 Wysłane",
      "folder_starred": "⭐ Ważne",
      "folder_spam": "🛑 Spam / Oferty",
      "folder_trash": "🗑️ Kosz",
      "folder_all": "📁 Wszystkie maile",
      "custom_folders_title": "🗂️ Moje Katalogi (Słowa kluczowe)",
      "add_custom_folder": "Dodaj katalog",
      "modal_add_folder_title": "Dodaj własny katalog inteligentny",
      "folder_name_label": "Nazwa katalogu",
      "folder_name_placeholder": "np. Faktury i Księgowość",
      "folder_keywords_label": "Słowa kluczowe (po przecinku)",
      "folder_keywords_placeholder": "np. faktura, vat, płatność, rachunek",
      "folder_color_label": "Kolor znacznika",
      "btn_save_folder": "Zapisz katalog",
      "btn_delete_folder": "Usuń katalog",
      "empty_trash_btn": "Opróżnij kosz",
      "empty_trash_confirm": "Czy na pewno chcesz trwale usunąć wiadomości z Kosza?",
      "folder_delete_confirm": "Czy na pewno chcesz usunąć ten katalog?",
      "filtered_by_keywords": "Filtrowanie po słowach kluczowych:",

      ai_crm_manager_title: "Asystent AI - Zarządzanie CRM i Treścią (Agentic AI + MCP)",
      ai_crm_manager_desc: "Wydawaj polecenia głosem (Whisper STT) lub tekstem. Lokalne Agentic AI zrealizuje operacje na Twoim CRM przez serwer MCP.",
      ai_prompt_placeholder: "Naciśnij mikrofon lub wpisz polecenie, np: 'Stwórz stronę dla mojafirma@domena.pl'...",
      ai_btn_execute: "Wykonaj z Ollamą (MCP)",
      ai_voice_listening: "Nasłuchiwanie głosu (Whisper STT)... Mów do mikrofonu.",
      ai_voice_speak_resp: "Odsłuchaj odpowiedź AI (Lokalne XTTS)",
      landing_ai_title: "Stwórz swoją wizytówkę AI głosem lub tekstem w 10 sekund!",
      landing_ai_desc: "Opowiedz nam o swojej firmie do mikrofonu lub wpisz polecenie, a lokalne AI natychmiast wygeneruje dla Ciebie podgląd przez MCP.",
      landing_ai_placeholder: "Mów lub wpisz np: 'Chcę założyć stronę dla mojej firmy na email kontakt@nowy-klient.pl'...",
      landing_btn_build: "Wygeneruj Wizytówkę AI",
      ai_tts_generating: "Generowanie lokalnego głosu XTTS...",
      ai_tts_played: "Odtworzono mowę (Lokalny model XTTS w Dockerze).",
      ai_pin_required: "Wprowadź swój PIN właściciela do weryfikacji operacji CRM:",

      dashboard_welcome_title: "Centrum Dowodzenia AILinkB CRM & AI",
      dashboard_welcome_desc: "Przeglądaj statystyki na żywo i szybko przejdź do najważniejszych modułów swojego biznesu.",
      dashboard_quick_actions: "Szybkie Akcje i Narzędzia",
      company_public_profile_title: "Company Public Profile (Wizytówka Twojej Firmy)",
      company_public_profile_desc: "Udostępniaj klientom dedykowaną stronę ze swoją ofertą, usługami, kalendarzem oraz inteligentnym czatem AI.",
      btn_view_public_profile: "Otwórz Twój Profil",
      btn_edit_public_profile: "Edytuj Wizytówkę",
      btn_copy_link: "Kopiuj Link",
      tab_public_profile: "Company Public Profile",
      tab_crm_database: "Baza Twoich Klientów (CRM)",
      tab_public_discovery: "Wyszukiwarka Firm (Public Map & AI)",
      leads_stat_total: "Wszyscy Klienci",
      leads_stat_scanned: "Przeskaniowane (Lokalnie)",
      leads_stat_enriched: "Wzbogacone przez AI",
      leads_stat_email: "Gotowe z E-mail",
      leads_search_placeholder: "Szukaj w bazie klientów (nazwa, NIP, e-mail)...",

      tab_mcp: "Serwer MCP (AI)",
      mcp_title: "Serwer MCP & Integracja AI",
      mcp_subtitle: "Połącz zewnętrzne modele AI (Claude Desktop, Cursor, własnego agenta) bezpośrednio ze swoim CRM i generatorem stron AILinkB.",
      mcp_endpoint_label: "Adres punktu końcowego serwera MCP (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Uwierzytelnianie (Login i PIN)",
      mcp_auth_desc: "Dostęp do serwera MCP wymaga podania Twojego adresu e-mail jako loginu oraz Twojego 6-cyfrowego kodu PIN bezpieczeństwa.",
      mcp_login_label: "Twój Login (E-mail)",
      mcp_pin_label: "Twój PIN Bezpieczeństwa",
      mcp_pin_placeholder: "Wpisz 6-cyfrowy PIN, aby testować...",
      mcp_tools_title: "Dostępne narzędzia MCP i API",
      mcp_tools_desc: "Poniższe funkcje mogą być wywoływane przez agenty AI w celu automatyzacji zakładania stron, obsługi leadów, wysyłania wiadomości i kalendarza.",
      mcp_test_btn: "Przetestuj funkcję w Sandboxie",
      mcp_test_result: "Wynik wywołania funkcji:",
      mcp_doc_title: "Jak połączyć modele AI przez MCP?",
      mcp_doc_website: "Zakładanie strony i walidacja e-mail w MCP",
      mcp_doc_website_desc: "Za pomocą narzędzia 'website_setup' sztuczna inteligencja może utworzyć wizytówkę firmy. Jeśli e-mail już istnieje w bazie i strona jest zainicjowana, MCP zwróci błąd walidacji, zapobiegając omyłkowemu skasowaniu danych na tym samym mailu. Aby wygenerować aktywny link do podglądu (https://www.ailinkb.com/?profile=...), należy wywołać 'website_get_preview', podając e-mail.",

      sync_in_background_title: "Synchronizacja w tle",
      sync_in_progress: "Synchronizacja maili w toku...",
      sync_completed_refreshing: "Zakończono. Odświeżam listę...",
      no_messages_found: "Brak wiadomości.",
      welcome_back: "Witaj ponownie",
      login_to_dashboard: "Zaloguj się do panelu",
      email_address: "Adres Email",
      security_pin: "Bezpieczny PIN (6 cyfr)",
      forgot_pin: "Nie pamiętasz PINu?",
      login_with_pin: "Zaloguj się",
      or: "ALBO",
      need_account: "Nie masz konta? Rozpocznij konfigurację",
      back_to_home: "← Powrót do strony głównej",
      cancel_edit: "← Anuluj edycję",
      save_profile: "Zapisz profil",
      save_profile_activate: "Zapisz profil i aktywuj AI",
      sign_in: "Zaloguj się",
      "no_services_listed": "Ta firma nie dodała jeszcze konkretnych usług.", "view_details": "Zobacz szczegóły", "scan_mobile": "Zeskanuj, aby otworzyć na smartfonie:", "map_location": "Mapa i Lokalizacja", "map_not_provided": "Współrzędne mapy nie zostały podane.", "partner_program": "Partner AILinkB - Polecaj i zarabiaj!", "affiliate_code": "Kod partnerski:", "create_free_account": "Zamów konto", "tab_needs": "Potrzeby", "tab_job_offers": "Oferty Pracy",       "tab_services": "Nasze Produkty i Usługi",
      "setting_up_ai": "Konfiguracja Twojego asystenta AI...",
      "onboard_success_title": "Twój Asystent AI jest gotowy!",
      "onboard_success_desc": "Wysłaliśmy Twój PIN dostępu na",
      "onboard_success_check_inbox": "Sprawdź swoją skrzynkę odbiorczą!",
      "onboard_success_instructions": "Otrzymasz instrukcje instalacji i kod widżetu na swój e-mail po aktywacji subskrypcji. Możesz również uzyskać do niego dostęp w panelu.",
      "onboard_success_btn_login": "Przejdź do logowania i Panelu",
      "onboard_live_test": "Test na żywo",
      "admin_system_settings_title": "Globalne ustawienia systemu (Tylko Admin)",
      "admin_save_all_settings": "Zapisz wszystkie ustawienia",
      "settings_saved": "Ustawienia zostały zapisane!",
      "admin_smtp_warning_text": "Nie możesz wysyłać kampanii e-mail, dopóki nie skonfigurujesz SMTP w ustawieniach.",
      "admin_go_to_settings": "Przejdź do ustawień teraz",
      "instagram_business_account_id": "ID Konta Biznesowego Instagram",
      "bg_color_tab": "Kolor tła", "ai_image_tab": "AI Obraz", "bg_color_label": "Wybierz kolor nagłówka", "bg_color_placeholder": "np. #4f46e5", "ai_image_title": "Generuj nagłówek AI", "ai_image_desc": "Wygeneruj tło nagłówka wpisując własny opis. Obraz zostanie automatycznie przypisany do Twojej wizytówki.", "ai_image_prompt_placeholder": "np. Nowoczesne biuro, panorama miasta, jasne kolory", "ai_image_btn": "Generuj obraz", "ai_image_email_req": "Proszę najpierw podać e-mail w formularzu rejestracyjnym.", "ai_image_timeout": "Czas oczekiwania na generację obrazu upłynął.",
      "mark_as_read": "Oznacz jako przeczytane",
      "conversations": "rozmów",
      "live_editor_title": "Kreator na żywo: Stwórz profil swojej firmy",
      "preview_btn_top": "👁️ Podgląd (Nowe okno)",
      "preview_btn_bottom": "👁️ Podgląd strony w czasie rzeczywistym (Nowe okno)",
      "preview_banner_title": "PODGLĄD STRONY W CZASIE RZECZYWISTYM",
      "preview_banner_desc": "Tak będzie wyglądać Twoja gotowa strona internetowa na AILinkB po zapisaniu formularza.",
      "preview_banner_close": "✖ Zamknij podgląd",
      "our_services": "Nasze Usługi",
      "about_us": "O nas",
      "about_us_placeholder": "Wprowadź informacje, z których będzie korzystać AI, np.:\n• Godziny pracy i zasady\n• Cennik i zniżki\n• Atuty Twojej firmy\n• FAQ (najczęściej zadawane pytania)\n• Instrukcje dla AI (np. 'Zwracaj się do klienta na Ty')",
      "live_ai_chat": "Podgląd czatu AI na żywo",
      "service_name": "Nazwa Usługi",
      "brief_desc": "Krótki opis...",
      "add_service": "+ Dodaj Usługę",
      "install_widget": "Jak zainstalować widget na swojej stronie?",
      "profile_link": "Twój dedykowany link do profilu",
      "copy": "Kopiuj",
      "ai_learn_note": "Uwaga: AI nauczy się Twoich danych dopiero po kliknięciu Zapisz profil.",
      "chat_consent_label": "Akceptuję ",
      "privacy_policy_link": "Politykę Prywatności",
      "privacy_policy_title": "Polityka Prywatności",
      "privacy_policy_content": "Polityka prywatności\nPrzegląd\nNiniejsza Polityka prywatności została stworzona w celu wyjaśnienia zasad przetwarzania danych osobowych pozyskanych za pośrednictwem strony internetowej https://ailinkb.com/ (zwanej dalej: Serwisem). Wskazujemy, że dokładamy należytej staranności, aby Państwa dane osobowe były przetwarzane zgodnie z wymogami obowiązującego prawa, w tym w szczególności zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (dalej: RODO).\n\nZarządzanie danymi\nPrzetwarzanie danych osobowych opiera się na zgodności z prawem, rzetelności i przejrzystości informacji. Dane zbierane są przez Administratora Danych Osobowych w konkretnym, wyraźnym i prawnie usprawiedliwionym celu, a zakres danych ograniczony jest do danych niezbędnych do realizacji tego celu. Administrator Danych Osobowych dokłada niezbędnych starań, aby zapewnić jak największe bezpieczeństwo i ochronę przetwarzanych przez niego danych osobowych. Podanie danych jest dobrowolne. Każdy z Państwa ma prawo do wglądu i sprawdzenia swoich danych osobowych, ich aktualizacji oraz wniesienia żądania usunięcia danych.\nDane osobowe zostały zebrane przez nas bezpośrednio od Państwa lub od podmiotów współpracujących z nami – dysponentów baz mailingowych (Growbots Sp. z o.o., nr KRS: 0000504714) w celu wykonania zawartej z Państwem umowy lub – w przypadku plików Cookies - na podstawie Państwa zgody.\nAdministrator danych osobowych\nAdministratorem Danych Osobowych jest: QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B Kapitał zakładowy 10 000 PLN (zwana dalej: ailinkb lub Administratorem).\nZ poszanowaniem Państwa praw jako podmiotów danych osobowych (tj. osób, których dane dotyczą) oraz z poszanowaniem bezwzględnie obowiązujących przepisów prawa, w tym w szczególności RODO, polskiej ustawy o ochronie danych osobowych (dalej: Ustawa) oraz innych właściwych przepisów o ochronie danych osobowych, zobowiązujemy się do zachowania bezpieczeństwa i poufności wszystkich danych osobowych, które nam Państwo udostępniacie. Wszyscy nasi pracownicy zostali odpowiednio przeszkoleni w zakresie ochrony danych osobowych, a ailinkb, jako Administrator Danych Osobowych, wprowadził nowe środki bezpieczeństwa oraz środki techniczne i organizacyjne, aby zapewnić jak najwyższy poziom ochrony danych osobowych. Wprowadziliśmy odpowiednie procedury i polityki przetwarzania danych osobowych zgodnie z RODO, tak aby przetwarzanie danych osobowych odbywało się zgodnie z prawem i rzetelnie, a Państwo jako osoby, których dane dotyczą, mogli realizować wszystkie swoje odpowiednie uprawnienia. Dodatkowo, w razie potrzeby, współpracujemy z organem regulacyjnym na terenie Rzeczypospolitej Polskiej, tj. Prezesem Urzędu Ochrony Danych Osobowych (dalej: PUODO).\nWszelkie pytania, wnioski lub skargi związane z przetwarzaniem danych osobowych w ailinkb (Administrator Danych Osobowych) należy kierować drogą elektroniczną na adres e-mail: support@ailinkb.com, lub pisemnie na adres pocztowy Administratora Danych Osobowych, tj. QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B.\nWnioski powinny zawierać w sposób jednoznaczny:\ndane osoby lub osób, których dotyczy wniosek,\nzdarzenie, którego dotyczy wniosek,\nzgłaszane żądania,\npożądany sposób załatwienia sprawy.\nRodzaj przetwarzanych danych osobowych i cele przetwarzania danych osobowych\nNasz Serwis gromadzi następujące dane osobowe:\na) adres e-mail - zbieramy Państwa adres e-mail w celu utworzenia dla Państwa konta w Serwisie,\n\nb) imię, nazwisko, adres zamieszkania i NIP - zbieramy je od klientów zwracających się do nas z prośbą o wystawienie faktury,\n\nc) numer karty kredytowej, kod CVC i datę ważności karty - informacje te są niezbędne do dokonania płatności za nasze usługi,\n\nd) w przypadku przedsiębiorców powyższy zakres danych może zostać rozszerzony o: firmę, inne numery identyfikacyjne przedsiębiorcy (w tym REGON), adres wykonywania działalności gospodarczej.\n\ne) w związku z korzystaniem z Serwisu mogą być przetwarzane dodatkowe dane, w szczególności: adres IP, nazwa domeny, typ przeglądarki, czas dostępu czy rodzaj systemu operacyjnego, a także dane nawigacyjne, w tym informacje o linkach i odnośnikach, w które zdecydują się Państwo kliknąć oraz innych działaniach podejmowanych przez Państwa w naszym Serwisie,\n\nW związku z korzystaniem z Serwisu, Państwa dane osobowe mogą być zbierane poprzez:\n\nwysłanie zapytania za pomocą formularza kontaktowego,\n\nkomunikację za pomocą wiadomości e-mail, a także komunikatorów typu Messenger (Intercom),\n\nPodanie danych określonych w ust. 1 lit. a – d jest dobrowolne i jest wyłącznie wymogiem umownym. Podanie tych danych jest jednak niezbędne w celu założenia konta w Serwisie i korzystania z jego płatnej wersji, a przez to realizacji umowy dotyczącej pozycjonowania lokalnego wizytówki (dalej: Umowa). Podanie danych określonych w ust. 1 lit. e następuje na podstawie Państwa zgody.\n\nPaństwa dane osobowe przetwarzane są w następujących celach: prawidłowej realizacji Umowy lub podjęcia działań na Państwa żądanie przed zawarciem Umowy, w szczególności odpowiedzi na zadane pytania, np. poprzez formularz kontaktowy (art. 6 ust. 1 lit. b RODO); wypełnienia obowiązku prawnego ciążącego na Administratorze (art. 6 ust. 1 lit. c RODO); ewentualnego ustalenia, dochodzenia lub obrony przed roszczeniami, jako prawnie uzasadniony interes Administratora (art. 6 ust. 1 lit. f RODO); prawidłowego korzystania z usługi formularza kontaktowego/logowania zamieszczonego w Serwisie w celu wykonania Umowy (art. 6 ust. 1 lit. b RODO - konieczność wykonania umowy o świadczenie usługi formularza kontaktowego); zapisania się i otrzymywania informacji o usługach i ich funkcjonalnościach dostępnych w Serwisie w celu wykonania Umowy, której przedmiotem jest usługa elektroniczna. Administrator może również zbierać od użytkowników Serwisu dane nawigacyjne, w tym informacje o linkach i odnośnikach, w które decydują się kliknąć lub o innych czynnościach podejmowanych w Serwisie, służące do ułatwienia korzystania z usług świadczonych drogą elektroniczną oraz na poprawie funkcjonalności tych usług, co stanowi prawnie uzasadniony interes Administratora (art. 6 ust.1 lit. f RODO),\nŹródłem danych osobowych przetwarzanych przez Administratora Danych Osobowych są osoby, których dane dotyczą.\nPodczas wypełniania formularza logowania w Serwisie Użytkownik podaje: adres e-mail i poufne hasło tylko do wiadomości Użytkownika.\nNie dochodzi do zautomatyzowanego podejmowania decyzji w następstwie przetwarzania danych osobowych, w tym w następstwie profilowania tych danych.\nPliki cookie i profilowanie\nSerwis wykorzystuje technologię Cookies, aby dopasować jego funkcjonalność do Państwa indywidualnych potrzeb. Użytkownik może zatem wyrazić zgodę na zapisanie wprowadzonych przez siebie danych i informacji, aby mogły być one później wykorzystywane przy kolejnych wizytach na stronie bez konieczności ponownego ich wprowadzania. Właściciele innych stron internetowych nie będą mieli dostępu do tych danych i informacji. Jeżeli jednak nie wyrażają Państwo zgody na personalizację witryny Serwisu, mogą Państwo wyłączyć obsługę Cookies w swoich przeglądarkach internetowych.\nKażda osoba korzystająca z Serwisu może zdecydować, czy i w jaki sposób chce korzystać z naszych usług i udostępniać swoje dane i informacje w określonym zakresie, zgodnie z niniejszą Polityką Prywatności.\nOkres przetwarzania danych osobowych\nPaństwa dane będą przetwarzane przez okres niezbędny do wykonania Umowy oraz mogą być przetwarzane przez okres niezbędny do realizacji prawnie uzasadnionych interesów Administratora (tj. do czasu przedawnienia wszelkich roszczeń z tytułu wykonania Umowy),\nW sytuacji, gdy podstawą przetwarzania Państwa danych osobowych jest zgoda, wówczas dane te są przetwarzane przez Administratora do czasu odwołania zgody.\nOdbiorcy danych\nPaństwa dane osobowe mogą być przekazywane podmiotom współpracującym z ailinkb, w szczególności podmiotom świadczącym usługi i wsparcie informatyczne oraz obsługującym nas firmom księgowym i informatycznym, a także wszystkim instytucjom mającym prawo przetwarzania danych osobowych na podstawie przepisów publicznoprawnych, w szczególności Urzędom Skarbowym oraz w razie potrzeby podmiotom świadczącym usługi archiwizacyjne. W uzasadnionych przypadkach Państwa dane mogą zostać wysłane poza obszar UE. W takim przypadku ailinkb każdorazowo zapewni poufność przekazanych danych oraz to, że przekazywane są tylko te dane, które są niezbędne do prawidłowego wykonania Umowy i oparte na odpowiednich zabezpieczeniach danych osobowych wymaganych przez obowiązujące przepisy prawa.\n\nAdministrator przekazuje dane osobowe do państw trzecich, poza Europejski Obszar Gospodarczy, wyłącznie do następujących podmiotów, z uwagi na międzynarodowy charakter tych podmiotów i posiadanie przez nie części infrastruktury teleinformatycznej poza granicami EOG:\n\na) w odniesieniu do Użytkowników Serwisu https://ailinkb.com/pl/ z terytorium Stanów Zjednoczonych - spółka pod firmą: Paddle.com Inc, posiadająca adres: 3811 Ditmars Blvd #1071 Astoria NY 11105-1803 – podmiot, który odpowiada za prowadzenie rozliczeń i przesyłanie dokumentów finansowych (faktur) do użytkowników serwisu https://ailinkb.com/pl/. Paddel.com Inc deklaruje zgodność transferu danych z wymaganiami RODO, m. in. poprzez zastosowanie standardowych klauzul umownych. Informacje na temat przetwarzania danych osobowych można znaleźć także na stronie https://www.paddle.com/legal/data-sharing-addendum\n\nb) w odniesieniu do Użytkowników Serwisu https://ailinkb.com/pl/ z terytorium pozostałych państw – spółka pod firmą: Paddle.com Market Limited (numer rejestrowy 08172165), posiadająca adres: 15 Briery Close, Great Oakley, Corby, Northamptonshire NN18 8JG, Zjednoczone Królestwo Wielkiej Brytanii i Irlandii Północnej - podmiot, który odpowiada za prowadzenie rozliczeń i przesyłanie dokumentów finansowych (faktur) do Użytkowników Serwisu https://ailinkb.com/pl/. Na podstawie decyzji Komisji Europejskiej z dnia 28 czerwca 2021 r. zostało potwierdzone, że transfer danych do Zjednoczonego Królestwa Wielkiej Brytanii i Irlandii Północnej zapewnia odpowiedni poziom ochrony danych osobowych (pierwsza decyzja o sygn. C(2021) 4800 final, została wydana na podstawie rozporządzenia (UE) 2016/679 (RODO) oraz druga o sygn. C(2021) 4801 final, wydano na podstawie dyrektywy (UE) 2016/680.\n\nUznanie przez Komisję Europejską określonego państwa trzeciego, w tym wypadku Wielkiej Brytanii, za zapewniające odpowiedni poziom ochrony danych osobowych umożliwia swobodne przekazywanie takich danych z Europejskiego Obszaru Gospodarczego bez konieczności uzyskiwania dodatkowych zezwoleń lub wdrożenia dodatkowych zabezpieczeń przewidzianych w rozdziale V RODO, które są wymagane, jeżeli państwo trzecie takiej ochrony nie zapewnia. Informacje na temat przetwarzania danych osobowych można znaleźć także na stronie https://www.paddle.com/legal/data-sharing-addendum\n\nDane osobowe mogą być udostępniane podmiotom, które przetwarzają te dane na nasze zlecenie, tj. na zlecenie Administratora Danych Osobowych. W takich przypadkach, jako Administrator Danych Osobowych, zawieramy z takim podmiotem umowę o przetwarzanie danych osobowych. Podmiot przetwarzający przetwarza udostępnione dane osobowe wyłącznie w celach określonych w ww. umowie. Bez udostępnienia danych osobowych takim podmiotom nie bylibyśmy w stanie prowadzić działalności gospodarczej w naszym Serwisie. Jako Administrator Danych Osobowych udostępniamy dane osobowe do przetwarzania podmiotom:\n\nświadczącym usługi hostingowe dla Serwisu,\nświadczącym inne usługi na naszą rzecz, które są niezbędne do prawidłowego funkcjonowania Serwisu.\nZgodnie z RODO, każda osoba, której dane osobowe są przetwarzane przez administratora danych osobowych, ma prawo żądać od administratora:\npoinformowania o przetwarzaniu jej danych osobowych, zgodnie z art. 12 RODO - Administrator jest zobowiązany do udostępnienia informacji określonych w RODO (m.in. dotyczących samych danych, danych kontaktowych, celów i podstaw prawnych przetwarzania danych osobowych, odbiorców danych osobowych lub kategorii odbiorców, jeśli takie istnieją, lub okresu, przez który dane będą przetwarzane lub kryteriów, na podstawie których taki okres jest ustalany) z osobą, której dane dotyczą; obowiązek ten powinien być wykonany niezwłocznie z chwilą uzyskania danych po raz pierwszy, a jeżeli dane nie zostały uzyskane od osoby, której dotyczą, lecz z innego źródła, wówczas powinien być wykonany w rozsądnym terminie w zależności od okoliczności; Administrator może zrezygnować z udzielenia tej informacji osobie, której dane dotyczą, jeżeli osoba ta została już o tym poinformowana,\ndostępu do swoich danych osobowych, zgodnie z art. 15 RODO - przekazując nam swoje dane osobowe, mają Państwo prawo dostępu do nich i wglądu w nie; nie oznacza to jednak, że mają Państwo dostęp do wszystkich dokumentów, które zawierają Państwa dane, ponieważ dokumenty te mogą zawierać informacje poufne; mają Państwo prawo do informacji, które z Państwa danych są przetwarzane i w jaki sposób, a także prawo do otrzymania kopii swoich danych osobowych, przy czym pierwsza kopia jest wydawana bezpłatnie, a za każdą następną, zgodnie z RODO, możemy pobrać odpowiednią opłatę administracyjną związaną z wykonaniem kopii,\nsprostowania danych osobowych, zgodnie z art. 16 RODO - jeżeli Państwa dane osobowe uległy zmianie, prosimy o poinformowanie nas, jako Administratora, o tym fakcie, aby przechowywane przez nas dane osobowe odpowiadały rzeczywistym informacjom i były aktualne; również w sytuacjach, gdy dane osobowe nie uległy zmianie, ale z jakiegoś powodu przechowywane przez nas dane są nieprawidłowe lub zostały błędnie zapisane (np. w wyniku błędu redakcyjnego), prosimy o poinformowanie nas o tym, abyśmy mogli skorygować odpowiednie punkty danych,\nusunięcia danych (prawo do bycia zapomnianym), zgodnie z art. 17 RODO - innymi słowy, macie Państwo prawo żądać od nas, jako Administratora, usunięcia danych będących w naszym posiadaniu oraz prawo żądać, abyśmy, jako Administrator, poinformowali innych administratorów, którym udostępniliśmy Państwa dane, o Państwa żądaniu ich usunięcia. Możecie Państwo żądać usunięcia swoich danych osobowych przede wszystkim wtedy, gdy:\n\ncele, dla których dane osobowe zostały udostępnione, zostały zrealizowane, np. w pełni wykonaliśmy zawartą przez nas Umowę,\n\npodstawą przetwarzania Państwa danych osobowych była wyraźna zgoda, która została następnie wycofana i nie ma innej podstawy prawnej do dalszego przetwarzania przez nas Państwa danych osobowych,\nzłożyliście sprzeciw wobec przetwarzania przez nas Państwa danych osobowych, zgodnie z art. 21 RODO i uważacie Państwo, że nie mamy innej podstawy prawnej pozwalającej nam na dalsze przetwarzanie Państwa danych osobowych,\nPaństwa dane osobowe były przetwarzane niezgodnie z prawem, tj. w celach niezgodnych z przepisami prawa lub bez podstawy prawnej do ich przetwarzania (proszę pamiętać, że w takich przypadkach konieczne będzie podanie podstawy takiego żądania),\nkonieczność usunięcia Państwa danych osobowych wynika z bezwzględnie obowiązujących przepisów prawa,\ndane osobowe dotyczą osoby małoletniej i zostały zebrane w ramach usługi społeczeństwa informacyjnego,\n\nOgraniczenia przetwarzania, zgodnie z art. 18 RODO - możecie Państwo zażądać od nas, abyśmy ograniczyli zakres przetwarzania Państwa danych osobowych (co oznacza, że do czasu wyjaśnienia sprawy ograniczylibyśmy się jedynie do przechowywania danych), jeśli:\n\nkwestionują Państwo prawidłowość swoich danych osobowych,\n\nuważają Państwo, że przetwarzamy Państwa dane osobowe bez podstawy prawnej, ale jednocześnie nie chcą Państwo, abyśmy usunęli dane osobowe (tj. nie realizują Państwo ww. uprawnienia),\nzłożyli Państwo sprzeciw,\nPonadto, zgodnie z RODO, każda osoba, której dane osobowe są przetwarzane przez administratora danych osobowych, ma prawo do:\n\nprzeniesienia danych, zgodnie z art. 20 RODO - macie Państwo prawo do otrzymania swoich danych w formacie umożliwiającym ich przeglądanie na komputerze oraz prawo do przenoszenia danych w takim formacie do innego administratora; prawo to przysługuje Państwu tylko wtedy, gdy podstawą przetwarzania Państwa danych osobowych była wyraźna zgoda lub dane były przetwarzane automatycznie,\nwniesienia sprzeciwu wobec przetwarzania danych osobowych zgodnie z art. 21 RODO - macie Państwo prawo do złożenia sprzeciwu, jeśli nie zgadzacie się na przetwarzanie przez nas Państwa danych osobowych, które dotychczas przetwarzaliśmy w określonych celach, zgodnie z bezwzględnie obowiązującymi przepisami prawa,\nsprzeciwu wobec profilowania danych, zgodnie z art. 22 (w rozumieniu do art. 4 ust. 4 RODO) - na naszej stronie internetowej nie będą Państwo poddawani zautomatyzowanemu podejmowaniu decyzji lub profilowaniu, zgodnie z RODO, chyba że udzielą nam Państwo na to wyraźnej zgody; ponadto będą Państwo zawsze informowani o wszelkich przypadkach profilowania, jeśli takie wystąpią,\nzłożenia skargi do organu regulacyjnego (tj. do Prezesa Urzędu Ochrony Danych Osobowych), zgodnie z art. 77 RODO - jeżeli uważacie Państwo, że przetwarzamy Państwa dane osobowe niezgodnie z prawem lub w sposób naruszający Państwa prawa wynikające z bezwzględnie obowiązujących przepisów prawa o ochronie danych osobowych lub do organu nadzorczego innego państwa członkowskiego Unii Europejskiej właściwego ze względu na miejsce zwykłego pobytu lub wykonywania pracy lub do miejsca domniemanego naruszenia.\nW przypadku wystąpienia przez Użytkownika Serwisu z uprawnieniem wynikającym z powyższych praw, Administrator spełni żądanie albo odmówi jego spełnienia niezwłocznie, nie później jednak niż w ciągu miesiąca od jego otrzymania. Może się jednak zdarzyć, że ze względu na skomplikowany charakter żądania lub liczbę żądań Administrator nie będzie mógł spełnić żądania w ciągu miesiąca, o którym mowa w zdaniu poprzednim, wówczas spełni je w ciągu kolejnych dwóch miesięcy informując jednocześnie użytkownika o zamierzonym przedłużeniu terminu oraz jego przyczynach.\n\nW każdym czasie użytkownik Serwisu może zgłaszać Administratorowi wszelkie skargi, zapytania i wnioski dotyczące przetwarzania jego danych osobowych oraz wykonywania przysługujących mu praw.\n\nZgoda i informacja o możliwości wycofania zgody\nW przypadku, gdy podstawą prawną przetwarzania Państwa danych osobowych jest Państwa zgoda, macie Państwo prawo do cofnięcia zgody na przetwarzanie danych osobowych w dowolnym momencie, przy czym cofnięcie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody wyrażonej przed jej cofnięciem.\n\nPostanowienia końcowe\nW przypadku chęci skorzystania z któregokolwiek z wyżej wymienionych praw, prosimy o zapoznanie się z odpowiednimi zakładkami w naszym Serwisie, które umożliwiają usunięcie konta i danych gromadzonych przez nasz Serwis lub prosimy o wysłanie wiadomości e-mail na adres: support@ailinkb.com\nKażdy stwierdzony przypadek naruszenia bezpieczeństwa jest dokumentowany, a w przypadku wystąpienia któregokolwiek ze zdarzeń opisanych w RODO lub Ustawie, osoby, których dane dotyczą, a także PUODO, jeśli ma to zastosowanie, są o tym informowane.\nWszelkie kwestie nieuregulowane w niniejszej Polityce Prywatności będą regulowane przez odpowiednie bezwzględnie obowiązujące przepisy prawa. Jeżeli którekolwiek z postanowień niniejszej Polityki Prywatności nie jest zgodne z wyżej wymienionymi przepisami prawa, pierwszeństwo mają przepisy prawa.\nKorzystając z serwisu https://ailinkb.com/ akceptujecie Państwo niniejsze warunki polityki prywatności. Informujemy, że ustawienia dotyczące Cookies mogą być w każdej chwili zmienione za pomocą ustawień przeglądarki internetowej.\nPolityka Prywatności może ulec zmianie, o czym Administrator Danych poinformuje z 7-dniowym wyprzedzeniem.\nPytania dotyczące Polityki Prywatności należy kierować na adres: support@ailinkb.com.\n\n\nNiedozwolone korzystanie z Serwisu:\nZabrania się korzystania z Serwisu do jakichkolwiek celów niezgodnych z prawem, w tym do prowadzenia działalności przestępczej, oszustw lub innych działań naruszających przepisy powszechnie obowiązującego prawa. W przypadku stwierdzenia, że konto jest wykorzystywane do celów nielegalnych, Administrator zastrzega sobie bezwzględne prawo do natychmiastowego zablokowania lub trwałego usunięcia konta Użytkownika bez wcześniejszego powiadomienia.\n\nSerwis działa zgodnie z prawem polskim, a miejscem do rozstrzygania sporów jest najbliższy sąd właściwy dla siedziby firmy QR-SYSTEM.\n\nZasady okresu próbnego i retencji konta:\nKażdy nowy użytkownik otrzymuje darmowy 1-dniowy okres próbny. W przypadku braku opłaty (wyboru pakietu Basic 100 PLN lub PRO 2000 PLN) przed upływem okresu testowego, system przesyła powiadomienia e-mail (na 3 i 1 dzień przed końcem), a po upływie 1 dzień konto zostaje tymczasowo zablokowane (deaktywowane). Jeśli opłata nie zostanie uiszczona w ciągu kolejnego 7-dniowego okresu karencji od momentu zablokowania, konto użytkownika wraz z całą skojarzoną bazą danych i Wizytówką AI zostaje automatycznie i bezpowrotnie skasowane z serwerów AILinkB.\n\nData ostatniej modyfikacji: 2 sierpnia 2026 r.\n\nZasady Publikacji Treści:\nUżytkownicy publikujący własne materiały wideo (Prompty / Skille) w naszym serwisie są zobowiązani do wyraźnego zaznaczenia w treści filmu, że dany materiał jest publikowany i dostępny na platformie AILinkB. Przesyłając materiał, użytkownik wyraża również zgodę na to, aby platforma AILinkB publikowała i promowała jego materiały wideo w naszych mediach społecznościowych w jego imieniu.",
      "cookie_title": "Ta strona używa ciasteczek (cookies) 🍪",
      "cookie_desc": "Korzystamy z ciasteczek, aby zapewnić Ci najlepsze doświadczenia na naszej stronie. Zgadzając się, akceptujesz nasz komunikat o ciastkach. Dostęp do strony wymaga Twojej zgody.",
      "cookie_accept": "Akceptuję",
      "Find Service Near You": "Znajdź usługę blisko siebie",
      "search_placeholder": "Czego szukasz?",
      "search_services": "Usługi/Produkty",
      "search_purchases": "Potrzeby Zakupowe",
      "search_jobs": "Oferty Pracy",
      "title_services": "Znajdź Usługi blisko siebie",
      "title_purchases": "Znajdź Potrzeby Zakupowe blisko siebie",
      "title_jobs": "Znajdź Oferty Pracy blisko siebie",
      "tab_announcements": "Ogłoszenia B2B",
      "b2b_announcements_board": "Tablica Ogłoszeń B2B",
      "add_announcement": "Dodaj Ogłoszenie",
      "all_announcements": "Wszystkie ogłoszenia",
      "my_announcements": "Moje ogłoszenia",
      "no_announcements_board": "Brak ogłoszeń na tablicy.",
      "no_announcements_mine": "Nie dodałeś jeszcze żadnych ogłoszeń.",
      "new_announcement": "Nowe ogłoszenie",
      "announcement_type_label": "Typ ogłoszenia",
      "announcement_type_job": "Oferta pracy (Szukam pracownika)",
      "announcement_type_purchase": "Potrzeba zakupowa (Szukam usługi/produktu)",
      "announcement_title_label": "Tytuł",
      "announcement_title_placeholder": "np. Poszukujemy dostawcy serwerów / Zatrudnię Frontend Developera",
      "announcement_desc_label": "Opis i szczegóły",
      "announcement_desc_placeholder": "Opisz dokładnie czego potrzebujesz lub kogo szukasz...",
      "announcement_save": "Zapisz i Opublikuj",
      "badge_purchase": "Potrzeba Zakupowa",
      "badge_job": "Oferta Pracy",
      "tab_job_offers": "Oferty Pracy",
      "no_job_offers": "Nie znaleziono żadnych ofert pracy.",
      "verify_cv": "Aplikuj / Weryfikuj CV",
      "verify_cv_title": "Weryfikacja CV przez AI",
      "verify_cv_desc": "Wklej swoje CV poniżej, a nasza sztuczna inteligencja oceni, jak dobrze pasujesz do tej oferty. Otrzymasz wynik dopasowania i spersonalizowaną opinię.",
      "paste_cv_label": "Wklej swoje CV",
      "paste_cv_placeholder": "Wklej pełny tekst swojego CV tutaj...",
      "run_ai_evaluation": "Oceń CV za pomocą AI",
      "ai_feedback": "Opinia i ocena AI",
      "tab_report_bug": "Zgłoś błąd",
      "report_bug_desc": "Znalazłeś problem w systemie? Opisz go jak najdokładniej. Zgłoszenie trafi bezpośrednio do naszego zespołu technicznego.",
      "report_bug_label": "Opis błędu",
      "report_bug_placeholder": "Co się stało? Co próbowałeś zrobić? Wklej treść błędu jeśli się pojawił...",
      "report_bug_submit": "Wyślij zgłoszenie błędu",
      "report_bug_success_title": "Dziękujemy!",
      "report_bug_success_desc": "Twoje zgłoszenie zostało wysłane do naszego zespołu.",
      "report_bug_error_title": "Błąd",
      "report_bug_error_desc": "Nie udało się wysłać zgłoszenia w tej chwili. Spróbuj ponownie później.",
      "search_button": "Szukaj",
      "no_companies_found": "Nie znaleziono jeszcze żadnych firm.",
      "address": "Adres:",
      "phone": "Telefon:",
      "website": "Strona WWW:",
      "email": "E-mail:",
      "view_details": "Szczegóły",
      "chat_ai": "Chat",
      "greeting": "Cześć! Jestem asystentem AI firmy {{name}}.",
      "km_away": "km stąd",
      "company_details": "Szczegóły firmy",
      "about_company": "O firmie:",
      "offered_services": "Oferowane usługi:",
      "duration": "Czas trwania",
      "mins": "min",
      "start_ai_consultation": "Rozpocznij konsultację AI",
      "no_details": "Brak szczegółów.",
      "typing": "Pisze...",
      "type_message": "Wpisz swoją wiadomość...",
      "more": "więcej",
      "language": "Język",
      "tab_map_of_partners": "Mapa partnerów",
      "tab_dashboard": "Pulpit",
      "tab_system_logs": "Logi Systemowe",
      "tab_phone_calls": "Połączenia Telefoniczne",
      "tab_website": "Moja Strona",

      "google_maps_title": "Wizytówki Google Maps",
      "google_maps_desc": "Zarządzaj widocznością swojej firmy na mapach Google. Dodawaj informacje o lokalizacji, kontakt i integruj to z asystentem AI.",
      "btn_new_profile": "Nowa Wizytówka",
      "btn_edit": "Edytuj",
      "status_pending_verification": "Oczekuje Weryfikacji",
      "status_published": "Opublikowano",
      "btn_publish_map": "Publikuj na mapie",
      "google_maps_empty_title": "Brak wizytówek Google Maps",
      "google_maps_empty_desc": "Nie masz jeszcze skonfigurowanej wizytówki firmy. Dodaj ją, aby ułatwić klientom odnalezienie Twojego biznesu i zsynchronizować dane z asystentem AI.",
      "btn_add_first_profile": "Dodaj pierwszą wizytówkę",
      "company_address": "Adres Firmy",
      "no_company_desc": "Brak opisu firmy.",
      "company_category": "Kategoria",
      "company_phone": "Telefon",
      "modal_title_edit_profile": "Edytuj Wizytówkę",
      "modal_title_new_profile": "Nowa Wizytówka Google Maps",
      "btn_cancel": "Anuluj",
      "btn_save": "Zapisz Wizytówkę",
      "lbl_business_name": "Nazwa firmy",
      "lbl_business_address": "Pełny adres (ulica, miasto, kod pocztowy)",
      "lbl_business_category": "Kategoria działalności",
      "lbl_business_phone": "Numer telefonu",
      "lbl_business_website": "Strona WWW",
      "lbl_business_desc": "Opis firmy",
      "lbl_business_desc_hint": "Krótki opis Twojej działalności, widoczny w wizytówce Google Maps",
      "tab_customers": "Klienci",
      "tab_appointments": "Kalendarz",
      "tab_email": "Skrzynka E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Szkice (AI)",
      "tab_visitor_chats": "Czaty z klientami",
      "tab_orders": "Zamówienia",
      "tab_mail_campaigns": "Kampanie e-mail",
      "tab_ad_campaigns": "Kampanie Ads (AI)",
      "tab_email_templates": "Szablony e-mail",
      "tab_blacklist": "Czarna lista",
      "tab_services": "Produkty / Usługi",
      "tab_events": "Wydarzenia",
      "chat_update_offline": "Trwa aktualizacja oprogramowania. Za chwileczkę będziesz mógł kontynuować rozmowę...",
      "tab_settings": "Ustawienia",
      "tab_admin_panel": "Panel administratora",
      "install_widget": "Zainstaluj Widget",
      "unread_emails": "Nieprzeczytane E-maile",
      "go_to_inbox": "Przejdź do Skrzynki",
      "remaining_appointments": "Pozostałe Terminy",
      "go_to_calendar": "Przejdź do Kalendarza",
      "new_orders_today": "Nowe Zamówienia",
      "view_orders": "Zobacz Zamówienia",
      "total_customers": "Wszyscy Klienci",
      "view_database": "Zobacz Bazę Danych",
      "dashboard_chat_title": "Czat Panelu AILinkB",
      "dashboard_chat_desc": "Zadawaj pytania bazujące na Twoich źródłach wiedzy.",
      "unread_chats": "Nieprzeczytane Czaty",
      "knowledge_sources": "ŹRÓDŁA WIEDZY:",
      "ai_searching": "AI przeszukuje Twoją bazę wiedzy...",
      "cal_daily_appointments": "Dzienne Terminy",
      "cal_new_appointment": "Nowy Termin",
      "cal_reminder": "Przypomnienie",
      "cal_meeting_details": "Szczegóły Spotkania",
      "cal_time": "Czas",
      "cal_agenda": "Agenda / Notatki",
      "cal_no_notes": "Brak notatek.",
      "cal_confirm": "Potwierdź",
      "cal_delete": "Usuń",
      "cal_delete_confirm": "Czy na pewno usunąć to spotkanie?",
      "cal_schedule_new": "Zaplanuj Nowe Spotkanie",
      "cal_meeting_title": "Tytuł Spotkania",
      "cal_associated_lead": "Powiązany Klient",
      "cal_search_lead": "Szukaj klienta...",
      "cal_no_leads": "Nie znaleziono klientów",
      "cal_start_time": "Czas rozpoczęcia",
      "cal_end_time": "Czas zakończenia",
      "cal_cancel": "Anuluj",
      "cal_schedule": "Zaplanuj",
      "admin_title": "Panel Administratora - Użytkownicy i Role",
      "admin_search_email": "Szukaj E-maila",
      "admin_search_email_placeholder": "Szukaj po adresie e-mail...",
      "admin_filter_role": "Filtruj wg Roli",
      "admin_all_roles": "Wszystkie Role",
      "admin_filter_status": "Filtruj wg Statusu",
      "admin_filter_plan": "Filtruj wg Planu",
      "admin_clear": "Wyczyść",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Rola",
      "unread_chats": "Nieprzeczytane Czaty",
      "knowledge_sources": "ŹRÓDŁA WIEDZY:",
      "ai_searching": "AI przeszukuje Twoją bazę wiedzy...",
      "cal_daily_appointments": "Dzienne Terminy",
      "cal_new_appointment": "Nowy Termin",
      "cal_reminder": "Przypomnienie",
      "cal_meeting_details": "Szczegóły Spotkania",
      "cal_time": "Czas",
      "cal_agenda": "Agenda / Notatki",
      "cal_no_notes": "Brak notatek.",
      "cal_confirm": "Potwierdź",
      "cal_delete": "Usuń",
      "cal_delete_confirm": "Czy na pewno usunąć to spotkanie?",
      "cal_schedule_new": "Zaplanuj Nowe Spotkanie",
      "cal_meeting_title": "Tytuł Spotkania",
      "cal_associated_lead": "Powiązany Klient",
      "cal_search_lead": "Szukaj klienta...",
      "cal_no_leads": "Nie znaleziono klientów",
      "cal_start_time": "Czas rozpoczęcia",
      "cal_end_time": "Czas zakończenia",
      "cal_cancel": "Anuluj",
      "cal_schedule": "Zaplanuj",
      "admin_title": "Panel Administratora - Użytkownicy i Role",
      "admin_search_email": "Szukaj E-maila",
      "admin_search_email_placeholder": "Szukaj po adresie e-mail...",
      "admin_filter_role": "Filtruj wg Roli",
      "admin_all_roles": "Wszystkie Role",
      "admin_filter_status": "Filtruj wg Statusu",
      "admin_filter_plan": "Filtruj wg Planu",
      "admin_clear": "Wyczyść",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Rola",
      "admin_subscription": "Subskrypcja",
      "admin_plan": "Plan",
      "admin_no_users": "Nie znaleziono użytkowników spełniających kryteria.",
      "admin_prompts_title": "Globalne Prompty AI i Zachowanie Systemowe (Panel Admina)",
      "admin_prompts_desc": "Konfigurowanie ogólnego zachowania czata, naturalności wypowiedzi i reguł językowych. NIE WPROWADZAJ tutaj danych konkretnego podmiotu (opisy firm ustawia się w konfiguracji danego podmiotu w Panelu Klienta).",
      "admin_global_rules_label": "Globalne Reguły Zachowania AI i Naturalny Ton",
      "admin_global_rules_desc": "Główne wytyczne wymuszające zachowanie naturalne i przyjazne jak człowiek, zwięzłość oraz swobodne reakcje na powitania bez naruszania oferty firm.",
      "admin_default_system_prompt_label": "Domyślny System Prompt (Dla Nowych Podmiotów)",
      "admin_default_system_prompt_desc": "Bazowa instrukcja sterująca dla AI i pracy na wektorach ze źródłem wiedzy RAG.",
      "admin_autoreply_prompt_label": "Prompt Automatyzacji Odpowiedzi E-mail",
      "admin_autoreply_prompt_desc": "Instrukcje redagowania drafts e-mail ze zwracaniem w formacie JSON.",
      "admin_save_prompts": "Zapisz Globalne Prompty AI",
      "admin_prompts_saved": "Globalne konfiguracje promptów AI zostały pomyślnie zapisane!",
      "vpsMonitor.tabName": "Monitor VPS",
      "vpsMonitor.title": "Zasoby Serwera VPS",
      "vpsMonitor.cpu": "Użycie CPU",
      "vpsMonitor.ram": "Użycie RAM",
      "vpsMonitor.disk": "Użycie dysku",
      "vpsMonitor.cpuChart": "Użycie CPU w czasie",
      "vpsMonitor.ramChart": "Użycie RAM w czasie",
      "vpsMonitor.diskChart": "Użycie dysku w czasie",
      "vpsMonitor.range1h": "Ostatnia godzina",
      "vpsMonitor.range6h": "Ostatnie 6 godzin",
      "vpsMonitor.range24h": "Ostatnie 24 godziny",
      "vpsMonitor.range7d": "Ostatnie 7 dni",
      "vpsMonitor.range30d": "Ostatnie 30 dni"
}
  },

        de: {
    translation: {
        "social_publish_this_video": "Dieses Video veröffentlichen",
        "tab_social_sub_upload": "Hochladen & Video",
        "tab_social_sub_skill_videos": "Skill-Videos",
        "tab_social_sub_connectors": "API-Anschlüsse",
        "tab_social_sub_comments": "Kommentare & KI-Moderation",
        "tab_social_sub_history": "Veröffentlichungsverlauf",
        "social_tab_skill_videos": "Meine Skill-Videos",
        "social_skill_videos_title": "Meine Skill-Videos (Veröffentlichungsbereit)",
        "social_skill_videos_empty": "Keine veröffentlichten Skills mit einer Videodatei gefunden.",

        "gen_new_posts": "Neue Beiträge generieren",
        "copy_content": "Inhalt kopieren",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% MwSt. (einmalig)",

        "pricing_options_title": "Veröffentlichungsoptionen & Preise",
        "pricing_yt": "1. YouTube-Link (erfordert PRO-Plan)",
        "pricing_mp4": "2. MP4-Datei auf unseren Server hochladen",
        "pricing_mp4_non_pro": "1. MP4-Datei auf unseren Server hochladen",
        "pricing_order": "3. Videoaufzeichnung bei uns bestellen",
        "pricing_order_non_pro": "2. Videoaufzeichnung bei uns bestellen",

      "order_video_tab": "Video bestellen",
      "order_video_desc": "Sie haben kein Video? Wir nehmen eine professionelle Präsentation für Sie auf! Die Kosten betragen ~30 USD (100 PLN + MwSt.). Senden Sie uns einfach Ihre Dateien.",
      "skill_description_video": "Beschreibung & Anweisungen für das Video",
      "proceed_to_payment_order_video": "Video bestellen und veröffentlichen (25 EUR + 23% VAT)",

      "no_skills_yet": "Sie haben noch keine Skills zum Verkauf veröffentlicht.",
      "preview": "Vorschau",
      "status_approved": "Veröffentlicht",
      "status_pending": "Ausstehende Überprüfung",
      "status_rejected": "Abgelehnt",
      "chat_with_ai": "Fragen Sie die KI nach unserem Angebot",
      "no_skills_listed": "Der Verkäufer hat noch keine KI-Skills gelistet.",
      "buy_skill": "Skill Kaufen",

      "filter_tags_title": "Nach Tags filtern",
      "filter_tags_desc": "Wählen Sie die KI-Technologien und Modelle aus, nach denen Sie suchen:",
      "apply_filters_btn": "Filter anwenden",
      "enter_email_for_access": "Geben Sie Ihre E-Mail-Adresse ein, um Zugang zu erhalten:",
      "payment_error": "Zahlungsfehler",
      "error_generic": "Fehler: ",
      "tab_publish_sell": "Veröffentlichen / Verkaufen",
      "tab_my_skills": "Meine Skills",
      "publish_sell_title": "Veröffentliche und Verkaufe deinen Skill",
      "publish_sell_desc": "Wähle, wie das Video hochgeladen werden soll.",
      "my_published_skills": "Meine veröffentlichten AI Skills",
      "publish_first_skill_desc": "Veröffentliche deinen ersten AI Skill und verdiene Geld",
      "link_youtube": "YouTube-Link",
      "upload_mp4": "MP4 Hochladen",
      "skill_title": "Skill Titel / Name",
      "skill_package_url": "Skill-Paket Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill-Paket (.zip, .py, .json)",
      "skill_tags": "Tags / Technologien (z.B. Python, JS)",
      "skill_price": "Preis (EUR)",
      "publish_for_verification": "Skill zur Überprüfung veröffentlichen",
      "free_publish_pro_only": "Kostenlose Veröffentlichung nur für PRO-Abonnenten.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Titel & Beschreibung",
      "table_price": "Preis",
      "table_status": "Status",
      "table_actions": "Aktionen",
      "confirm_delete_skill": "Bist du sicher?",
      "fill_all_fields": "Bitte fülle alle Felder aus!",
      "generic_error": "Ein Fehler ist aufgetreten",
      "connection_error": "Verbindungsfehler: ",
      "select_video_file": "Video auswählen (MP4)",
      "click_to_select": "Klicken zum Auswählen...",
      "proceed_to_payment_publish": "Zur Zahlung gehen (5 EUR) & Veröffentlichen",
      "skill_video_link": "Präsentationsvideo Link (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Skill-Paket (.zip, .json, .py)",
      "skill_package_placeholder": "Skill-Datei auswählen...",
      "skill_description": "Skill-Beschreibung & Anleitung",
      "skill_description_placeholder": "Wie benutzt man diesen Skill?",
      "skill_tags": "Tags / Technologien",
      "skill_tags_placeholder": "Technologien auswählen...",
      "login_action": "Anmelden",
      "create_account_action": "Konto erstellen",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "SEO Audit",
        "seo_audit_title": "Globales SEO-Audit",
        "seo_audit_desc": "Scannt alle Kunden-Websites auf SEO-Korrektheit, SSL, RWD und Google-Indexierung.",
        "seo_audit_resume": "Audit fortsetzen",
        "seo_audit_new": "Neues Audit",
        "seo_audit_scanning": "Scannen...",
        "seo_audit_confirm": "Möchten Sie wirklich ein völlig neues Audit starten? Der vorherige Bericht wird als Archivversion gespeichert.", "btn_compose": "Verfassen","label_system": "System",
      "label_basic_package": "Basispaket", 
      "label_premium_modules": "Premium-Module", 
      "tab_google_maps": "Google Maps (KI)", 
      "tab_affiliate": "Partnerprogramm",
      
      "cart_btn": "Warenkorb",
      "your_cart": "Ihr Warenkorb",
      "cart_empty": "Warenkorb ist leer.",
      "clear_cart": "Warenkorb leeren",
      "checkout_cart": "Zusammen bezahlen (Checkout)",
      "payment_error": "Zahlungsfehler",
      "dashboard_quick_actions": "Schnelle Aktionen & Werkzeuge",
      "unread_chats": "Ungelesene Chats",
      "go_to_chats": "Zu den Chats gehen",
      "ai_requests_today": "Heute:",
      "ai_requests_btn": "KI-Einstellungen",
      "go_to_inbox": "Zum Posteingang gehen",
      "remaining_appointments": "Verbleibende Termine",
      "go_to_calendar": "Zum Kalender gehen",
      "total_customers": "Alle Kunden",
      "view_database": "Datenbank anzeigen",
      "folder_inbox": "📥 Posteingang",
      "folder_sent": "📤 Gesendet",
      "folder_starred": "⭐ Markiert",
      "folder_spam": "🛑 Spam / Angebote",
      "tab_public_profile": "Öffentliches Firmenprofil",

      "ai_search_empty_alert": "Geben Sie eine Abfrage in das Suchfeld ein, um KI zu verwenden.",
      "ai_search_error": "Verbindungsfehler mit dem KI-Dienst.",
      "ai_summary_title": "KI-Zusammenfassung",
      "ask_ai_search_btn": "Mit KI suchen",
        ask_ai: "KI fragen",
        btn_clear_to_trash: "In den Papierkorb",
        empty_trash_btn: "Papierkorb leeren",
        filter_unread_btn: "🔵 Ungelesene zeigen",
        filter_unread_active: "🔵 Nur ungelesene (Aktiv)",
      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      calls_title: "Anrufe & AI Voice Einstellungen",
      calls_description: "Konfigurieren Sie Ihre Twilio-Telefonnummer und Ihren OpenAI-API-Schlüssel.",
      calls_instruction_title: "Einrichtungsanleitung",
      calls_instruction_desc: "Wissen Sie nicht, wie Sie ein Konto einrichten? Laden Sie unsere Schritt-für-Schritt-Anleitung herunter: ",
      calls_instruction_link: "Anleitung Herunterladen (PDF)",
      twilio_phone_number: "Twilio Telefonnummer",
      openai_voice_api_key: "OpenAI API Schlüssel (Voice)",
      ai_voice_system_prompt_label: "Anweisungen für den Sprachagenten",
      ai_voice_system_prompt_desc: "Leer lassen für Standardverhalten oder eigene Regeln eingeben.",
      ai_voice_system_prompt_placeholder: "Standard: Du bist ein Sprachassistent...",
      webhook_config_title: "Twilio Webhook-Konfiguration",
      webhook_config_desc: "Kopieren Sie die untenstehende URL in Ihre Twilio-Einstellungen:",
      webhook_url: "Webhook URL (AILinkB)",
      btn_copy: "Kopieren",
      btn_copied: "Kopiert",
      btn_save_config: "Konfiguration Speichern",
      save_success_title: "Gespeichert",
      save_success_desc: "Erfolgreich gespeichert.",
      save_error_title: "Fehler",
      save_error_desc: "Fehler beim Speichern.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Anrufverlauf",

      analytics_buy_tokens: "AI-Token kaufen", analytics_package_desc: "1 Paket = 100.000 Token (50 PLN netto)", analytics_buy_btn: "Kaufen für {{amount}} PLN",
      
      time_1h: "1 Std", time_24h: "24 Std", time_7d: "7 Tage", time_30d: "30 Tage", time_3m: "3 Mon.", time_6m: "6 Mon.",
      
      analytics_chart2_legend: "Aktive Anrufe (Redis)",
      analytics_chart2_desc: "Anzahl der aktiven Redis-Sprachsitzungen im Zeitverlauf",
      analytics_chart2_title: "Aktive Live-Sprachanrufe",
      analytics_chart1_legend_voice: "Sprachsitzungs-Tokens",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Historische und aktuelle Aufschlüsselung der Token-Nutzung für Text-Chat und Sprachsitzungen",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Kontostatus: Blockiert (403)",
      analytics_status_ok: "Kontostatus: Aktiv (OK)",
      analytics_available_credits_title: "Verfügbare KI-Credits",
      analytics_active_calls_desc: "Direkt aus Redis abgerufen (`VoiceSessionRedisService`)",
      analytics_active_calls: "Aktive Sprachsitzungen (Redis)",
      analytics_refresh: "Metriken aktualisieren",
      analytics_last_updated: "Zuletzt aktualisiert: ",
      analytics_panel_desc: "Metriken für Sprachsitzungen, KI-Token-Nutzung und Echtzeit-Guthabenstand",
      analytics_panel_title: "Analysepanel & Ressourcennutzung",
      analytics_model: "Modell",
      analytics_cost: "Kosten (Credits)",
      analytics_tokens_comp: "Abschluss-Tokens",
      analytics_tokens_prompt: "Prompt Tokens",
      analytics_date: "Datum",
      analytics_history: "LLM Abfrageverlauf (Letzte 10)",
      analytics_limit_exceeded: "⚠️ Credit-Limit überschritten! AI-Dienste (Chat und Voice) wurden blockiert.",
      analytics_limit_total: "Gesamtlimit: ",
      analytics_credits_used: "Verbrauchte Credits: ",
      analytics_credits_available: "Verfügbare Credits: ",
      analytics_credits_available_pct: "Verfügbar",
      analytics_credits_progress: "AI-Guthabennutzung (Fortschrittsbalken)",
      analytics_voice_minutes_rate: "Umrechnungsrate pro Minute für Telefonsitzungen",
      analytics_voice_minutes: "Voice AI Minutenverbrauch",
      openai_api_key_voice: "OpenAI API Schlüssel (Realtime Voice)",
      tab_calls: "Anrufe",
      calls_title: "Sprachassistent Einstellungen",
      twilio_phone_number: "Twilio Telefonnummer",
      save_calls_settings: "Spracheinstellungen speichern",
      add_product: "Produkt / Dienstleistung hinzufügen",
      new_product_def: "Definition eines neuen Produkts / einer neuen Dienstleistung",
      product_name: "Produkt- / Dienstleistungsname",
      price: "Preis",
      currency: "Währung",
      hidden_ai_only: "Auf öffentlichem Profil verborgen (nur für KI)",
      ai_knowledge_desc: "Beschreibung (Was soll die KI über dieses Produkt lernen?)",
      save_product: "Produkt / Dienstleistung speichern",
      update_product: "Änderungen speichern",
      confirm_delete: "Möchten Sie dieses Produkt wirklich löschen?",
      delete: "Löschen",
      no_products_yet: "Noch keine Produkte oder Dienstleistungen. Fügen Sie Ihr erstes Produkt hinzu.",
      "logout": "Abmelden",
      "bg_color_tab": "Hintergrundfarbe", "ai_image_tab": "KI-Bild", "bg_color_label": "Kopfzeilenfarbe wählen", "bg_color_placeholder": "z.B. #4f46e5", "ai_image_title": "KI-Kopfzeile generieren (ComfyUI)", "ai_image_desc": "Generieren Sie einen Kopfzeilen-Hintergrund, indem Sie Ihre eigene Eingabeaufforderung eingeben. Das Bild wird automatisch an Ihr Profil angehängt.", "ai_image_prompt_placeholder": "z.B. Modernes Büro, Skyline, helle Farben", "ai_image_btn": "Bild generieren", "ai_image_email_req": "Bitte geben Sie zuerst Ihre E-Mail im Registrierungsformular an.", "ai_image_timeout": "Wartezeit für Bildgenerierung abgelaufen.",
      "btn_activate_subscription": "Dieses Paket aktivieren",
      "btn_active_current": "Aktuelles Paket",
      "error_accept_terms": "Sie müssen die Bedingungen akzeptieren, um fortzufahren.",
      "trial_expired_title": "🛑 Zahlung erforderlich",
      "trial_expired_desc": "Um Ihre AI Business Card und Business-Tools weiterhin zu nutzen, wählen Sie bitte unten ein Abonnement aus.",
      "plan_upgrade_success_basic": "Glückwunsch! Paket aktiviert: AI Business Card + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Glückwunsch! Paket aktiviert: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 AI Business Card + Chatbot Paket",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN brutto) / Monat",
      "plan_basic_desc": "Ideales Starterpaket. Beinhaltet die vollständige Verwaltung Ihrer AI Business Card und Chatbot-Training:",
      "plan_basic_f1": "✅ AI Business Card (Öffentliches Firmenprofil)",
      "plan_basic_f2": "✅ AI Chatbot-Training & Dienstleistungsbeschreibungen",
      "plan_basic_f3": "✅ Stellenangebote und Firmenveranstaltungen",
      "plan_basic_f4": "🔒 Ads, CRM, Mail & Google Maps-Tools sind deaktiviert",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Fangen Sie jetzt an zu verdienen, indem Sie Ihre KI-Fähigkeiten verkaufen",
      "hero_title_discover": "Entdecken & Verkaufen",
      "hero_title_skills": "KI-Fähigkeiten",
      "marketplace_search_placeholder": "Was suchen Sie? Fragen Sie die KI...",
      "marketplace_popular_skills": "Beliebte Fähigkeiten",
      "marketplace_new_prompts": "Neue KI-Prompts",
      "plan_pro_f1": "✅ Alles im Basispaket",
      "plan_pro_f2": "⚡ Eigenes CRM-System mit intelligenten E-Mails",
      "plan_pro_f3": "⚡ AI Ad Campaign Generatoren (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps & Auto-Discovery B2B Leads",
      "plan_pro_f5": "⚡ Social Media Post & Newsletter Generator",
      "ai_requests_stat_title": "KI-Nutzung (Agentic AI)",
      "ai_requests_today": "Heute:",
      "ai_requests_btn": "KI-Einstellungen",
      ai_greeting: "Hallo! Ich bin Ihr KI-Assistent. Fragen Sie nach Produkten und Dienstleistungen, oder lassen Sie mich eine professionelle Website mit einem KI-Chatbot für Sie erstellen! Durch die Fortsetzung dieses Gesprächs stimmen Sie automatisch der Verarbeitung und Speicherung aller hier angegebenen Daten zu.",
      search_results_title: "Suchergebnisse auf der Karte für",
      all_companies_list_title: "Verifiziertes AILinkB-Verzeichnis & Interaktive Karte",
      landing_ai_title_simple: "Wie können wir Ihnen heute helfen? (Globale Suche)",
      landing_ai_subtitle_simple: "Suchen Sie ein Unternehmen, einen Dienst oder ein Produkt? Fragen Sie per Sprachbefehl oder Text, und ich durchsuche die gesamte AILinkB-Datenbank.",
      landing_ai_placeholder_simple: "Sprechen oder tippen Sie, wonach Sie suchen...",
      search_by_voice_title: "Per Sprache suchen",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Hintergrund-Synchronisation",
      sync_in_progress: "E-Mails werden im Hintergrund synchronisiert...",
      sync_completed_refreshing: "Abgeschlossen. Liste wird aktualisiert...",
      no_messages_found: "Keine Nachrichten gefunden.",
      welcome_back: "Willkommen zurück",
      login_to_dashboard: "Anmelden",
      email_address: "E-Mail Adresse",
      security_pin: "Sicherheits-PIN (6 Ziffern)",
      forgot_pin: "PIN vergessen?",
      login_with_pin: "Mit PIN anmelden",
      or: "ODER",
      need_account: "Konto benötigt? Setup starten",
      back_to_home: "← Zurück zur Startseite",
      cancel_edit: "← Bearbeitung abbrechen",
      save_profile: "Profil speichern",
      save_profile_activate: "Profil speichern & AI aktivieren",
      sign_in: "Anmelden",
      "no_services_listed": "Dieses Unternehmen hat noch keine spezifischen Dienstleistungen aufgeführt.", "view_details": "Details anzeigen", "scan_mobile": "Scannen zum Öffnen auf dem Handy:", "map_location": "Karte & Standort", "map_not_provided": "Kartenkoordinaten nicht angegeben.", "partner_program": "Partner AILinkB - Empfehlen und verdienen!", "affiliate_code": "Partnercode:", "create_free_account": "Konto erstellen", "tab_needs": "Bedarf", "tab_job_offers": "Stellenangebote", "tab_services": "Unsere Dienstleistungen",
      "bg_color_tab": "Hintergrundfarbe", "ai_image_tab": "KI-Bild", "bg_color_label": "Kopfzeilenfarbe wählen", "bg_color_placeholder": "z.B. #4f46e5", "ai_image_title": "KI-Kopfzeile generieren", "ai_image_desc": "Generieren Sie einen Kopfzeilen-Hintergrund, indem Sie Ihre eigene Eingabeaufforderung eingeben. Das Bild wird automatisch an Ihr Profil angehängt.", "ai_image_prompt_placeholder": "z.B. Modernes Büro, Skyline, helle Farben", "ai_image_btn": "Bild generieren", "ai_image_email_req": "Bitte geben Sie zuerst Ihre E-Mail im Registrierungsformular an.", "ai_image_timeout": "Wartezeit für Bildgenerierung abgelaufen.",
      "live_editor_title": "Live-Editor: Erstellen Sie Ihr Unternehmensprofil",
      "preview_btn_top": "👁️ Vorschau (Neues Fenster)",
      "preview_btn_bottom": "👁️ Live-Website-Vorschau (Neues Fenster)",
      "preview_banner_title": "LIVE-WEBSITE-VORSCHAU IN ECHTZEIT",
      "preview_banner_desc": "So wird Ihre fertige Website auf AILinkB aussehen, nachdem Sie das Formular gespeichert haben.",
      "preview_banner_close": "✖ Vorschau schließen",
      "our_services": "Unsere Dienstleistungen",
      "about_us": "Über uns",
      "about_us_placeholder": "Geben Sie Informationen für die KI ein, z.B.:\n• Arbeitszeiten und Regeln\n• Preispolitik und Rabatte\n• Ihre Unternehmensvorteile\n• FAQ (Häufig gestellte Fragen)\n• Anweisungen für die KI",
      "live_ai_chat": "Live-KI-Chat-Vorschau",
      "service_name": "Dienstleistungsname",
      "brief_desc": "Kurzbeschreibung...",
      "add_service": "+ Dienstleistung hinzufügen",
      "install_widget": "Wie installieren Sie das Widget auf Ihrer Website?",
      "profile_link": "Ihr dedizierter Profillink",
      "copy": "Kopieren",
      "ai_learn_note": "Hinweis: Die KI lernt Ihre spezifischen Details erst, nachdem Sie auf Speichern geklickt haben.",
      "chat_consent_label": "Ich akzeptiere die ",
      "privacy_policy_link": "Datenschutzerklärung",
      "privacy_policy_title": "Datenschutzerklärung",
      "privacy_policy_content": "Datenschutzrichtlinie\nÜberblick\nDiese Datenschutzrichtlinie wurde erstellt, um die Regeln für die Verarbeitung personenbezogener Daten zu erläutern, die über die Website https://ailinkb.com/ (im Folgenden: die Website) erhoben werden. Wir weisen darauf hin, dass wir mit der gebotenen Sorgfalt sicherstellen, dass Ihre personenbezogenen Daten in Übereinstimmung mit den Anforderungen des geltenden Rechts verarbeitet werden, insbesondere in Übereinstimmung mit der Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 (Datenschutz-Grundverordnung) (im Folgenden: DSGVO).\n\nDatenverwaltung\nDie Verarbeitung personenbezogener Daten basiert auf Rechtmäßigkeit, Fairness und Transparenz der Informationen. Daten werden vom Verantwortlichen für personenbezogene Daten für einen bestimmten, eindeutigen und legitimen Zweck erhoben. Der Verantwortliche für personenbezogene Daten unternimmt alle notwendigen Anstrengungen, um die höchstmögliche Sicherheit und den Schutz der von ihm verarbeiteten personenbezogenen Daten zu gewährleisten. Die Bereitstellung von Daten ist freiwillig. Jeder von Ihnen hat das Recht, auf seine personenbezogenen Daten zuzugreifen, diese zu überprüfen, zu aktualisieren und deren Löschung zu beantragen.\nPersonenbezogene Daten wurden von uns direkt von Ihnen oder von mit uns zusammenarbeitenden Unternehmen (Growbots Sp. z o.o., KRS-Nummer: 0000504714) erhoben, um den mit Ihnen geschlossenen Vertrag zu erfüllen oder - im Fall von Cookies - auf Grundlage Ihrer Einwilligung.\nVerantwortlicher für personenbezogene Daten\nDer Verantwortliche für personenbezogene Daten ist: QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B Stammkapital 10 000 PLN (im Folgenden: ailinkb oder der Administrator).\nAlle Fragen, Anfragen oder Beschwerden im Zusammenhang mit der Verarbeitung personenbezogener Daten in ailinkb sollten elektronisch an die E-Mail-Adresse: support@ailinkb.com oder schriftlich an die Postanschrift des Verantwortlichen, d. h. QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B gerichtet werden.\nArt der verarbeiteten personenbezogenen Daten und Zwecke der Datenverarbeitung\nUnsere Website erhebt die folgenden personenbezogenen Daten:\na) E-Mail-Adresse - zur Erstellung eines Kontos auf der Website,\nb) Name, Vorname, Wohnanschrift und Steuernummer (NIP) - für Rechnungen,\nc) Kreditkartennummer, CVC-Code und Ablaufdatum - für Zahlungen,\nd) bei Unternehmern zusätzlich: Firmenname, REGON, Geschäftsadresse.\ne) zusätzlich Navigationsdaten (IP, Browser etc.).\n\nIhre personenbezogenen Daten werden verarbeitet für: Erfüllung des Vertrags (Art. 6(1)(b) DSGVO); Erfüllung gesetzlicher Pflichten (Art. 6(1)(c) DSGVO); berechtigte Interessen (Art. 6(1)(f) DSGVO).\n\nCookies und Profiling\nDie Website verwendet Cookie-Technologie, um ihre Funktionalität an Ihre individuellen Bedürfnisse anzupassen. \n\nIhre Rechte gemäß DSGVO\nSie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21). \nAußerdem haben Sie das Recht, eine Beschwerde bei einer Aufsichtsbehörde einzureichen (Art. 77 DSGVO).\n\n\n\nUnzulässige Nutzung des Dienstes:\nEs ist strengstens untersagt, den Dienst für illegale Zwecke zu nutzen, einschließlich der Durchführung krimineller Aktivitäten, Betrug oder anderer Aktivitäten, die gegen allgemein geltende Gesetze verstoßen. Für den Fall, dass festgestellt wird, dass ein Konto für illegale Zwecke verwendet wird, behält sich der Administrator das absolute Recht vor, das Konto des Benutzers ohne vorherige Ankündigung sofort zu sperren oder dauerhaft zu löschen.\n\nFragen zur Datenschutzrichtlinie sind an support@ailinkb.com zu richten.\n\nRichtlinie zur Veröffentlichung von Inhalten:\nBenutzer, die ihre eigenen Videomaterialien (Prompts / Skills) auf unserem Dienst veröffentlichen, müssen im Videoinhalt ausdrücklich angeben, dass das Material auf der AILinkB-Plattform veröffentlicht und verfügbar ist. Durch das Hochladen erteilt der Benutzer der AILinkB-Plattform außerdem die Erlaubnis, seine Videomaterialien in seinem Namen auf unseren Social-Media-Kanälen zu veröffentlichen und zu bewerben.",
      "cookie_title": "Diese Website verwendet Cookies 🍪",
      "cookie_desc": "Wir verwenden Cookies, um Ihnen das beste Erlebnis auf unserer Website zu bieten. Durch die Zustimmung akzeptieren Sie unsere Cookie-Richtlinie. Der Zugriff auf die Website erfordert Ihre Zustimmung.",
      "cookie_accept": "Ich stimme zu",
      "Find Service Near You": "Finden Sie einen Service in Ihrer Nähe",
      "search_placeholder": "Wonach suchen Sie?",
      "search_services": "Dienstleistungen/Produkte",
      "search_purchases": "Kaufbedürfnisse",
      "search_jobs": "Stellenangebote",
      "title_services": "Finden Sie Dienstleistungen in Ihrer Nähe",
      "title_purchases": "Finden Sie Kaufbedürfnisse in Ihrer Nähe",
      "title_jobs": "Finden Sie Stellenangebote in Ihrer Nähe",
      "tab_announcements": "B2B-Anzeigen",
      "b2b_announcements_board": "B2B-Anzeigetafel",
      "add_announcement": "Anzeige hinzufügen",
      "all_announcements": "Alle Anzeigen",
      "my_announcements": "Meine Anzeigen",
      "no_announcements_board": "Keine Anzeigen auf der Tafel.",
      "no_announcements_mine": "Sie haben noch keine Anzeigen hinzugefügt.",
      "new_announcement": "Neue Anzeige",
      "announcement_type_label": "Anzeigentyp",
      "announcement_type_job": "Stellenangebot (Suche nach einem Mitarbeiter)",
      "announcement_type_purchase": "Kaufbedarf (Suche nach einer Dienstleistung/einem Produkt)",
      "announcement_title_label": "Titel",
      "announcement_title_placeholder": "z.B. Suche Serverlieferanten / Stelle Frontend-Entwickler ein",
      "announcement_desc_label": "Beschreibung und Details",
      "announcement_desc_placeholder": "Beschreiben Sie genau, was Sie brauchen oder wen Sie suchen...",
      "announcement_save": "Speichern und veröffentlichen",
      "badge_purchase": "Kaufbedarf",
      "badge_job": "Stellenangebot",
      "tab_job_offers": "Stellenangebote",
      "no_job_offers": "Keine Stellenangebote gefunden.",
      "verify_cv": "Bewerben / Lebenslauf prüfen",
      "verify_cv_title": "KI-Lebenslaufprüfung",
      "verify_cv_desc": "Fügen Sie Ihren Lebenslauf unten ein. Unsere KI bewertet, wie gut Sie zu diesem Stellenangebot passen.",
      "paste_cv_label": "Lebenslauf einfügen",
      "paste_cv_placeholder": "Fügen Sie hier Ihren vollständigen Lebenslauftext ein...",
      "run_ai_evaluation": "Lebenslauf mit KI bewerten",
      "ai_feedback": "KI-Bewertungsfeedback",
      "tab_report_bug": "Fehler melden",
      "report_bug_desc": "Ein Problem gefunden? Bitte beschreiben Sie es so genau wie möglich. Es wird direkt an unser Technikteam gesendet.",
      "report_bug_label": "Fehlerbeschreibung",
      "report_bug_placeholder": "Was ist passiert? Was wollten Sie tun? Fehlermeldungen falls möglich einfügen...",
      "report_bug_submit": "Fehlerbericht senden",
      "report_bug_success_title": "Vielen Dank!",
      "report_bug_success_desc": "Ihr Bericht wurde an unser Team gesendet.",
      "report_bug_error_title": "Fehler",
      "report_bug_error_desc": "Wir konnten Ihren Bericht im Moment nicht senden. Bitte versuchen Sie es später erneut.",
      "search_button": "Suchen",
      "no_companies_found": "Noch keine Firmen gefunden.",
      "address": "Adresse:",
      "phone": "Telefon:",
      "website": "Webseite:",
      "email": "E-Mail:",
      "view_details": "Details anzeigen",
      "chat_ai": "Chat",
      "greeting": "Hallo! Ich bin der KI-Assistent für {{name}}.",
      "km_away": "km entfernt",
      "company_details": "Firmendetails",
      "about_company": "Über die Firma:",
      "offered_services": "Angebotene Dienstleistungen:",
      "duration": "Dauer",
      "mins": "Min",
      "start_ai_consultation": "KI-Beratung starten",
      "no_details": "Keine Details verfügbar.",
      "typing": "Tippt...",
      "type_message": "Ihre Nachricht eingeben...",
      "more": "mehr",
      "language": "Sprache",
      "tab_map_of_partners": "Partnerkarte",
      "tab_dashboard": "Dashboard",
      "tab_system_logs": "Systemprotokolle",
      "tab_phone_calls": "Telefonanrufe",
      "tab_website": "Meine Website",
      "tab_customers": "Kunden",
      "tab_appointments": "Termine",
      "tab_email": "E-Mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Entwürfe (KI)",
      "tab_visitor_chats": "Besucher-Chats",
      "tab_orders": "Bestellungen",
      "tab_mail_campaigns": "E-Mail-Kampagnen",
      "tab_ad_campaigns": "Werbekampagnen (KI)",
      "tab_email_templates": "E-Mail-Vorlagen",
      "tab_blacklist": "Schwarze Liste",
      "tab_services": "Dienstleistungen",
      "tab_events": "Ereignisse",
      "chat_update_offline": "Software-Update läuft. Sie können das Gespräch gleich fortsetzen...",
      "tab_settings": "Einstellungen",
      "tab_admin_panel": "Admin-Panel",
      "install_widget": "Widget installieren",
      "unread_emails": "Ungelesene E-Mails",
      "go_to_inbox": "Zum Posteingang",
      "remaining_appointments": "Verbleibende Termine",
      "go_to_calendar": "Zum Kalender",
      "new_orders_today": "Neue Bestellungen",
      "view_orders": "Bestellungen ansehen",
      "total_customers": "Gesamtkunden",
      "view_database": "Datenbank ansehen",
      "dashboard_chat_title": "AILinkB Dashboard-Chat",
      "dashboard_chat_desc": "Stellen Sie Fragen basierend auf Ihren Datenquellen.",
      "unread_chats": "Ungelesene Chats",
      "knowledge_sources": "WISSENSQUELLEN:",
      "ai_searching": "KI durchsucht Ihre Wissensdatenbank...",
      "cal_daily_appointments": "Tägliche Termine",
      "cal_new_appointment": "Neuer Termin",
      "cal_reminder": "Erinnerung",
      "cal_meeting_details": "Besprechungsdetails",
      "cal_time": "Zeit",
      "cal_agenda": "Agenda / Notizen",
      "cal_no_notes": "Keine Notizen.",
      "cal_confirm": "Bestätigen",
      "cal_delete": "Löschen",
      "cal_delete_confirm": "Besprechung löschen?",
      "cal_schedule_new": "Neue Besprechung planen",
      "cal_meeting_title": "Besprechungstitel",
      "cal_associated_lead": "Zugehöriger Lead",
      "cal_search_lead": "Nach Lead suchen...",
      "cal_no_leads": "Keine Leads gefunden",
      "cal_start_time": "Startzeit",
      "cal_end_time": "Endzeit",
      "cal_cancel": "Abbrechen",
      "cal_schedule": "Planen",
      "admin_title": "Admin-Panel - Benutzer & Rollen",
      "admin_search_email": "E-Mail suchen",
      "admin_search_email_placeholder": "Nach E-Mail suchen...",
      "admin_filter_role": "Nach Rolle filtern",
      "admin_all_roles": "Alle Rollen",
      "admin_filter_status": "Nach Status filtern",
      "admin_filter_plan": "Nach Plan filtern",
      "admin_clear": "Löschen",
      "admin_id": "ID",
      "admin_email": "E-Mail",
      "admin_role": "Rolle",
      "admin_subscription": "Abonnement",
      "admin_plan": "Plan",
      "admin_no_users": "Keine passenden Benutzer gefunden.",
      "admin_prompts_title": "Globale KI-Prompts & Systemverhalten (Admin-Panel)",
      "admin_prompts_desc": "Konfigurieren Sie das allgemeine KI-Verhalten, den Konversationston und die Sprachregeln. Fügen Sie hier KEINE firmenspezifischen Daten hinzu (nutzen Sie dafür das Kundenprofil).",
      "admin_global_rules_label": "Globale KI-Regeln & Natürlich-Menschlicher Ton",
      "admin_global_rules_desc": "Hauptregeln für natürliches, freundliches Verhalten wie ein Mensch, Präzision und angemessene Reaktionen auf Begrüßungen.",
      "admin_default_system_prompt_label": "Standard-System-Prompt (Für neue Unternehmen)",
      "admin_default_system_prompt_desc": "Basis-Anweisungen für die Arbeit der KI mit RAG-Kontextdaten.",
      "admin_autoreply_prompt_label": "E-Mail-Auto-Reply-Prompt",
      "admin_autoreply_prompt_desc": "Anweisungen für das Analysieren von E-Mails und Generieren von Entwürfen im JSON-Format.",
      "admin_save_prompts": "Globale Prompts speichern",
      "admin_prompts_saved": "Globale KI-Prompt-Konfigurationen erfolgreich gespeichert!",
      "vpsMonitor.tabName": "VPS-Monitor",
      "vpsMonitor.title": "VPS-Serverressourcen",
      "vpsMonitor.cpu": "CPU-Auslastung",
      "vpsMonitor.ram": "RAM-Auslastung",
      "vpsMonitor.disk": "Festplattenauslastung",
      "vpsMonitor.cpuChart": "CPU-Auslastung im Zeitverlauf",
      "vpsMonitor.ramChart": "RAM-Auslastung im Zeitverlauf",
      "vpsMonitor.diskChart": "Festplattenauslastung im Zeitverlauf",
      "vpsMonitor.range1h": "Letzte Stunde",
      "vpsMonitor.range6h": "Letzte 6 Stunden",
      "vpsMonitor.range24h": "Letzte 24 Stunden",
      "vpsMonitor.range7d": "Letzte 7 Tage",
      "vpsMonitor.range30d": "Letzte 30 Tage"
}
  },

        fr: {
    translation: {
        "social_publish_this_video": "Publier cette vidéo",
        "tab_social_sub_upload": "Téléchargement et Vidéo",
        "tab_social_sub_skill_videos": "Vidéos de Skills",
        "tab_social_sub_connectors": "Connecteurs API",
        "tab_social_sub_comments": "Commentaires & Modération IA",
        "tab_social_sub_history": "Historique de Publication",
        "social_tab_skill_videos": "Mes Vidéos de Skills",
        "social_skill_videos_title": "Mes Vidéos de Skills (Prêtes à Publier)",
        "social_skill_videos_empty": "Aucun skill publié avec un fichier vidéo trouvé.",

        "gen_new_posts": "Générer de nouveaux posts",
        "copy_content": "Copier le contenu",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% TVA (une fois)",

        "pricing_options_title": "Options de publication et prix",
        "pricing_yt": "1. Lien YouTube (nécessite le plan PRO)",
        "pricing_mp4": "2. Télécharger un fichier MP4 sur notre serveur",
        "pricing_mp4_non_pro": "1. Télécharger un fichier MP4 sur notre serveur",
        "pricing_order": "3. Commander un enregistrement vidéo chez nous",
        "pricing_order_non_pro": "2. Commander un enregistrement vidéo chez nous",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Lien de la vidéo de présentation (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Package du Skill (.zip, .json, .py)",
      "skill_package_placeholder": "Sélectionnez le fichier du skill...",
      "skill_description": "Description et instructions du Skill",
      "skill_description_placeholder": "Comment utiliser ce skill?",
      "skill_tags": "Tags / Technologies",
      "skill_tags_placeholder": "Sélectionnez les technologies...",
      "login_action": "Se connecter",
      "create_account_action": "Créer un compte",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "Audit SEO",
        "seo_audit_title": "Audit SEO Global",
        "seo_audit_desc": "Analyse tous les sites Web des clients pour la correction SEO, SSL, RWD et indexation Google.",
        "seo_audit_resume": "Reprendre l'audit",
        "seo_audit_new": "Nouvel audit",
        "seo_audit_scanning": "Analyse en cours...",
        "seo_audit_confirm": "Êtes-vous sûr de vouloir lancer un tout nouvel audit ? Le rapport précédent sera enregistré en tant que version d'archive.", "btn_compose": "Nouveau message","label_system": "Système",
      "label_basic_package": "Forfait de Base", 
      "label_premium_modules": "Modules Premium", 
      "tab_google_maps": "Google Maps (IA)", 
      "tab_affiliate": "Programme d'Affiliation",
      
        ask_ai: "Demander à l'IA",
        btn_clear_to_trash: "Mettre à la corbeille",
        empty_trash_btn: "Vider la corbeille",
        filter_unread_btn: "🔵 Afficher non lus",
        filter_unread_active: "🔵 Seulement non lus (Actif)",
      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      calls_title: "Appels et Paramètres AI Voice",
      calls_description: "Configurez votre numéro Twilio et la clé API OpenAI.",
      calls_instruction_title: "Instructions de Configuration",
      calls_instruction_desc: "Besoin d'aide pour configurer ? Téléchargez notre guide : ",
      calls_instruction_link: "Télécharger le Guide (PDF)",
      twilio_phone_number: "Numéro de Téléphone Twilio",
      openai_voice_api_key: "Clé API OpenAI (Voice)",
      ai_voice_system_prompt_label: "Instructions pour l'Agent Vocal",
      ai_voice_system_prompt_desc: "Laissez vide pour le comportement par défaut.",
      ai_voice_system_prompt_placeholder: "Par défaut : Vous êtes un assistant vocal...",
      webhook_config_title: "Configuration Webhook Twilio",
      webhook_config_desc: "Copiez l'URL ci-dessous dans vos paramètres Twilio :",
      webhook_url: "URL Webhook (AILinkB)",
      btn_copy: "Copier",
      btn_copied: "Copié",
      btn_save_config: "Enregistrer",
      save_success_title: "Enregistré",
      save_success_desc: "Paramètres enregistrés avec succès.",
      save_error_title: "Erreur",
      save_error_desc: "Échec de l'enregistrement.",
      tab_voice_config: "Configuration AI Voice",
      tab_voice_history: "Historique des Appels",

      analytics_buy_tokens: "Acheter des jetons IA", analytics_package_desc: "1 forfait = 100 000 jetons (50 PLN net)", analytics_buy_btn: "Acheter pour {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Jours", time_30d: "30 Jours", time_3m: "3 Mois", time_6m: "6 Mois",
      
      analytics_chart2_legend: "Appels actifs (Redis)",
      analytics_chart2_desc: "Nombre de sessions vocales Redis actives dans le temps",
      analytics_chart2_title: "Appels vocaux actifs en direct",
      analytics_chart1_legend_voice: "Tokens Sessions Vocales",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Répartition historique et actuelle de l'utilisation des tokens du chat textuel et des sessions vocales",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Statut du compte : Bloqué (403)",
      analytics_status_ok: "Statut du compte : Actif (OK)",
      analytics_available_credits_title: "Crédits IA disponibles",
      analytics_active_calls_desc: "Récupéré directement depuis Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Sessions vocales actives (Redis)",
      analytics_refresh: "Actualiser les métriques",
      analytics_last_updated: "Dernière mise à jour : ",
      analytics_panel_desc: "Métriques des sessions vocales, utilisation des tokens IA et solde de crédits en temps réel",
      analytics_panel_title: "Panneau d'analyse et utilisation des ressources",
      analytics_model: "Modèle",
      analytics_cost: "Coût (Crédits)",
      analytics_tokens_comp: "Tokens de complétion",
      analytics_tokens_prompt: "Tokens de prompt",
      analytics_date: "Date",
      analytics_history: "Historique des requêtes LLM (10 dernières)",
      analytics_limit_exceeded: "⚠️ Limite de crédits dépassée ! Les services IA (Chat et Voix) ont été bloqués.",
      analytics_limit_total: "Limite totale: ",
      analytics_credits_used: "Crédits utilisés: ",
      analytics_credits_available: "Crédits disponibles: ",
      analytics_credits_available_pct: "Disponible",
      analytics_credits_progress: "Utilisation des crédits IA (Barre de progression)",
      analytics_voice_minutes_rate: "Taux par minute converti pour les sessions téléphoniques",
      analytics_voice_minutes: "Utilisation des minutes Voice AI",
      openai_api_key_voice: "Clé API OpenAI (Realtime Voice)",
      tab_calls: "Appels",
      calls_title: "Paramètres de l'assistant vocal",
      twilio_phone_number: "Numéro de téléphone Twilio",
      save_calls_settings: "Enregistrer les paramètres vocaux",
      add_product: "Ajouter un Produit / Service",
      new_product_def: "Définition d'un nouveau produit / service",
      product_name: "Nom du Produit / Service",
      price: "Prix",
      currency: "Devise",
      hidden_ai_only: "Masqué sur le profil public (uniquement pour l'IA)",
      ai_knowledge_desc: "Description (Que doit apprendre l'IA sur ce produit ?)",
      save_product: "Enregistrer le Produit / Service",
      update_product: "Enregistrer les modifications",
      confirm_delete: "Êtes-vous sûr de vouloir supprimer ce produit ?",
      delete: "Supprimer",
      no_products_yet: "Aucun produit ou service pour le moment. Ajoutez votre premier produit.",
      "logout": "Se déconnecter",
      "bg_color_tab": "Couleur de fond", "ai_image_tab": "Image IA", "bg_color_label": "Sélectionner la couleur d'en-tête", "bg_color_placeholder": "ex. #4f46e5", "ai_image_title": "Générer un en-tête IA (ComfyUI)", "ai_image_desc": "Générez un fond d'en-tête en entrant votre propre description. L'image sera automatiquement attachée à votre profil.", "ai_image_prompt_placeholder": "ex. Bureau moderne, panorama, couleurs vives", "ai_image_btn": "Générer l'image", "ai_image_email_req": "Veuillez d'abord fournir votre e-mail dans le formulaire d'inscription.", "ai_image_timeout": "Le délai d'attente pour la génération de l'image a expiré.",
      "btn_activate_subscription": "Activer ce forfait",
      "btn_active_current": "Forfait Actuel",
      "error_accept_terms": "Vous devez accepter les conditions pour continuer.",
      "trial_expired_title": "🛑 Paiement Requis",
      "trial_expired_desc": "Pour continuer à utiliser votre carte de visite IA et vos outils, veuillez choisir un forfait ci-dessous.",
      "plan_upgrade_success_basic": "Félicitations! Forfait activé: Carte de visite IA + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Félicitations! Forfait activé: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Forfait Carte de Visite IA + Chatbot",
      "plan_basic_price": "100 PLN net (123 PLN brut) / mois",
      "plan_basic_desc": "Forfait de démarrage idéal. Comprend la gestion complète de votre profil public IA et la formation du chatbot:",
      "plan_basic_f1": "✅ Carte de Visite IA (Profil Public)",
      "plan_basic_f2": "✅ Formation Chatbot IA & descriptions des services",
      "plan_basic_f3": "✅ Offres d'emploi et événements",
      "plan_basic_f4": "🔒 Annonces, CRM, E-mail & Google Maps désactivés",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Commencez à gagner maintenant en vendant vos compétences en IA",
      "hero_title_discover": "Découvrir & Vendre",
      "hero_title_skills": "Compétences IA",
      "marketplace_search_placeholder": "Que cherchez-vous ? Demandez à l'IA...",
      "marketplace_popular_skills": "Compétences populaires",
      "marketplace_new_prompts": "Nouveaux Prompts IA",
      "plan_pro_f1": "✅ Tout ce qui est dans le forfait de base",
      "plan_pro_f2": "⚡ CRM dédié avec e-mails et dossiers intelligents",
      "plan_pro_f3": "⚡ Générateurs de campagnes (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps & Auto-Discovery Leads B2B",
      "plan_pro_f5": "⚡ Générateur de posts sociaux & Newsletters",
      "ai_requests_stat_title": "Utilisation de l'IA (Agentic AI)",
      "ai_requests_today": "Aujourd'hui:",
      "ai_requests_btn": "Paramètres IA",
      ai_greeting: "Bonjour ! Je suis votre assistant IA. Posez des questions sur les produits et services, ou laissez-moi créer un site web professionnel avec un Chatbot IA pour vous ! En poursuivant cette conversation, vous consentez automatiquement au traitement et à l'enregistrement de toutes les données fournies ici.",
      search_results_title: "Résultats de recherche sur la carte pour",
      all_companies_list_title: "Annuaire vérifié AILinkB et carte interactive",
      landing_ai_title_simple: "Comment pouvons-nous vous aider aujourd'hui ? (Recherche globale)",
      landing_ai_subtitle_simple: "Vous cherchez une entreprise, un service ou un produit ? Demandez par voix ou par texte, et je chercherai dans toute la base de données AILinkB.",
      landing_ai_placeholder_simple: "Parlez ou tapez ce que vous cherchez...",
      search_by_voice_title: "Rechercher par la voix",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Synchronisation en arrière-plan",
      sync_in_progress: "Synchronisation des e-mails en cours...",
      sync_completed_refreshing: "Terminé. Actualisation de la liste...",
      no_messages_found: "Aucun message trouvé.",
      welcome_back: "Bon retour",
      login_to_dashboard: "Connectez-vous à votre tableau de bord",
      email_address: "Adresse e-mail",
      security_pin: "Code PIN de sécurité (6 chiffres)",
      forgot_pin: "PIN oublié?",
      login_with_pin: "Se connecter avec le PIN",
      or: "OU",
      need_account: "Besoin d'un compte? Commencer la configuration",
      back_to_home: "← Retour à l'accueil",
      cancel_edit: "← Annuler la modification",
      save_profile: "Enregistrer le profil",
      save_profile_activate: "Enregistrer le profil et activer AI",
      sign_in: "Se connecter",
      "no_services_listed": "Cette entreprise n'a pas encore répertorié de services spécifiques.", "view_details": "Voir les détails", "scan_mobile": "Scannez pour ouvrir sur mobile :", "map_location": "Carte et Emplacement", "map_not_provided": "Coordonnées de la carte non fournies.", "partner_program": "Partenaire AILinkB - Recommandez et gagnez !", "affiliate_code": "Code d'affiliation :", "create_free_account": "Créer un compte", "tab_needs": "Besoins", "tab_job_offers": "Offres d'emploi", "tab_services": "Nos Services",
      "bg_color_tab": "Couleur de fond", "ai_image_tab": "Image IA", "bg_color_label": "Sélectionner la couleur d'en-tête", "bg_color_placeholder": "ex. #4f46e5", "ai_image_title": "Générer un en-tête IA", "ai_image_desc": "Générez un fond d'en-tête en entrant votre propre description. L'image sera automatiquement attachée à votre profil.", "ai_image_prompt_placeholder": "ex. Bureau moderne, panorama, couleurs vives", "ai_image_btn": "Générer l'image", "ai_image_email_req": "Veuillez d'abord fournir votre e-mail dans le formulaire d'inscription.", "ai_image_timeout": "Le délai d'attente pour la génération de l'image a expiré.",
      "live_editor_title": "Éditeur en direct : Créez votre profil d'entreprise",
      "preview_btn_top": "👁️ Aperçu (Nouvelle fenêtre)",
      "preview_btn_bottom": "👁️ Aperçu du site en direct (Nouvelle fenêtre)",
      "preview_banner_title": "APERÇU DU SITE EN TEMPS RÉEL",
      "preview_banner_desc": "Voici à quoi ressemblera votre site web terminé sur AILinkB après avoir enregistré le formulaire.",
      "preview_banner_close": "✖ Fermer l'aperçu",
      "our_services": "Nos Services",
      "about_us": "À Propos",
      "about_us_placeholder": "Entrez des informations pour l'IA, par ex. :\n• Heures de travail et règles\n• Politique de prix et réductions\n• Avantages de votre entreprise\n• FAQ (Foire aux questions)\n• Instructions pour l'IA",
      "live_ai_chat": "Aperçu du chat IA en direct",
      "service_name": "Nom du service",
      "brief_desc": "Brève description...",
      "add_service": "+ Ajouter un service",
      "install_widget": "Comment installer le widget sur votre site ?",
      "profile_link": "Votre lien de profil dédié",
      "copy": "Copier",
      "ai_learn_note": "Remarque : l'IA n'apprendra vos détails spécifiques qu'après avoir cliqué sur Enregistrer.",

      "chat_consent_label": "J'accepte la ",
      "privacy_policy_link": "Politique de confidentialité",
      "privacy_policy_title": "Politique de confidentialité",
      "privacy_policy_content": "Politique de confidentialité\nAperçu\nCette politique de confidentialité a été créée pour expliquer les règles de traitement des données personnelles obtenues via le site https://ailinkb.com/ (ci-après: le Site). Nous indiquons que nous faisons preuve de diligence raisonnable pour nous assurer que vos données personnelles sont traitées conformément aux exigences de la législation en vigueur, notamment conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 (RGPD).\n\nGestion des données\nLe traitement des données personnelles est fondé sur la licéité, la loyauté et la transparence des informations. Les données sont collectées par l\'Administrateur des données personnelles dans un but précis, explicite et légitime. L\'Administrateur des données personnelles fait tous les efforts nécessaires pour assurer la sécurité et la protection les plus élevées possibles des données personnelles qu\'il traite. La fourniture des données est volontaire. \nLes données personnelles ont été collectées par nous directement auprès de vous ou auprès d\'entités coopérant avec nous (Growbots Sp. z o.o., numéro KRS : 0000504714) pour exécuter le contrat conclu avec vous ou - dans le cas des cookies - sur la base de votre consentement.\nAdministrateur des données personnelles\nL\'Administrateur des données personnelles est : QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B Capital social 10 000 PLN (ci-après : ailinkb ou l\'Administrateur).\nToutes questions, demandes ou plaintes liées au traitement des données personnelles dans ailinkb doivent être adressées par voie électronique à l\'adresse e-mail : support@ailinkb.com, ou par écrit à l\'adresse postale de l\'Administrateur, à savoir QR-SYSTEM sp. z.o.o. Płaza ul. Graniczna 13B.\n\nType de données personnelles traitées et finalités du traitement\nNotre site Web recueille les données personnelles suivantes :\na) adresse e-mail - pour créer un compte,\nb) nom, prénom, adresse et NIP - pour les factures,\nc) numéro de carte de crédit, code CVC - pour les paiements,\nd) pour les entrepreneurs : nom de la société, REGON, adresse,\ne) données de navigation (IP, navigateur, etc.).\n\nVos données personnelles sont traitées pour : l\'exécution du Contrat (Art. 6(1)(b) RGPD) ; le respect d\'une obligation légale (Art. 6(1)(c) RGPD) ; les intérêts légitimes (Art. 6(1)(f) RGPD).\n\nVos droits (RGPD)\nVous avez le droit d\'accès (Art. 15), de rectification (Art. 16), d\'effacement (Art. 17), de limitation du traitement (Art. 18), de portabilité des données (Art. 20) et d\'opposition (Art. 21). Vous avez également le droit de déposer une plainte auprès d\'une autorité de contrôle (Art. 77 RGPD).\n\n\n\nUtilisation interdite du service :\nIl est strictement interdit d\'utiliser le Service à des fins illégales, y compris pour mener des activités criminelles, des fraudes ou d\'autres activités violant les lois généralement applicables. Dans le cas où il serait avéré qu\'un compte est utilisé à des fins illégales, l\'Administrateur se réserve le droit absolu de bloquer immédiatement ou de supprimer définitivement le compte de l\'Utilisateur sans préavis.\n\nLes questions concernant la politique de confidentialité doivent être envoyées à : support@ailinkb.com.\n\nPolitique de publication de contenu :\nLes utilisateurs publiant leurs propres documents vidéo (Prompts / Compétences) sur notre service sont tenus de déclarer explicitement dans le contenu vidéo que le matériel est publié et disponible sur la plateforme AILinkB. En téléchargeant, l'utilisateur accorde également à la plateforme AILinkB l'autorisation de publier et de promouvoir ses documents vidéo sur nos canaux de médias sociaux en son nom.",
      "cookie_title": "Ce site web utilise des cookies 🍪",
      "cookie_desc": "Nous utilisons des cookies pour vous garantir la meilleure expérience sur notre site web. En acceptant, vous consentez à notre politique de cookies. L'accès au site nécessite votre consentement.",
      "cookie_accept": "J'accepte",
      "Find Service Near You": "Trouvez un service près de chez vous",
      "search_placeholder": "Que cherchez-vous ?",
      "search_services": "Services/Produits",
      "search_purchases": "Besoins d'achat",
      "search_jobs": "Offres d'emploi",
      "title_services": "Trouvez des services près de chez vous",
      "title_purchases": "Trouvez des besoins d'achat près de chez vous",
      "title_jobs": "Trouvez des offres d'emploi près de chez vous",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Chercher",
      "no_companies_found": "Aucune entreprise trouvée.",
      "address": "Adresse:",
      "phone": "Téléphone:",
      "website": "Site Web:",
      "email": "Email:",
      "view_details": "Voir les détails",
      "chat_ai": "Chat",
      "greeting": "Bonjour ! Je suis l'assistant IA pour {{name}}.",
      "km_away": "km de distance",
      "company_details": "Détails de l'entreprise",
      "about_company": "À propos de l'entreprise:",
      "offered_services": "Services offerts:",
      "duration": "Durée",
      "mins": "min",
      "start_ai_consultation": "Démarrer la consultation IA",
      "no_details": "Aucun détail disponible.",
      "typing": "En train d'écrire...",
      "type_message": "Tapez votre message...",
      "more": "plus",
      "language": "Langue",
      "tab_map_of_partners": "Carte des partenaires",
      "tab_dashboard": "Tableau de bord",
      "tab_system_logs": "Journaux Système",
      "tab_phone_calls": "Appels Téléphoniques",
      "tab_website": "Mon Site Web",
      "tab_customers": "Clients",
      "tab_appointments": "Rendez-vous",
      "tab_email": "E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Brouillons (IA)",
      "tab_visitor_chats": "Chats visiteurs",
      "tab_orders": "Commandes",
      "tab_mail_campaigns": "Campagnes e-mail",
      "tab_ad_campaigns": "Campagnes Publicitaires (IA)",
      "tab_email_templates": "Modèles e-mail",
      "tab_blacklist": "Liste noire",
      "tab_services": "Products / Services",
      "tab_events": "Événements",
      "chat_update_offline": "Mise à jour du logiciel en cours. Vous pourrez continuer la conversation dans un instant...",
      "tab_settings": "Paramètres",
      "tab_admin_panel": "Panneau d'administration",
      "install_widget": "Installer le widget",
      "unread_emails": "E-mails non lus",
      "go_to_inbox": "Aller à la boîte de réception",
      "remaining_appointments": "Rendez-vous restants",
      "go_to_calendar": "Aller au calendrier",
      "new_orders_today": "Nouvelles commandes",
      "view_orders": "Voir les commandes",
      "total_customers": "Total des clients",
      "view_database": "Voir la base de données",
      "dashboard_chat_title": "Chat du tableau de bord",
      "dashboard_chat_desc": "Posez des questions sur vos sources de données.",
      "unread_chats": "Chats non lus",
      "knowledge_sources": "SOURCES DE CONNAISSANCES :",
      "ai_searching": "L'IA recherche dans votre base de connaissances...",
      "cal_daily_appointments": "Rendez-vous Quotidiens",
      "cal_new_appointment": "Nouveau Rendez-vous",
      "cal_reminder": "Rappel",
      "cal_meeting_details": "Détails de la Réunion",
      "cal_time": "Heure",
      "cal_agenda": "Agenda / Notes",
      "cal_no_notes": "Pas de notes.",
      "cal_confirm": "Confirmer",
      "cal_delete": "Supprimer",
      "cal_delete_confirm": "Supprimer la réunion ?",
      "cal_schedule_new": "Planifier une Nouvelle Réunion",
      "cal_meeting_title": "Titre de la Réunion",
      "cal_associated_lead": "Prospect Associé",
      "cal_search_lead": "Rechercher un prospect...",
      "cal_no_leads": "Aucun prospect trouvé",
      "cal_start_time": "Heure de Début",
      "cal_end_time": "Heure de Fin",
      "cal_cancel": "Annuler",
      "cal_schedule": "Planifier",
      "admin_title": "Panneau d'administration - Utilisateurs & Rôles",
      "admin_search_email": "Chercher E-mail",
      "admin_search_email_placeholder": "Rechercher par e-mail...",
      "admin_filter_role": "Filtrer par rôle",
      "admin_all_roles": "Tous les rôles",
      "admin_filter_status": "Filtrer par statut",
      "admin_filter_plan": "Filtrer par plan",
      "admin_clear": "Effacer",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Rôle",
      "unread_chats": "Chats non lus",
      "knowledge_sources": "SOURCES DE CONNAISSANCES :",
      "ai_searching": "L'IA recherche dans votre base de connaissances...",
      "cal_daily_appointments": "Rendez-vous Quotidiens",
      "cal_new_appointment": "Nouveau Rendez-vous",
      "cal_reminder": "Rappel",
      "cal_meeting_details": "Détails de la Réunion",
      "cal_time": "Heure",
      "cal_agenda": "Agenda / Notes",
      "cal_no_notes": "Pas de notes.",
      "cal_confirm": "Confirmer",
      "cal_delete": "Supprimer",
      "cal_delete_confirm": "Supprimer la réunion ?",
      "cal_schedule_new": "Planifier une Nouvelle Réunion",
      "cal_meeting_title": "Titre de la Réunion",
      "cal_associated_lead": "Prospect Associé",
      "cal_search_lead": "Rechercher un prospect...",
      "cal_no_leads": "Aucun prospect trouvé",
      "cal_start_time": "Heure de Début",
      "cal_end_time": "Heure de Fin",
      "cal_cancel": "Annuler",
      "cal_schedule": "Planifier",
      "admin_title": "Panneau d'administration - Utilisateurs & Rôles",
      "admin_search_email": "Chercher E-mail",
      "admin_search_email_placeholder": "Rechercher par e-mail...",
      "admin_filter_role": "Filtrer par rôle",
      "admin_all_roles": "Tous les rôles",
      "admin_filter_status": "Filtrer par statut",
      "admin_filter_plan": "Filtrer par plan",
      "admin_clear": "Effacer",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Rôle",
      "admin_subscription": "Abonnement",
      "admin_plan": "Plan",
      "admin_no_users": "Aucun utilisateur correspondant trouvé.",
      "admin_prompts_title": "Prompts IA Globaux & Comportement Système (Panneau Admin)",
      "admin_prompts_desc": "Configurez le comportement global de l'IA, le ton relationnel et les règles linguistiques. N'intégrez PAS de données spécifiques aux entreprises ici (utilisez le profil client).",
      "admin_global_rules_label": "Règles Globales de l'IA & Ton Humain Naturel",
      "admin_global_rules_desc": "Règles principales imposant une attitude naturelle, conviviale et humaine, la concision et une gestion fluide des salutations.",
      "admin_default_system_prompt_label": "Prompt Système par Défaut (Pour Nouveaux Comptes)",
      "admin_default_system_prompt_desc": "Instructions de base définissant le fonctionnement de l'IA avec la recherche vectorielle RAG.",
      "admin_autoreply_prompt_label": "Prompt d'Auto-Réponse E-mail",
      "admin_autoreply_prompt_desc": "Instructions pour l'analyse d'e-mails et la génération de brouillons au format JSON.",
      "admin_save_prompts": "Enregistrer les Prompts Globaux",
      "admin_prompts_saved": "Configurations des prompts IA globaux enregistrées avec succès !",
      "vpsMonitor.tabName": "Moniteur VPS",
      "vpsMonitor.title": "Ressources du Serveur VPS",
      "vpsMonitor.cpu": "Utilisation CPU",
      "vpsMonitor.ram": "Utilisation RAM",
      "vpsMonitor.disk": "Utilisation du disque",
      "vpsMonitor.cpuChart": "Utilisation CPU au fil du temps",
      "vpsMonitor.ramChart": "Utilisation RAM au fil du temps",
      "vpsMonitor.diskChart": "Utilisation du disque au fil du temps",
      "vpsMonitor.range1h": "Dernière heure",
      "vpsMonitor.range6h": "6 dernières heures",
      "vpsMonitor.range24h": "24 dernières heures",
      "vpsMonitor.range7d": "7 derniers jours",
      "vpsMonitor.range30d": "30 derniers jours"
}
  },

        es: {
    translation: {
        "social_publish_this_video": "Publicar este video",
        "tab_social_sub_upload": "Subida y Video",
        "tab_social_sub_skill_videos": "Videos de Skills",
        "tab_social_sub_connectors": "Conectores API",
        "tab_social_sub_comments": "Comentarios y Moderación de IA",
        "tab_social_sub_history": "Historial de Publicaciones",
        "social_tab_skill_videos": "Mis Videos de Skills",
        "social_skill_videos_title": "Mis Videos de Skills (Listos para Publicar)",
        "social_skill_videos_empty": "No se encontraron skills publicados con un archivo de video.",

        "gen_new_posts": "Generar nuevos posts",
        "copy_content": "Copiar contenido",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% IVA (pago único)",

        "pricing_options_title": "Opciones de publicación y precios",
        "pricing_yt": "1. Enlace de YouTube (requiere plan PRO)",
        "pricing_mp4": "2. Subir archivo MP4 a nuestro servidor",
        "pricing_mp4_non_pro": "1. Subir archivo MP4 a nuestro servidor",
        "pricing_order": "3. Pedir grabación de video con nosotros",
        "pricing_order_non_pro": "2. Pedir grabación de video con nosotros",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Enlace del vídeo de demostración (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Paquete del Skill (.zip, .json, .py)",
      "skill_package_placeholder": "Seleccione el archivo del skill...",
      "skill_description": "Descripción e instrucciones del Skill",
      "skill_description_placeholder": "¿Cómo usar este skill?",
      "skill_tags": "Etiquetas / Tecnologías",
      "skill_tags_placeholder": "Seleccionar tecnologías...",
      "login_action": "Iniciar sesión",
      "create_account_action": "Crear cuenta",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "Auditoría SEO",
        "seo_audit_title": "Auditoría SEO Global",
        "seo_audit_desc": "Escanea todos los sitios web de los clientes para verificar la corrección de SEO, SSL, RWD e indexación de Google.",
        "seo_audit_resume": "Reanudar auditoría",
        "seo_audit_new": "Nueva auditoría",
        "seo_audit_scanning": "Escaneando...",
        "seo_audit_confirm": "¿Está seguro de que desea iniciar una auditoría completamente nueva? El informe anterior se guardará como versión de archivo.", "btn_compose": "Redactar","label_system": "Sistema",
      "label_basic_package": "Paquete Básico", 
      "label_premium_modules": "Módulos Premium", 
      "tab_google_maps": "Google Maps (IA)", 
      "tab_affiliate": "Programa de Afiliados",
      
        ask_ai: "Preguntar a IA",
        btn_clear_to_trash: "Mover a la papelera",
        empty_trash_btn: "Vaciar papelera",
        filter_unread_btn: "🔵 Mostrar no leídos",
        filter_unread_active: "🔵 Solo no leídos (Activo)",
      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      calls_title: "Llamadas y Ajustes de AI Voice",
      calls_description: "Configure su número Twilio y clave API de OpenAI.",
      calls_instruction_title: "Instrucciones de Configuración",
      calls_instruction_desc: "¿No sabe cómo configurarlo? Descargue nuestra guía: ",
      calls_instruction_link: "Descargar Guía (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Clave API de OpenAI",
      ai_voice_system_prompt_label: "Instrucciones del Agente de Voz",
      ai_voice_system_prompt_desc: "Deje en blanco para comportamiento por defecto.",
      ai_voice_system_prompt_placeholder: "Por defecto: Eres un asistente de voz...",
      webhook_config_title: "Configuración de Webhook de Twilio",
      webhook_config_desc: "Copie la URL a continuación en Twilio:",
      webhook_url: "URL del Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Guardar",
      save_success_title: "Guardado",
      save_success_desc: "Guardado exitosamente.",
      save_error_title: "Error",
      save_error_desc: "Error al guardar.",
      tab_voice_config: "Configuración AI Voice",
      tab_voice_history: "Historial de Llamadas",

      analytics_buy_tokens: "Comprar tokens de IA", analytics_package_desc: "1 paquete = 100.000 tokens (50 PLN neto)", analytics_buy_btn: "Comprar por {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Días", time_30d: "30 Días", time_3m: "3 Meses", time_6m: "6 Meses",
      
      analytics_chart2_legend: "Llamadas activas (Redis)",
      analytics_chart2_desc: "Número de sesiones de voz Redis activas a lo largo del tiempo",
      analytics_chart2_title: "Llamadas de voz activas en vivo",
      analytics_chart1_legend_voice: "Tokens Sesiones de Voz",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Desglose histórico y actual del uso de tokens del chat de texto y sesiones de voz",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Estado de la cuenta: Bloqueada (403)",
      analytics_status_ok: "Estado de la cuenta: Activa (OK)",
      analytics_available_credits_title: "Créditos de IA disponibles",
      analytics_active_calls_desc: "Obtenido directamente de Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Sesiones de voz activas (Redis)",
      analytics_refresh: "Actualizar métricas",
      analytics_last_updated: "Última actualización: ",
      analytics_panel_desc: "Métricas de sesiones de voz, uso de tokens de IA y saldo de créditos en tiempo real",
      analytics_panel_title: "Panel de Análisis y Uso de Recursos",
      analytics_model: "Modelo",
      analytics_cost: "Costo (Créditos)",
      analytics_tokens_comp: "Tokens de finalización",
      analytics_tokens_prompt: "Tokens de prompt",
      analytics_date: "Fecha",
      analytics_history: "Historial de consultas LLM (Últimas 10)",
      analytics_limit_exceeded: "⚠️ ¡Límite de créditos superado! Los servicios de IA (Chat y Voz) han sido bloqueados.",
      analytics_limit_total: "Límite total: ",
      analytics_credits_used: "Créditos usados: ",
      analytics_credits_available: "Créditos disponibles: ",
      analytics_credits_available_pct: "Disponible",
      analytics_credits_progress: "Uso de créditos de IA (Barra de progreso)",
      analytics_voice_minutes_rate: "Tarifa por minuto convertida para sesiones telefónicas",
      analytics_voice_minutes: "Uso de minutos de Voice AI",
      openai_api_key_voice: "Clave API de OpenAI (Realtime Voice)",
      tab_calls: "Llamadas",
      calls_title: "Configuración del asistente de voz",
      twilio_phone_number: "Número de teléfono de Twilio",
      save_calls_settings: "Guardar configuración de voz",
      add_product: "Añadir Producto / Servicio",
      new_product_def: "Definición de nuevo producto / servicio",
      product_name: "Nombre del Producto / Servicio",
      price: "Precio",
      currency: "Moneda",
      hidden_ai_only: "Oculto en el perfil público (solo para IA)",
      ai_knowledge_desc: "Descripción (¿Qué debería aprender la IA sobre este producto?)",
      save_product: "Guardar Producto / Servicio",
      update_product: "Guardar cambios",
      confirm_delete: "¿Estás seguro de que quieres eliminar este producto?",
      delete: "Eliminar",
      no_products_yet: "Todavía no hay productos ni servicios. Añade tu primer producto.",
      "logout": "Cerrar sesión",
      "bg_color_tab": "Color de fondo", "ai_image_tab": "Imagen de IA", "bg_color_label": "Seleccionar color de encabezado", "bg_color_placeholder": "ej. #4f46e5", "ai_image_title": "Generar encabezado de IA (ComfyUI)", "ai_image_desc": "Genere un fondo de encabezado ingresando su propio prompt. La imagen se adjuntará automáticamente a su perfil.", "ai_image_prompt_placeholder": "ej. Oficina moderna, panorama, colores brillantes", "ai_image_btn": "Generar imagen", "ai_image_email_req": "Por favor, introduzca primero su correo electrónico en el formulario de registro.", "ai_image_timeout": "El tiempo de espera para la generación de la imagen ha expirado.",
      "btn_activate_subscription": "Activar este plan",
      "btn_active_current": "Plan Actual",
      "error_accept_terms": "Debes aceptar los términos para continuar.",
      "trial_expired_title": "🛑 Pago Requerido",
      "trial_expired_desc": "Para seguir usando tu Tarjeta de Presentación IA y herramientas, elige un plan de suscripción a continuación.",
      "plan_upgrade_success_basic": "¡Felicidades! Plan activado: Tarjeta IA + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "¡Felicidades! Plan activado: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Plan Tarjeta de Presentación IA + Chatbot",
      "plan_basic_price": "100 PLN neto (123 PLN bruto) / mes",
      "plan_basic_desc": "Paquete de inicio ideal. Incluye la gestión completa de tu perfil público y formación del chatbot:",
      "plan_basic_f1": "✅ Tarjeta de Presentación IA (Perfil Público)",
      "plan_basic_f2": "✅ Entrenamiento de Chatbot IA",
      "plan_basic_f3": "✅ Ofertas de trabajo y eventos de empresa",
      "plan_basic_f4": "🔒 Anuncios, CRM, Correo y Google Maps están deshabilitados",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Empieza a ganar ahora vendiendo tus habilidades de IA",
      "hero_title_discover": "Descubrir & Vender",
      "hero_title_skills": "Habilidades de IA",
      "marketplace_search_placeholder": "¿Qué estás buscando? Pregunta a la IA...",
      "marketplace_popular_skills": "Habilidades Populares",
      "marketplace_new_prompts": "Nuevos Prompts de IA",
      "plan_pro_f1": "✅ Todo en el Plan Básico",
      "plan_pro_f2": "⚡ CRM dedicado con correos inteligentes",
      "plan_pro_f3": "⚡ Generadores de campañas (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps y Auto-Discovery B2B Leads",
      "plan_pro_f5": "⚡ Generador de Publicaciones y Newsletters",
      "ai_requests_stat_title": "Uso de IA (Agentic AI)",
      "ai_requests_today": "Hoy:",
      "ai_requests_btn": "Ajustes de IA",
      ai_greeting: "¡Hola! Soy tu asistente de IA. Pregunta sobre productos y servicios, ¡o déjame crear un sitio web profesional con un Chatbot de IA para ti! Al continuar esta conversación, usted acepta automáticamente el procesamiento y almacenamiento de todos los datos proporcionados aquí.",
      search_results_title: "Resultados de búsqueda en el mapa para",
      all_companies_list_title: "Directorio verificado de AILinkB y mapa interactivo",
      landing_ai_title_simple: "¿Cómo podemos ayudarle hoy? (Búsqueda global)",
      landing_ai_subtitle_simple: "¿Busca una empresa, servicio o producto? Pregunte por voz o texto y buscaré en toda la base de datos de AILinkB.",
      landing_ai_placeholder_simple: "Hable o escriba lo que busca...",
      search_by_voice_title: "Buscar por voz",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Sincronización en segundo plano",
      sync_in_progress: "Sincronizando correos...",
      sync_completed_refreshing: "Completado. Actualizando lista...",
      no_messages_found: "No se encontraron mensajes.",
      welcome_back: "Bienvenido de nuevo",
      login_to_dashboard: "Inicie sesión en su panel",
      email_address: "Dirección de correo electrónico",
      security_pin: "PIN de seguridad (6 dígitos)",
      forgot_pin: "¿Olvidaste tu PIN?",
      login_with_pin: "Iniciar sesión con PIN",
      or: "O",
      need_account: "¿Necesitas una cuenta? Iniciar configuración",
      back_to_home: "← Volver al inicio",
      cancel_edit: "← Cancelar edición",
      save_profile: "Guardar perfil",
      save_profile_activate: "Guardar perfil y activar IA",
      sign_in: "Iniciar sesión",
      "bg_color_tab": "Color de fondo", "ai_image_tab": "Imagen de IA", "bg_color_label": "Seleccionar color de encabezado", "bg_color_placeholder": "ej. #4f46e5", "ai_image_title": "Generar encabezado de IA", "ai_image_desc": "Genere un fondo de encabezado ingresando su propio prompt. La imagen se adjuntará automáticamente a su perfil.", "ai_image_prompt_placeholder": "ej. Oficina moderna, panorama, colores brillantes", "ai_image_btn": "Generar imagen", "ai_image_email_req": "Por favor, introduzca primero su correo electrónico en el formulario de registro.", "ai_image_timeout": "El tiempo de espera para la generación de la imagen ha expirado.",
      "live_editor_title": "Editor en vivo: Crea tu perfil de empresa",
      "preview_btn_top": "👁️ Vista previa (Nueva ventana)",
      "preview_btn_bottom": "👁️ Vista previa del sitio web (Nueva ventana)",
      "preview_banner_title": "VISTA PREVIA DEL SITIO EN TIEMPO REAL",
      "preview_banner_desc": "Así se verá tu sitio web completo en AILinkB después de guardar el formulario.",
      "preview_banner_close": "✖ Cerrar vista previa",
      "our_services": "Nuestros Servicios",
      "about_us": "Sobre Nosotros",
      "about_us_placeholder": "Ingrese información para que la IA la use, ej.:\n• Horario de trabajo y reglas\n• Política de precios y descuentos\n• Ventajas de su empresa\n• FAQ (preguntas frecuentes)\n• Instrucciones para la IA",
      "live_ai_chat": "Vista previa del chat de IA en vivo",
      "service_name": "Nombre del servicio",
      "brief_desc": "Breve descripción...",
      "add_service": "+ Agregar servicio",
      "install_widget": "¿Cómo instalar el widget en su sitio?",
      "profile_link": "Su enlace de perfil dedicado",
      "copy": "Copiar",
      "ai_learn_note": "Nota: la IA solo aprenderá sus detalles específicos después de hacer clic en Guardar.",

      "chat_consent_label": "Acepto la ",
      "privacy_policy_link": "Política de Privacidad",
      "privacy_policy_title": "Política de Privacidad",
      "privacy_policy_content": "El responsable del tratamiento de datos es QR-SYSTEM sp.z.o.o Płaza ul. Graniczna 13B, Capital Social 10 000 PLN. Al utilizar nuestro chat de IA, acepta que su correo electrónico y datos de conversación sean procesados. El asistente de IA proporciona respuestas basadas en el contexto disponible y su precisión depende de las capacidades del sistema. Según el RGPD, tiene derecho a acceder, rectificar o borrar sus datos personales (Derecho al olvido). Para solicitar la eliminación de sus datos, simplemente envíenos un correo electrónico. También tiene derecho a presentar una queja ante una autoridad de control de protección de datos.\n\nPolítica de publicación de contenido:\nLos usuarios que publiquen sus propios materiales de video (Prompts / Habilidades) en nuestro servicio deben indicar explícitamente en el contenido del video que el material está publicado y disponible en la plataforma AILinkB. Al subirlo, el usuario también otorga permiso para que la plataforma AILinkB publique y promocione sus materiales de video en nuestros canales de redes sociales en su nombre.",
      "cookie_title": "Este sitio web utiliza cookies 🍪",
      "cookie_desc": "Utilizamos cookies para asegurarnos de que obtenga la mejor experiencia en nuestro sitio web. Al aceptar, consiente nuestra política de cookies. El acceso al sitio requiere su consentimiento.",
      "cookie_accept": "Acepto",
      "Find Service Near You": "Encuentra un servicio cerca de ti",
      "search_placeholder": "¿Qué estás buscando?",
      "search_services": "Servicios/Productos",
      "search_purchases": "Necesidades de compra",
      "search_jobs": "Ofertas de trabajo",
      "title_services": "Encuentra servicios cerca de ti",
      "title_purchases": "Encuentra necesidades de compra cerca de ti",
      "title_jobs": "Encuentra ofertas de trabajo cerca de ti",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Buscar",
      "no_companies_found": "Aún no se han encontrado empresas.",
      "address": "Dirección:",
      "phone": "Teléfono:",
      "website": "Sitio web:",
      "email": "Correo electrónico:",
      "view_details": "Ver detalles",
      "chat_ai": "Chat",
      "greeting": "¡Hola! Soy el asistente de IA para {{name}}.",
      "km_away": "km de distancia",
      "company_details": "Detalles de la empresa",
      "about_company": "Acerca de la empresa:",
      "offered_services": "Servicios ofrecidos:",
      "duration": "Duración",
      "mins": "min",
      "start_ai_consultation": "Iniciar consulta de IA",
      "no_details": "No hay detalles disponibles.",
      "typing": "Escribiendo...",
      "type_message": "Escribe tu mensaje...",
      "more": "más",
      "language": "Idioma",
      "tab_map_of_partners": "Mapa de socios",
      "tab_dashboard": "Panel",
      "tab_system_logs": "Registros del Sistema",
      "tab_phone_calls": "Llamadas Telefónicas",
      "tab_website": "Mi Sitio Web",
      "tab_customers": "Clientes",
      "tab_appointments": "Citas",
      "tab_email": "Correo",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Borradores (IA)",
      "tab_visitor_chats": "Chats de visitantes",
      "tab_orders": "Pedidos",
      "tab_mail_campaigns": "Campañas de correo",
      "tab_ad_campaigns": "Campañas de Anuncios (IA)",
      "tab_email_templates": "Plantillas de correo",
      "tab_blacklist": "Lista negra",
      "tab_services": "Servicios",
      "tab_events": "Eventos",
      "chat_update_offline": "Actualización de software en curso. Podrá continuar la conversación en un momento...",
      "tab_settings": "Ajustes",
      "tab_admin_panel": "Panel de administración",
      "install_widget": "Instalar widget",
      "unread_emails": "Correos no leídos",
      "go_to_inbox": "Ir a la bandeja de entrada",
      "remaining_appointments": "Citas restantes",
      "go_to_calendar": "Ir al calendario",
      "new_orders_today": "Nuevos pedidos hoy",
      "view_orders": "Ver pedidos",
      "total_customers": "Clientes totales",
      "view_database": "Ver base de datos",
      "dashboard_chat_title": "Chat del panel",
      "dashboard_chat_desc": "Haga preguntas basadas en sus datos.",
      "unread_chats": "Chats no leídos",
      "knowledge_sources": "FUENTES DE CONOCIMIENTO:",
      "ai_searching": "La IA está buscando en su base de conocimientos...",
      "cal_daily_appointments": "Citas Diarias",
      "cal_new_appointment": "Nueva Cita",
      "cal_reminder": "Recordatorio",
      "cal_meeting_details": "Detalles de la Reunión",
      "cal_time": "Hora",
      "cal_agenda": "Agenda / Notas",
      "cal_no_notes": "Sin notas.",
      "cal_confirm": "Confirmar",
      "cal_delete": "Eliminar",
      "cal_delete_confirm": "¿Eliminar reunión?",
      "cal_schedule_new": "Programar Nueva Reunión",
      "cal_meeting_title": "Título de la Reunión",
      "cal_associated_lead": "Cliente Potencial Asociado",
      "cal_search_lead": "Buscar un cliente...",
      "cal_no_leads": "No se encontraron clientes",
      "cal_start_time": "Hora de Inicio",
      "cal_end_time": "Hora de Fin",
      "cal_cancel": "Cancelar",
      "cal_schedule": "Programar",
      "admin_title": "Panel de Administración - Usuarios y Roles",
      "admin_search_email": "Buscar Correo",
      "admin_search_email_placeholder": "Buscar por correo electrónico...",
      "admin_filter_role": "Filtrar por rol",
      "admin_all_roles": "Todos los roles",
      "admin_filter_status": "Filtrar por estado",
      "admin_filter_plan": "Filtrar por plan",
      "admin_clear": "Limpiar",
      "admin_id": "ID",
      "admin_email": "Correo electrónico",
      "admin_company": "Empresa",
      "admin_role": "Rol",
      "admin_subscription": "Suscripción",
      "admin_plan": "Plan",
      "admin_no_users": "No se encontraron usuarios coincidentes.",
      "admin_prompts_title": "Prompts de IA Globales y Comportamiento del Sistema (Panel Admin)",
      "admin_prompts_desc": "Configure el comportamiento general del chatbot, el tono de conversación y las reglas lingüísticas. NO añada datos específicos de empresas aquí (use el perfil de cliente).",
      "admin_global_rules_label": "Reglas Globales de IA y Tono Humano Natural",
      "admin_global_rules_desc": "Reglas principales para un comportamiento natural, amigable y similar a un humano, concisión y manejo fluido de saludos.",
      "admin_default_system_prompt_label": "Prompt de Sistema por Defecto (Para Nuevas Empresas)",
      "admin_default_system_prompt_desc": "Instrucciones básicas que definen la interacción de la IA con la búsqueda vectorial RAG.",
      "admin_autoreply_prompt_label": "Prompt de Respuesta Automática por E-mail",
      "admin_autoreply_prompt_desc": "Instrucciones para analizar correos y redactar borradores en formato JSON.",
      "admin_save_prompts": "Guardar Prompts Globales",
      "admin_prompts_saved": "¡Configuraciones de prompts de IA globales guardadas con éxito!",
      "vpsMonitor.tabName": "Monitor VPS",
      "vpsMonitor.title": "Recursos del Servidor VPS",
      "vpsMonitor.cpu": "Uso de CPU",
      "vpsMonitor.ram": "Uso de RAM",
      "vpsMonitor.disk": "Uso de disco",
      "vpsMonitor.cpuChart": "Uso de CPU a lo largo del tiempo",
      "vpsMonitor.ramChart": "Uso de RAM a lo largo del tiempo",
      "vpsMonitor.diskChart": "Uso de disco a lo largo del tiempo",
      "vpsMonitor.range1h": "Última hora",
      "vpsMonitor.range6h": "Últimas 6 horas",
      "vpsMonitor.range24h": "Últimas 24 horas",
      "vpsMonitor.range7d": "Últimos 7 días",
      "vpsMonitor.range30d": "Últimos 30 días"
}
  },

        it: {
    translation: {
        "social_publish_this_video": "Pubblica questo video",
        "tab_social_sub_upload": "Caricamento e Video",
        "tab_social_sub_skill_videos": "Video di Skills",
        "tab_social_sub_connectors": "Connettori API",
        "tab_social_sub_comments": "Commenti e Moderazione IA",
        "tab_social_sub_history": "Cronologia delle Pubblicazioni",
        "social_tab_skill_videos": "I miei Video di Skills",
        "social_skill_videos_title": "I miei Video di Skills (Pronti per la Pubblicazione)",
        "social_skill_videos_empty": "Nessun skill pubblicato con un file video trovato.",

        "gen_new_posts": "Genera nuovi post",
        "copy_content": "Copia contenuto",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% IVA (una tantum)",

        "pricing_options_title": "Opzioni di pubblicazione e prezzi",
        "pricing_yt": "1. Link YouTube (richiede il piano PRO)",
        "pricing_mp4": "2. Carica file MP4 sul nostro server",
        "pricing_mp4_non_pro": "1. Carica file MP4 sul nostro server",
        "pricing_order": "3. Ordina la registrazione video da noi",
        "pricing_order_non_pro": "2. Ordina la registrazione video da noi",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Link del video di presentazione (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Pacchetto Skill (.zip, .json, .py)",
      "skill_package_placeholder": "Seleziona file skill...",
      "skill_description": "Descrizione e Istruzioni Skill",
      "skill_description_placeholder": "Come usare questa skill?",
      "skill_tags": "Tag / Tecnologie",
      "skill_tags_placeholder": "Seleziona tecnologie...",
      "login_action": "Accedi",
      "create_account_action": "Crea account",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "Audit SEO",
        "seo_audit_title": "Audit SEO Globale",
        "seo_audit_desc": "Scansiona tutti i siti web dei clienti per verificare la correttezza SEO, SSL, RWD e indicizzazione Google.",
        "seo_audit_resume": "Riprendi audit",
        "seo_audit_new": "Nuovo audit",
        "seo_audit_scanning": "Scansione...",
        "seo_audit_confirm": "Sei sicuro di voler avviare un audit completamente nuovo? Il rapporto precedente verrà salvato come versione di archivio.", "btn_compose": "Componi","label_system": "Sistema",
      "label_basic_package": "Pacchetto Base", 
      "label_premium_modules": "Moduli Premium", 
      "tab_google_maps": "Google Maps (IA)", 
      "tab_affiliate": "Programma di Affiliazione",
      
        ask_ai: "Chiedi all'IA",
        btn_clear_to_trash: "Sposta nel cestino",
        empty_trash_btn: "Svuota cestino",
        filter_unread_btn: "🔵 Mostra non letti",
        filter_unread_active: "🔵 Solo non letti (Attivo)",
      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      calls_title: "Chiamate e Impostazioni AI Voice",
      calls_description: "Configura il numero Twilio e la chiave API OpenAI.",
      calls_instruction_title: "Istruzioni",
      calls_instruction_desc: "Scarica la nostra guida passo-passo: ",
      calls_instruction_link: "Scarica Guida (PDF)",
      twilio_phone_number: "Numero Twilio",
      openai_voice_api_key: "Chiave API OpenAI",
      ai_voice_system_prompt_label: "Istruzioni Agente Vocale",
      ai_voice_system_prompt_desc: "Lascia vuoto per default.",
      ai_voice_system_prompt_placeholder: "Default...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copia l'URL in Twilio:",
      webhook_url: "URL Webhook",
      btn_copy: "Copia",
      btn_copied: "Copiato",
      btn_save_config: "Salva",
      save_success_title: "Salvato",
      save_success_desc: "Salvato con successo.",
      save_error_title: "Errore",
      save_error_desc: "Errore.",
      tab_voice_config: "Configurazione AI Voice",
      tab_voice_history: "Cronologia Chiamate",

      analytics_buy_tokens: "Acquista token IA", analytics_package_desc: "1 pacchetto = 100.000 token (50 PLN netto)", analytics_buy_btn: "Acquista a {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Giorni", time_30d: "30 Giorni", time_3m: "3 Mesi", time_6m: "6 Mesi",
      
      analytics_chart2_legend: "Chiamate attive (Redis)",
      analytics_chart2_desc: "Numero di sessioni vocali Redis attive nel tempo",
      analytics_chart2_title: "Chiamate vocali attive in diretta",
      analytics_chart1_legend_voice: "Token Sessioni Vocali",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Suddivisione storica e attuale dell'utilizzo dei token della chat testuale e delle sessioni vocali",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Stato account: Bloccato (403)",
      analytics_status_ok: "Stato account: Attivo (OK)",
      analytics_available_credits_title: "Crediti IA disponibili",
      analytics_active_calls_desc: "Recuperato direttamente da Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Sessioni vocali attive (Redis)",
      analytics_refresh: "Aggiorna metriche",
      analytics_last_updated: "Ultimo aggiornamento: ",
      analytics_panel_desc: "Metriche delle sessioni vocali, utilizzo dei token IA e saldo crediti in tempo reale",
      analytics_panel_title: "Pannello Analitico e Utilizzo Risorse",
      analytics_model: "Modello",
      analytics_cost: "Costo (Crediti)",
      analytics_tokens_comp: "Token di completamento",
      analytics_tokens_prompt: "Token del prompt",
      analytics_date: "Data",
      analytics_history: "Cronologia query LLM (Ultime 10)",
      analytics_limit_exceeded: "⚠️ Limite crediti superato! I servizi IA (Chat e Voce) sono stati bloccati.",
      analytics_limit_total: "Limite totale: ",
      analytics_credits_used: "Crediti utilizzati: ",
      analytics_credits_available: "Crediti disponibili: ",
      analytics_credits_available_pct: "Disponibile",
      analytics_credits_progress: "Utilizzo crediti IA (Barra di avanzamento)",
      analytics_voice_minutes_rate: "Tariffa al minuto convertita per sessioni telefoniche",
      analytics_voice_minutes: "Utilizzo minuti Voice AI",
      openai_api_key_voice: "Chiave API OpenAI (Realtime Voice)",
      tab_calls: "Chiamate",
      calls_title: "Impostazioni assistente vocale",
      twilio_phone_number: "Numero di telefono Twilio",
      save_calls_settings: "Salva impostazioni vocali",
      add_product: "Aggiungi Prodotto / Servizio",
      new_product_def: "Definizione del nuovo prodotto / servizio",
      product_name: "Nome Prodotto / Servizio",
      price: "Prezzo",
      currency: "Valuta",
      hidden_ai_only: "Nascosto sul profilo pubblico (solo per IA)",
      ai_knowledge_desc: "Descrizione (Cosa dovrebbe imparare l'IA su questo prodotto?)",
      save_product: "Salva Prodotto / Servizio",
      update_product: "Salva modifiche",
      confirm_delete: "Sei sicuro di voler eliminare questo prodotto?",
      delete: "Elimina",
      no_products_yet: "Ancora nessun prodotto o servizio. Aggiungi il tuo primo prodotto.",
      "logout": "Esci",
      "bg_color_tab": "Colore di sfondo", "ai_image_tab": "Immagine AI", "bg_color_label": "Seleziona colore intestazione", "bg_color_placeholder": "es. #4f46e5", "ai_image_title": "Genera Intestazione AI (ComfyUI)", "ai_image_desc": "Genera uno sfondo per l'intestazione inserendo il tuo prompt. L'immagine verrà automaticamente allegata al tuo profilo.", "ai_image_prompt_placeholder": "es. Ufficio moderno, skyline, colori vivaci", "ai_image_btn": "Genera immagine", "ai_image_email_req": "Si prega di fornire prima la propria email nel modulo di registrazione.", "ai_image_timeout": "Tempo di attesa per la generazione dell'immagine scaduto.",
      "btn_activate_subscription": "Attiva questo piano",
      "btn_active_current": "Piano Attuale",
      "error_accept_terms": "Devi accettare i termini per continuare.",
      "trial_expired_title": "🛑 Pagamento Richiesto",
      "trial_expired_desc": "Per continuare a utilizzare il tuo Biglietto da Visita IA e gli strumenti, scegli un abbonamento.",
      "plan_upgrade_success_basic": "Congratulazioni! Piano attivato: Biglietto IA + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Congratulazioni! Piano attivato: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Piano Biglietto da Visita IA + Chatbot",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN lordo) / mese",
      "plan_basic_desc": "Pacchetto base ideale. Include la gestione del profilo pubblico IA e la formazione del chatbot:",
      "plan_basic_f1": "✅ Biglietto da Visita IA (Profilo Pubblico)",
      "plan_basic_f2": "✅ Addestramento Chatbot IA",
      "plan_basic_f3": "✅ Offerte di lavoro e eventi",
      "plan_basic_f4": "🔒 Annunci, CRM, Email e Google Maps disabilitati",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Inizia a guadagnare ora vendendo le tue competenze AI",
      "hero_title_discover": "Scopri & Vendi",
      "hero_title_skills": "Competenze AI",
      "marketplace_search_placeholder": "Cosa stai cercando? Chiedi all'IA...",
      "marketplace_popular_skills": "Competenze Popolari",
      "marketplace_new_prompts": "Nuovi Prompt AI",
      "plan_pro_f1": "✅ Tutto nel piano Base",
      "plan_pro_f2": "⚡ CRM dedicato con email intelligenti",
      "plan_pro_f3": "⚡ Generatori campagne Ads (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps e Auto-Discovery B2B",
      "plan_pro_f5": "⚡ Generatore Social Media & Newsletter",
      "ai_requests_stat_title": "Utilizzo IA (Agentic AI)",
      "ai_requests_today": "Oggi:",
      "ai_requests_btn": "Impostazioni IA",
      ai_greeting: "Ciao! Sono il tuo assistente AI. Chiedi informazioni su prodotti e servizi, oppure lascia che crei un sito web professionale con un Chatbot AI per te! Continuando questa conversazione, acconsenti automaticamente al trattamento e al salvataggio di tutti i dati forniti qui.",
      search_results_title: "Risultati di ricerca sulla mappa per",
      all_companies_list_title: "Directory verificata di AILinkB e mappa interattiva",
      landing_ai_title_simple: "Come possiamo aiutarti oggi? (Ricerca globale)",
      landing_ai_subtitle_simple: "Cerchi un'azienda, un servizio o un prodotto? Chiedilo a voce o tramite testo e cercherò nell'intero database di AILinkB.",
      landing_ai_placeholder_simple: "Parla o digita cosa stai cercando...",
      search_by_voice_title: "Cerca con la voce",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Sincronizzazione in background",
      sync_in_progress: "Sincronizzazione e-mail in corso...",
      sync_completed_refreshing: "Completato. Aggiornamento elenco...",
      no_messages_found: "Nessun messaggio trovato.",
      welcome_back: "Bentornato",
      login_to_dashboard: "Accedi alla tua dashboard",
      email_address: "Indirizzo e-mail",
      security_pin: "PIN di sicurezza (6 cifre)",
      forgot_pin: "PIN dimenticato?",
      login_with_pin: "Accedi con PIN",
      or: "OPPURE",
      need_account: "Hai bisogno di un account? Inizia la configurazione",
      back_to_home: "← Torna alla home",
      cancel_edit: "← Annulla modifica",
      save_profile: "Salva profilo",
      save_profile_activate: "Salva profilo e attiva IA",
      sign_in: "Accedi",
      "bg_color_tab": "Colore di sfondo", "ai_image_tab": "Immagine AI", "bg_color_label": "Seleziona colore intestazione", "bg_color_placeholder": "es. #4f46e5", "ai_image_title": "Genera Intestazione AI", "ai_image_desc": "Genera uno sfondo per l'intestazione inserendo il tuo prompt. L'immagine verrà automaticamente allegata al tuo profilo.", "ai_image_prompt_placeholder": "es. Ufficio moderno, skyline, colori vivaci", "ai_image_btn": "Genera immagine", "ai_image_email_req": "Si prega di fornire prima la propria email nel modulo di registrazione.", "ai_image_timeout": "Tempo di attesa per la generazione dell'immagine scaduto.",
      "live_editor_title": "Editor dal vivo: Crea il profilo della tua azienda",
      "preview_btn_top": "👁️ Anteprima (Nuova finestra)",
      "preview_btn_bottom": "👁️ Anteprima del sito web dal vivo (Nuova finestra)",
      "preview_banner_title": "ANTEPRIMA DEL SITO IN TEMPO REALE",
      "preview_banner_desc": "Ecco come apparirà il tuo sito web completato su AILinkB dopo aver salvato il modulo.",
      "preview_banner_close": "✖ Chiudi anteprima",
      "our_services": "I Nostri Servizi",
      "about_us": "Chi Siamo",
      "about_us_placeholder": "Inserisci informazioni per l'IA, es.:\n• Orari di lavoro e regole\n• Politica dei prezzi e sconti\n• Vantaggi della tua azienda\n• FAQ (domande frequenti)\n• Istruzioni per l'IA",
      "live_ai_chat": "Anteprima Chat IA dal vivo",
      "service_name": "Nome del servizio",
      "brief_desc": "Breve descrizione...",
      "add_service": "+ Aggiungi servizio",
      "install_widget": "Come installare il widget sul tuo sito?",
      "profile_link": "Il tuo link al profilo dedicato",
      "copy": "Copia",
      "ai_learn_note": "Nota: l'IA imparerà i tuoi dettagli specifici solo dopo aver cliccato su Salva.",

      "chat_consent_label": "Accetto l'",
      "privacy_policy_link": "Informativa sulla privacy",
      "privacy_policy_title": "Informativa sulla privacy",
      "privacy_policy_content": "Il Titolare del trattamento dei dati è QR-SYSTEM sp.z.o.o Płaza ul. Graniczna 13B, Capitale sociale 10 000 PLN. Utilizzando la nostra chat IA, accetti che la tua email e i dati della conversazione vengano elaborati. L'assistente IA fornisce risposte in base al contesto disponibile e la sua precisione dipende dalle capacità del sistema. Ai sensi del GDPR, hai il diritto di accedere, rettificare o cancellare i tuoi dati personali (Diritto all'oblio). Per richiedere la cancellazione dei tuoi dati, è sufficiente inviarci un'email. Hai anche il diritto di presentare un reclamo a un'autorità di controllo per la protezione dei dati.\n\nPolitica di pubblicazione dei contenuti:\nGli utenti che pubblicano i propri materiali video (Prompt / Skill) sul nostro servizio sono tenuti a dichiarare esplicitamente nel contenuto del video che il materiale è pubblicato e disponibile sulla piattaforma AILinkB. Caricando il file, l'utente concede inoltre alla piattaforma AILinkB l'autorizzazione a pubblicare e promuovere i propri materiali video sui nostri canali social per suo conto.",
      "cookie_title": "Questo sito web utilizza i cookie 🍪",
      "cookie_desc": "Utilizziamo i cookie per assicurarti la migliore esperienza sul nostro sito web. Accettando, acconsenti alla nostra politica sui cookie. L'accesso al sito richiede il tuo consenso.",
      "cookie_accept": "Accetto",
      "Find Service Near You": "Trova un servizio vicino a te",
      "search_placeholder": "Cosa stai cercando?",
      "search_services": "Servizi/Prodotti",
      "search_purchases": "Esigenze di acquisto",
      "search_jobs": "Offerte di lavoro",
      "title_services": "Trova servizi vicino a te",
      "title_purchases": "Trova esigenze di acquisto vicino a te",
      "title_jobs": "Trova offerte di lavoro vicino a te",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Cerca",
      "no_companies_found": "Nessuna azienda trovata.",
      "address": "Indirizzo:",
      "phone": "Telefono:",
      "website": "Sito web:",
      "email": "Email:",
      "view_details": "Vedi dettagli",
      "chat_ai": "Chat",
      "greeting": "Ciao! Sono l'assistente IA per {{name}}.",
      "km_away": "km di distanza",
      "company_details": "Dettagli dell'azienda",
      "about_company": "Informazioni sull'azienda:",
      "offered_services": "Servizi offerti:",
      "duration": "Durata",
      "mins": "min",
      "start_ai_consultation": "Inizia la consultazione IA",
      "no_details": "Nessun dettaglio disponibile.",
      "typing": "Sta scrivendo...",
      "type_message": "Scrivi il tuo messaggio...",
      "more": "di più",
      "language": "Lingua",
      "tab_map_of_partners": "Mappa dei partner",
      "tab_dashboard": "Dashboard",
      "tab_system_logs": "Log di Sistema",
      "tab_phone_calls": "Chiamate Telefoniche",
      "tab_website": "Il Mio Sito",
      "tab_clienti": "Clienti",
      "tab_appointments": "Appuntamenti",
      "tab_email": "E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Bozze (IA)",
      "tab_visitor_chats": "Chat visitatori",
      "tab_orders": "Ordini",
      "tab_mail_campaigns": "Campagne e-mail",
      "tab_ad_campaigns": "Campagne Pubblicitarie (IA)",
      "tab_email_templates": "Modelli e-mail",
      "tab_blacklist": "Lista nera",
      "tab_services": "Servizi",
      "tab_events": "Eventi",
      "chat_update_offline": "Aggiornamento del software in corso. Potrai continuare la conversazione tra un attimo...",
      "tab_settings": "Impostazioni",
      "tab_admin_panel": "Pannello di amministrazione",
      "install_widget": "Installa Widget",
      "unread_emails": "Email non lette",
      "go_to_inbox": "Vai alla posta in arrivo",
      "remaining_appointments": "Appuntamenti rimanenti",
      "go_to_calendar": "Vai al calendario",
      "new_orders_today": "Nuovi ordini oggi",
      "view_orders": "Visualizza ordini",
      "total_customers": "Clienti totali",
      "view_database": "Visualizza database",
      "dashboard_chat_title": "Chat della Dashboard",
      "dashboard_chat_desc": "Fai domande basate sulle tue fonti di dati.",
      "unread_chats": "Chat non lette",
      "knowledge_sources": "FONTI DI CONOSCENZA:",
      "ai_searching": "L'IA sta cercando nella tua base di conoscenza...",
      "cal_daily_appointments": "Appuntamenti Giornalieri",
      "cal_new_appointment": "Nuovo Appuntamento",
      "cal_reminder": "Promemoria",
      "cal_meeting_details": "Dettagli della Riunione",
      "cal_time": "Ora",
      "cal_agenda": "Agenda / Note",
      "cal_no_notes": "Nessuna nota.",
      "cal_confirm": "Conferma",
      "cal_delete": "Elimina",
      "cal_delete_confirm": "Eliminare la riunione?",
      "cal_schedule_new": "Pianifica Nuova Riunione",
      "cal_meeting_title": "Titolo della Riunione",
      "cal_associated_lead": "Lead Associato",
      "cal_search_lead": "Cerca un lead...",
      "cal_no_leads": "Nessun lead trovato",
      "cal_start_time": "Ora di Inizio",
      "cal_end_time": "Ora di Fine",
      "cal_cancel": "Annulla",
      "cal_schedule": "Pianifica",
      "admin_title": "Pannello di Amministrazione - Utenti e Ruoli",
      "admin_search_email": "Cerca Email",
      "admin_search_email_placeholder": "Cerca per email...",
      "admin_filter_role": "Filtra per Ruolo",
      "admin_all_roles": "Tutti i Ruoli",
      "admin_filter_status": "Filtra per Stato",
      "admin_filter_plan": "Filtra per Piano",
      "admin_clear": "Pulisci",
      "admin_id": "ID",
      "admin_email": "Email",
      "admin_company": "Company",
      "admin_role": "Ruolo",
      "admin_subscription": "Abbonamento",
      "admin_plan": "Piano",
      "admin_no_users": "Nessun utente corrispondente trovato.",
      "admin_prompts_title": "Prompt IA Globali e Comportamento del Sistema (Pannello Admin)",
      "admin_prompts_desc": "Configura il comportamento generale dell'IA, il tono conversazionale e le regole linguistiche. NON aggiungere dati specifici delle aziende qui (utilizza le impostazioni del Profilo Cliente).",
      "admin_global_rules_label": "Regole Globali dell'IA e Tono Umano Naturale",
      "admin_global_rules_desc": "Regole principali per garantire risposte naturali e amichevoli come un operatore umano, concisione e gestione fluida dei saluti.",
      "admin_default_system_prompt_label": "Prompt di Sistema Predefinito (Per Nuove Aziende)",
      "admin_default_system_prompt_desc": "Istruzioni di base che definiscono come l'IA elabora il contesto e i vettori RAG.",
      "admin_autoreply_prompt_label": "Prompt di Risposta Automatica Email",
      "admin_autoreply_prompt_desc": "Istruzioni per analizzare email e generare bozze di risposta in formato JSON.",
      "admin_save_prompts": "Salva Prompt Globali",
      "admin_prompts_saved": "Configurazioni dei prompt IA globali salvate con successo!",
      "vpsMonitor.tabName": "Monitor VPS",
      "vpsMonitor.title": "Risorse Server VPS",
      "vpsMonitor.cpu": "Utilizzo CPU",
      "vpsMonitor.ram": "Utilizzo RAM",
      "vpsMonitor.disk": "Utilizzo disco",
      "vpsMonitor.cpuChart": "Utilizzo CPU nel tempo",
      "vpsMonitor.ramChart": "Utilizzo RAM nel tempo",
      "vpsMonitor.diskChart": "Utilizzo disco nel tempo",
      "vpsMonitor.range1h": "Ultima ora",
      "vpsMonitor.range6h": "Ultime 6 ore",
      "vpsMonitor.range24h": "Ultime 24 ore",
      "vpsMonitor.range7d": "Ultimi 7 giorni",
      "vpsMonitor.range30d": "Ultimi 30 giorni"
}
  },

        pt: {
    translation: {
        "social_publish_this_video": "Publicar este vídeo",
        "tab_social_sub_upload": "Envio e Vídeo",
        "tab_social_sub_skill_videos": "Vídeos de Skills",
        "tab_social_sub_connectors": "Conectores API",
        "tab_social_sub_comments": "Comentários e Moderação com IA",
        "tab_social_sub_history": "Histórico de Publicações",
        "social_tab_skill_videos": "Meus Vídeos de Skills",
        "social_skill_videos_title": "Meus Vídeos de Skills (Prontos para Publicar)",
        "social_skill_videos_empty": "Nenhum skill publicado com um arquivo de vídeo encontrado.",

        "gen_new_posts": "Gerar novos posts",
        "copy_content": "Copiar conteúdo",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% IVA (único)",

        "pricing_options_title": "Opções de Publicação e Preços",
        "pricing_yt": "1. Link do YouTube (requer plano PRO)",
        "pricing_mp4": "2. Enviar arquivo MP4 para nosso servidor",
        "pricing_mp4_non_pro": "1. Enviar arquivo MP4 para nosso servidor",
        "pricing_order": "3. Solicitar gravação de vídeo conosco",
        "pricing_order_non_pro": "2. Solicitar gravação de vídeo conosco",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Link do vídeo de demonstração (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Pacote da Skill (.zip, .json, .py)",
      "skill_package_placeholder": "Selecione o arquivo da skill...",
      "skill_description": "Descrição e instruções da Skill",
      "skill_description_placeholder": "Como usar esta skill?",
      "skill_tags": "Tags / Tecnologias",
      "skill_tags_placeholder": "Selecionar tecnologias...",
      "login_action": "Entrar",
      "create_account_action": "Criar conta",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "Auditoria SEO",
        "seo_audit_title": "Auditoria SEO Global",
        "seo_audit_desc": "Verifica todos os sites de clientes quanto à correção de SEO, SSL, RWD e indexação no Google.",
        "seo_audit_resume": "Retomar auditoria",
        "seo_audit_new": "Nova auditoria",
        "seo_audit_scanning": "Verificando...",
        "seo_audit_confirm": "Tem certeza de que deseja iniciar uma auditoria completamente nova? O relatório anterior será salvo como versão de arquivo.", "btn_compose": "Escrever",
        ask_ai: "Perguntar à IA",
        btn_clear_to_trash: "Mover para o lixo",
        empty_trash_btn: "Esvaziar lixo",
        filter_unread_btn: "🔵 Mostrar não lidos",
        filter_unread_active: "🔵 Apenas não lidos (Ativo)",
      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      calls_title: "Chamadas e AI Voice",
      calls_description: "Configure o número Twilio e a API da OpenAI.",
      calls_instruction_title: "Instruções",
      calls_instruction_desc: "Baixe nosso guia: ",
      calls_instruction_link: "Baixar Guia (PDF)",
      twilio_phone_number: "Número Twilio",
      openai_voice_api_key: "Chave API OpenAI",
      ai_voice_system_prompt_label: "Instruções do Agente",
      ai_voice_system_prompt_desc: "Deixe em branco para o padrão.",
      ai_voice_system_prompt_placeholder: "Padrão...",
      webhook_config_title: "Webhook Twilio",
      webhook_config_desc: "Copie a URL:",
      webhook_url: "URL do Webhook",
      btn_copy: "Copiar",
      btn_copied: "Copiado",
      btn_save_config: "Salvar",
      save_success_title: "Salvo",
      save_success_desc: "Salvo com sucesso.",
      save_error_title: "Erro",
      save_error_desc: "Erro ao salvar.",
      tab_voice_config: "Configuração AI Voice",
      tab_voice_history: "Histórico de Chamadas",

      analytics_buy_tokens: "Comprar Tokens de IA", analytics_package_desc: "1 pacote = 100.000 tokens (50 PLN líquido)", analytics_buy_btn: "Comprar por {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Dias", time_30d: "30 Dias", time_3m: "3 Meses", time_6m: "6 Meses",
      
      openai_api_key_voice: "Chave API OpenAI (Realtime Voice)",
      tab_calls: "Chamadas",
      calls_title: "Configurações do assistente de voz",
      twilio_phone_number: "Número de telefone Twilio",
      save_calls_settings: "Salvar configurações de voz",
      add_product: "Adicionar Produto / Serviço",
      new_product_def: "Definição de novo produto / serviço",
      product_name: "Nome do Produto / Serviço",
      price: "Preço",
      currency: "Moeda",
      hidden_ai_only: "Oculto no perfil público (apenas para IA)",
      ai_knowledge_desc: "Descrição (O que a IA deve aprender sobre este produto?)",
      save_product: "Salvar Produto / Serviço",
      update_product: "Salvar alterações",
      confirm_delete: "Tem certeza que deseja excluir este produto?",
      delete: "Excluir",
      no_products_yet: "Ainda sem produtos ou serviços. Adicione seu primeiro produto.",
      "logout": "Sair",
      "bg_color_tab": "Cor de fundo", "ai_image_tab": "Imagem de IA", "bg_color_label": "Selecionar cor do cabeçalho", "bg_color_placeholder": "ex. #4f46e5", "ai_image_title": "Gerar Cabeçalho de IA (ComfyUI)", "ai_image_desc": "Gere um fundo de cabeçalho inserindo seu próprio prompt. A imagem será anexada automaticamente ao seu perfil.", "ai_image_prompt_placeholder": "ex. Escritório moderno, panorama, cores vivas", "ai_image_btn": "Gerar imagem", "ai_image_email_req": "Por favor, forneça primeiro o seu e-mail no formulário de registo.", "ai_image_timeout": "O tempo de espera para a geração da imagem expirou.",
      "btn_activate_subscription": "Ativar este plano",
      "btn_active_current": "Plano Atual",
      "error_accept_terms": "Você deve aceitar os termos para continuar.",
      "trial_expired_title": "🛑 Pagamento Necessário",
      "trial_expired_desc": "Para continuar a usar o seu Cartão de Visita de IA, escolha um plano de assinatura abaixo.",
      "plan_upgrade_success_basic": "Parabéns! Plano ativado: Cartão IA + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Parabéns! Plano ativado: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Plano Cartão de Visita de IA + Chatbot",
      "plan_basic_price": "100 PLN líquido (123 PLN bruto) / mês",
      "plan_basic_desc": "Pacote inicial ideal. Inclui gerenciamento do perfil de IA e treinamento do chatbot:",
      "plan_basic_f1": "✅ Cartão de Visita IA (Perfil Público)",
      "plan_basic_f2": "✅ Treinamento de Chatbot IA",
      "plan_basic_f3": "✅ Vagas de emprego e eventos",
      "plan_basic_f4": "🔒 Anúncios, CRM, Email e Google Maps desativados",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Comece a ganhar agora vendendo suas habilidades em IA",
      "hero_title_discover": "Descobrir & Vender",
      "hero_title_skills": "Habilidades em IA",
      "marketplace_search_placeholder": "O que você está procurando? Pergunte à IA...",
      "marketplace_popular_skills": "Habilidades Populares",
      "marketplace_new_prompts": "Novos Prompts de IA",
      "plan_pro_f1": "✅ Tudo no Plano Básico",
      "plan_pro_f2": "⚡ CRM dedicado com e-mails inteligentes",
      "plan_pro_f3": "⚡ Geradores de Campanhas (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps e Auto-Discovery Leads B2B",
      "plan_pro_f5": "⚡ Gerador de Posts Sociais e Newsletters",
      "ai_requests_stat_title": "Uso de IA (Agentic AI)",
      "ai_requests_today": "Hoje:",
      "ai_requests_btn": "Configurações de IA",
      ai_greeting: "Olá! Sou o seu assistente de IA. Pergunte sobre produtos e serviços, ou deixe-me criar um site profissional com um Chatbot de IA para você! Ao continuar esta conversa, você concorda automaticamente com o processamento e salvamento de todos os dados fornecidos aqui.",
      search_results_title: "Resultados de busca no mapa para",
      all_companies_list_title: "Diretório verificado da AILinkB e mapa interativo",
      landing_ai_title_simple: "Como podemos ajudá-lo hoje? (Busca global)",
      landing_ai_subtitle_simple: "Procura uma empresa, serviço ou produto? Pergunte por voz ou texto, e pesquisei em todo o banco de dados da AILinkB.",
      landing_ai_placeholder_simple: "Fale ou digite o que procura...",
      search_by_voice_title: "Pesquisar por voz",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Sincronização em segundo plano",
      sync_in_progress: "Sincronizando e-mails...",
      sync_completed_refreshing: "Concluído. Atualizando lista...",
      no_messages_found: "Nenhuma mensagem encontrada.",
      "bg_color_tab": "Cor de fundo", "ai_image_tab": "Imagem de IA", "bg_color_label": "Selecionar cor do cabeçalho", "bg_color_placeholder": "ex. #4f46e5", "ai_image_title": "Gerar Cabeçalho de IA", "ai_image_desc": "Gere um fundo de cabeçalho inserindo seu próprio prompt. A imagem será anexada automaticamente ao seu perfil.", "ai_image_prompt_placeholder": "ex. Escritório moderno, panorama, cores vivas", "ai_image_btn": "Gerar imagem", "ai_image_email_req": "Por favor, forneça primeiro o seu e-mail no formulário de registo.", "ai_image_timeout": "O tempo de espera para a geração da imagem expirou.",
      "live_editor_title": "Editor ao vivo: Crie o perfil da sua empresa",
      "preview_btn_top": "👁️ Visualizar (Nova janela)",
      "preview_btn_bottom": "👁️ Visualização do site ao vivo (Nova janela)",
      "preview_banner_title": "VISUALIZAÇÃO DO SITE EM TEMPO REAL",
      "preview_banner_desc": "É assim que o seu site ficará no AILinkB depois de salvar o formulário.",
      "preview_banner_close": "✖ Fechar visualização",
      "our_services": "Nossos Serviços",
      "about_us": "Sobre Nós",
      "about_us_placeholder": "Insira informações para a IA usar, ex.:\n• Horário de trabalho e regras\n• Política de preços e descontos\n• Vantagens da sua empresa\n• FAQ (perguntas frequentes)\n• Instruções para a IA",
      "live_ai_chat": "Pré-visualização do Chat de IA ao vivo",
      "service_name": "Nome do serviço",
      "brief_desc": "Breve descrição...",
      "add_service": "+ Adicionar serviço",
      "install_widget": "Como instalar o widget no seu site?",
      "profile_link": "Seu link de perfil dedicado",
      "copy": "Copiar",
      "ai_learn_note": "Nota: a IA só aprenderá seus detalhes específicos depois de clicar em Salvar.",

      "chat_consent_label": "Aceito a ",
      "privacy_policy_link": "Política de Privacidade",
      "privacy_policy_title": "Política de Privacidade",
      "privacy_policy_content": "O Controlador de Dados é QR-SYSTEM sp.z.o.o Płaza ul. Graniczna 13B, Capital Social 10 000 PLN. Ao utilizar nosso chat de IA, você concorda que seu e-mail e dados de conversa sejam processados. O assistente de IA fornece respostas com base no contexto disponível, e sua precisão depende das capacidades do sistema. Ao abrigo do RGPD, tem o direito de aceder, retificar ou apagar os seus dados pessoais (Direito ao Esquecimento). Para solicitar a exclusão de seus dados, basta nos enviar um e-mail. Tem também o direito de apresentar reclamação a uma autoridade de controlo de proteção de dados.\n\nPolítica de Publicação de Conteúdo:\nOs usuários que publicam seus próprios materiais de vídeo (Prompts / Skills) em nosso serviço são obrigados a declarar explicitamente no conteúdo do vídeo que o material está publicado e disponível na plataforma AILinkB. Ao enviar, o usuário também concede permissão para a plataforma AILinkB publicar e promover seus materiais de vídeo em nossos canais de mídia social em seu nome.",
      "cookie_title": "Este site usa cookies 🍪",
      "cookie_desc": "Usamos cookies para garantir que você obtenha a melhor experiência em nosso site. Ao concordar, você aceita nossa política de cookies. O acesso ao site requer seu consentimento.",
      "cookie_accept": "Eu Aceito",
      "Find Service Near You": "Encontre um serviço perto de você",
      "search_placeholder": "O que você está procurando?",
      "search_services": "Serviços/Produtos",
      "search_purchases": "Necessidades de compra",
      "search_jobs": "Ofertas de emprego",
      "title_services": "Encontre serviços perto de você",
      "title_purchases": "Encontre necessidades de compra perto de você",
      "title_jobs": "Encontre ofertas de emprego perto de você",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Buscar",
      "no_companies_found": "Nenhuma empresa encontrada.",
      "address": "Endereço:",
      "phone": "Telefone:",
      "website": "Site:",
      "email": "E-mail:",
      "view_details": "Ver Detalhes",
      "chat_ai": "Chat",
      "greeting": "Olá! Sou o assistente de IA da {{name}}.",
      "km_away": "km de distância",
      "company_details": "Detalhes da Empresa",
      "about_company": "Sobre a Empresa:",
      "offered_services": "Serviços Oferecidos:",
      "duration": "Duração",
      "mins": "min",
      "start_ai_consultation": "Iniciar Consulta de IA",
      "no_details": "Sem detalhes disponíveis.",
      "typing": "Digitando...",
      "type_message": "Digite sua mensagem...",
      "more": "mais",
      "language": "Idioma",
      "tab_map_of_partners": "Mapa de Parceiros",
      "tab_dashboard": "Painel",
      "tab_system_logs": "Logs do Sistema",
      "tab_phone_calls": "Chamadas Telefônicas",
      "tab_website": "Meu Site",
      "tab_customers": "Clientes",
      "tab_appointments": "Agendamentos",
      "tab_email": "E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Rascunhos (IA)",
      "tab_visitor_chats": "Chats de visitantes",
      "tab_orders": "Pedidos",
      "tab_mail_campaigns": "Campanhas de E-mail",
      "tab_ad_campaigns": "Campanhas de Anúncios (IA)",
      "tab_email_templates": "Modelos de E-mail",
      "tab_blacklist": "Lista Negra",
      "tab_services": "Serviços",
      "tab_events": "Eventos",
      "chat_update_offline": "Atualização de software em andamento. Você poderá continuar a conversa em um momento...",
      "tab_settings": "Configurações",
      "tab_admin_panel": "Painel de Administração",
      "install_widget": "Instalar Widget",
      "unread_emails": "E-mails não lidos",
      "go_to_inbox": "Ir para a caixa de entrada",
      "remaining_appointments": "Agendamentos Restantes",
      "go_to_calendar": "Ir para o calendário",
      "new_orders_today": "Novos Pedidos Hoje",
      "view_orders": "Ver Pedidos",
      "total_customers": "Total de Clientes",
      "view_database": "Ver Banco de Dados",
      "dashboard_chat_title": "Chat do Painel AILinkB",
      "dashboard_chat_desc": "Faça perguntas com base em suas fontes de dados.",
      "unread_chats": "Chats não lidos",
      "knowledge_sources": "FONTES DE CONHECIMENTO:",
      "ai_searching": "A IA está buscando em sua base de conhecimento...",
      "cal_daily_appointments": "Agendamentos Diários",
      "cal_new_appointment": "Novo Agendamento",
      "cal_reminder": "Lembrete",
      "cal_meeting_details": "Detalhes da Reunião",
      "cal_time": "Hora",
      "cal_agenda": "Agenda / Notas",
      "cal_no_notes": "Sem notas.",
      "cal_confirm": "Confirmar",
      "cal_delete": "Excluir",
      "cal_delete_confirm": "Excluir reunião?",
      "cal_schedule_new": "Agendar Nova Reunião",
      "cal_meeting_title": "Título da Reunião",
      "cal_associated_lead": "Lead Associado",
      "cal_search_lead": "Pesquisar um lead...",
      "cal_no_leads": "Nenhum lead encontrado",
      "cal_start_time": "Hora de Início",
      "cal_end_time": "Hora de Fim",
      "cal_cancel": "Cancelar",
      "cal_schedule": "Agendar",
      "admin_title": "Painel de Administração - Usuários e Funções",
      "admin_search_email": "Buscar E-mail",
      "admin_search_email_placeholder": "Buscar por e-mail...",
      "admin_filter_role": "Filtrar por Função",
      "admin_all_roles": "Todas as Funções",
      "admin_filter_status": "Filtrar por Status",
      "admin_filter_plan": "Filtrar por Plano",
      "admin_clear": "Limpar",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Função",
      "admin_subscription": "Assinatura",
      "admin_plan": "Plano",
      "admin_no_users": "Nenhum usuário correspondente encontrado.",
      "admin_prompts_title": "Prompts Globais da IA e Comportamento do Sistema (Painel Admin)",
      "admin_prompts_desc": "Configure o comportamento geral do chat, o tom de conversação e regras linguísticas. NÃO adicione dados específicos de entidades aqui (use as configurações do Perfil do Cliente).",
      "admin_global_rules_label": "Regras Globais da IA e Tom Humano Natural",
      "admin_global_rules_desc": "Regras principais impondo um comportamento natural e amigável como um ser humano, concisão e tratamento adequado para saudações iniciais.",
      "admin_default_system_prompt_label": "Prompt de Sistema Padrão (Para Novas Empresas)",
      "admin_default_system_prompt_desc": "Instruções básicas que definem como a IA interage com o contexto vetorial RAG.",
      "admin_autoreply_prompt_label": "Prompt de Resposta Automática de E-mail",
      "admin_autoreply_prompt_desc": "Instruções para analisar e-mails e criar rascunhos em formato JSON.",
      "admin_save_prompts": "Salvar Prompts Globais",
      "admin_prompts_saved": "Configurações de prompts globais da IA salvas com sucesso!",
      "vpsMonitor.tabName": "Monitor VPS",
      "vpsMonitor.title": "Recursos do Servidor VPS",
      "vpsMonitor.cpu": "Uso de CPU",
      "vpsMonitor.ram": "Uso de RAM",
      "vpsMonitor.disk": "Uso de disco",
      "vpsMonitor.cpuChart": "Uso de CPU ao longo do tempo",
      "vpsMonitor.ramChart": "Uso de RAM ao longo do tempo",
      "vpsMonitor.diskChart": "Uso de disco ao longo do tempo",
      "vpsMonitor.range1h": "Última hora",
      "vpsMonitor.range6h": "Últimas 6 horas",
      "vpsMonitor.range24h": "Últimas 24 horas",
      "vpsMonitor.range7d": "Últimos 7 dias",
      "vpsMonitor.range30d": "Últimos 30 dias"
}
  },

        nl: {
    translation: {
        "social_publish_this_video": "Publiceer deze video",
        "tab_social_sub_upload": "Upload & Video",
        "tab_social_sub_skill_videos": "Skill Video's",
        "tab_social_sub_connectors": "API-Connectors",
        "tab_social_sub_comments": "Reacties & AI Moderatie",
        "tab_social_sub_history": "Publicatiegeschiedenis",
        "social_tab_skill_videos": "Mijn Skill Video\'s",
        "social_skill_videos_title": "Mijn Skill Video\'s (Klaar om te Publiceren)",
        "social_skill_videos_empty": "Geen gepubliceerde skills met een videobestand gevonden.",

        "gen_new_posts": "Genereer nieuwe berichten",
        "copy_content": "Kopieer inhoud",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% btw (eenmalig)",

        "pricing_options_title": "Publicatieopties en prijzen",
        "pricing_yt": "1. YouTube-link (vereist PRO-abonnement)",
        "pricing_mp4": "2. MP4-bestand uploaden naar onze server",
        "pricing_mp4_non_pro": "1. MP4-bestand uploaden naar onze server",
        "pricing_order": "3. Video-opname bij ons bestellen",
        "pricing_order_non_pro": "2. Video-opname bij ons bestellen",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Presentatievideo Link (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Skill-pakket (.zip, .json, .py)",
      "skill_package_placeholder": "Selecteer skill-bestand...",
      "skill_description": "Skill-beschrijving & Instructies",
      "skill_description_placeholder": "Hoe gebruik je deze skill?",
      "skill_tags": "Tags / Technologieën",
      "skill_tags_placeholder": "Selecteer technologieën...",
      "login_action": "Inloggen",
      "create_account_action": "Account aanmaken",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "SEO Audit",
        "seo_audit_title": "Wereldwijde SEO Audit",
        "seo_audit_desc": "Scant alle websites van klanten op SEO correctheid, SSL, RWD en Google indexering.",
        "seo_audit_resume": "Audit hervatten",
        "seo_audit_new": "Nieuwe audit",
        "seo_audit_scanning": "Scannen...",
        "seo_audit_confirm": "Weet u zeker dat u een compleet nieuwe audit wilt starten? Het vorige rapport wordt opgeslagen als archiefversie.", "btn_compose": "Opstellen",
        ask_ai: "Vraag het aan AI",
        btn_clear_to_trash: "Naar prullenbak verplaatsen",
        empty_trash_btn: "Prullenbak legen",
        filter_unread_btn: "🔵 Toon ongelezen",
        filter_unread_active: "🔵 Alleen ongelezen (Actief)",
      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      calls_title: "Oproepen en AI Voice",
      calls_description: "Configureer Twilio en OpenAI API.",
      calls_instruction_title: "Instructies",
      calls_instruction_desc: "Download onze gids: ",
      calls_instruction_link: "Gids Downloaden (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Spraakagent Instructies",
      ai_voice_system_prompt_desc: "Leeg laten voor standaard.",
      ai_voice_system_prompt_placeholder: "Standaard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopieer de URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiëren",
      btn_copied: "Gekopieerd",
      btn_save_config: "Opslaan",
      save_success_title: "Opgeslagen",
      save_success_desc: "Succesvol opgeslagen.",
      save_error_title: "Fout",
      save_error_desc: "Fout.",
      tab_voice_config: "AI Voice Config",
      tab_voice_history: "Oproepgeschiedenis",

      analytics_buy_tokens: "AI-tokens kopen", analytics_package_desc: "1 pakket = 100.000 tokens (50 PLN netto)", analytics_buy_btn: "Kopen voor {{amount}} PLN",
      
      time_1h: "1u", time_24h: "24u", time_7d: "7 Dagen", time_30d: "30 Dagen", time_3m: "3 Mnd", time_6m: "6 Mnd",
      
      analytics_chart2_legend: "Actieve oproepen (Redis)",
      analytics_chart2_desc: "Aantal actieve Redis-spraaksessies in de loop van de tijd",
      analytics_chart2_title: "Live actieve spraakoproepen",
      analytics_chart1_legend_voice: "Spraaksessies Tokens",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Historische en huidige uitsplitsing van tokengebruik voor tekstchat en spraaksessies",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Accountstatus: Geblokkeerd (403)",
      analytics_status_ok: "Accountstatus: Actief (OK)",
      analytics_available_credits_title: "Beschikbare AI-tegoeden",
      analytics_active_calls_desc: "Direct opgehaald uit Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Actieve spraaksessies (Redis)",
      analytics_refresh: "Metrieken vernieuwen",
      analytics_last_updated: "Laatst bijgewerkt: ",
      analytics_panel_desc: "Metrieken van spraaksessies, AI-tokengebruik en realtime kredietsaldo",
      analytics_panel_title: "Analysepanel & Bronnengebruik",
      analytics_model: "Model",
      analytics_cost: "Kosten (Tegoeden)",
      analytics_tokens_comp: "Voltooiingstokens",
      analytics_tokens_prompt: "Prompt Tokens",
      analytics_date: "Datum",
      analytics_history: "LLM Zoekgeschiedenis (Laatste 10)",
      analytics_limit_exceeded: "⚠️ Limiet tegoeden overschreden! AI-diensten (Chat en Voice) zijn geblokkeerd.",
      analytics_limit_total: "Totale limiet: ",
      analytics_credits_used: "Verbruikte tegoeden: ",
      analytics_credits_available: "Beschikbare tegoeden: ",
      analytics_credits_available_pct: "Beschikbaar",
      analytics_credits_progress: "Gebruik van AI-tegoeden (Voortgangsbalk)",
      analytics_voice_minutes_rate: "Omgerekend tarief per minuut voor telefoonsessies",
      analytics_voice_minutes: "Voice AI Minuten Gebruik",
      openai_api_key_voice: "OpenAI API-sleutel (Realtime Voice)",
      tab_calls: "Oproepen",
      calls_title: "Spraakassistent instellingen",
      twilio_phone_number: "Twilio Telefoonnummer",
      save_calls_settings: "Spraakinstellingen opslaan",
      add_product: "Product / Dienst Toevoegen",
  new_product_def: "Definitie van nieuw product / dienst",
  product_name: "Product- / Dienstnaam",
  price: "Prijs",
  currency: "Valuta",
  hidden_ai_only: "Verborgen op openbaar profiel (alleen voor AI)",
  ai_knowledge_desc: "Beschrijving (Wat moet AI leren over dit product?)",
  save_product: "Product / Dienst Opslaan",
  update_product: "Wijzigingen opslaan",
  confirm_delete: "Weet u zeker dat u dit product wilt verwijderen?",
  delete: "Verwijderen",
  no_products_yet: "Nog geen producten of diensten. Voeg uw eerste product toe.",
      "logout": "Uitloggen",
      "bg_color_tab": "Achtergrondkleur", "ai_image_tab": "AI Afbeelding", "bg_color_label": "Selecteer headerkleur", "bg_color_placeholder": "bijv. #4f46e5", "ai_image_title": "AI Header genereren (ComfyUI)", "ai_image_desc": "Genereer een header-achtergrond door uw eigen beschrijving in te voeren. De afbeelding wordt automatisch aan uw profiel toegevoegd.", "ai_image_prompt_placeholder": "bijv. Modern kantoor, skyline, lichte kleuren", "ai_image_btn": "Afbeelding genereren", "ai_image_email_req": "Vul eerst uw e-mailadres in op het registratieformulier.", "ai_image_timeout": "Wachttijd voor het genereren van afbeeldingen is verstreken.",
      "btn_activate_subscription": "Activeer dit plan",
      "btn_active_current": "Huidig Plan",
      "error_accept_terms": "U moet de voorwaarden accepteren om door te gaan.",
      "trial_expired_title": "🛑 Betaling Vereist",
      "trial_expired_desc": "Kies hieronder een abonnement om uw AI-visitekaartje te blijven gebruiken.",
      "plan_upgrade_success_basic": "Gefeliciteerd! Plan geactiveerd: AI Visitekaartje + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Gefeliciteerd! Plan geactiveerd: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Plan AI-visitekaartje + Chatbot",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN bruto) / maand",
      "plan_basic_desc": "Ideaal startpakket. Inclusief profielbeheer en chatbot-training:",
      "plan_basic_f1": "✅ AI Visitekaartje (Openbaar Profiel)",
      "plan_basic_f2": "✅ AI Chatbot training",
      "plan_basic_f3": "✅ Vacatures en evenementen",
      "plan_basic_f4": "🔒 Ads, CRM, Mail & Google Maps uitgeschakeld",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Begin nu met verdienen door uw AI-vaardigheden te verkopen",
      "hero_title_discover": "Ontdek & Verkoop",
      "hero_title_skills": "AI-Vaardigheden",
      "marketplace_search_placeholder": "Wat zoek je? Vraag het aan AI...",
      "marketplace_popular_skills": "Populaire Vaardigheden",
      "marketplace_new_prompts": "Nieuwe AI-Prompts",
      "plan_pro_f1": "✅ Alles in Basisplan",
      "plan_pro_f2": "⚡ Eigen CRM met slimme e-mails",
      "plan_pro_f3": "⚡ Ad Campaign Generators (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps & Auto-Discovery B2B",
      "plan_pro_f5": "⚡ Social Media Post & Newsletter Generator",
      "ai_requests_stat_title": "AI-gebruik (Agentic AI)",
      "ai_requests_today": "Vandaag:",
      "ai_requests_btn": "AI-instellingen",
      ai_greeting: "Hallo! Ik ben uw AI-assistent. Vraag naar producten en diensten, of laat mij een professionele website met een AI-Chatbot voor u maken! Door dit gesprek voort te zetten, gaat u automatisch akkoord met de verwerking en opslag van alle hier verstrekte gegevens.",
      search_results_title: "Zoekresultaten op de kaart voor",
      all_companies_list_title: "Geverifieerd AILinkB-account overzicht & interactieve kaart",
      landing_ai_title_simple: "Hoe kunnen we u vandaag helpen? (Globale zoekopdracht)",
      landing_ai_subtitle_simple: "Op zoek naar een bedrijf, dienst of product? Vraag het met uw stem of via tekst, en ik doorzoek de hele AILinkB-database.",
      landing_ai_placeholder_simple: "Spreekt of typ wat u zoekt...",
      search_by_voice_title: "Zoeken met spraak",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Achtergrond synchronisatie",
      sync_in_progress: "E-mails synchroniseren op de achtergrond...",
      sync_completed_refreshing: "Voltooid. Lijst vernieuwen...",
      no_messages_found: "Geen berichten gevonden.",
      welcome_back: "Welkom terug",
      login_to_dashboard: "Log in op uw dashboard",
      email_address: "E-mailadres",
      security_pin: "Veiligheidspincode (6 cijfers)",
      forgot_pin: "PIN vergeten?",
      login_with_pin: "Inloggen met PIN",
      or: "OF",
      need_account: "Account nodig? Start setup",
      back_to_home: "← Terug naar home",
      cancel_edit: "← Bewerken annuleren",
      save_profile: "Profiel opslaan",
      save_profile_activate: "Profiel opslaan & AI activeren",
      sign_in: "Inloggen",
      "bg_color_tab": "Achtergrondkleur", "ai_image_tab": "AI Afbeelding", "bg_color_label": "Selecteer headerkleur", "bg_color_placeholder": "bijv. #4f46e5", "ai_image_title": "AI Header genereren", "ai_image_desc": "Genereer een header-achtergrond door uw eigen beschrijving in te voeren. De afbeelding wordt automatisch aan uw profiel toegevoegd.", "ai_image_prompt_placeholder": "bijv. Modern kantoor, skyline, lichte kleuren", "ai_image_btn": "Afbeelding genereren", "ai_image_email_req": "Vul eerst uw e-mailadres in op het registratieformulier.", "ai_image_timeout": "Wachttijd voor het genereren van afbeeldingen is verstreken.",
      "live_editor_title": "Live Editor: Maak uw bedrijfsprofiel",
      "preview_btn_top": "👁️ Voorbeeld (Nieuw venster)",
      "preview_btn_bottom": "👁️ Live websitevoorbeeld (Nieuw venster)",
      "preview_banner_title": "REALTIME LIVE WEBSITEVOORBEELD",
      "preview_banner_desc": "Zo ziet uw voltooide website eruit op AILinkB na het opslaan van het formulier.",
      "preview_banner_close": "✖ Voorbeeld sluiten",
      "our_services": "Onze Diensten",
      "about_us": "Over Ons",
      "about_us_placeholder": "Voer informatie in voor de AI, bijv.:\n• Werktijden en regels\n• Prijsbeleid en kortingen\n• Voordelen van uw bedrijf\n• FAQ (veelgestelde vragen)\n• Instructies voor AI",
      "live_ai_chat": "Live AI Chat Voorbeeld",
      "service_name": "Naam dienst",
      "brief_desc": "Korte beschrijving...",
      "add_service": "+ Dienst toevoegen",
      "install_widget": "Hoe installeer je de widget op je site?",
      "profile_link": "Uw toegewijde profiellink",
      "copy": "Kopiëren",
      "ai_learn_note": "Opmerking: de AI leert uw specifieke details pas nadat u op Opslaan heeft geklikt.",

      "chat_consent_label": "Ik accepteer het ",
      "privacy_policy_link": "Privacybeleid",
      "privacy_policy_title": "Privacybeleid",
      "privacy_policy_content": "De verwerkingsverantwoordelijke is QR-SYSTEM sp.z.o.o Płaza ul. Graniczna 13B, Maatschappelijk Kapitaal 10 000 PLN. Door onze AI-chat te gebruiken, gaat u ermee akkoord dat uw e-mail en conversatiegegevens worden verwerkt. De AI-assistent geeft antwoorden op basis van de beschikbare context en de precisie is afhankelijk van de systeemmogelijkheden. Volgens de AVG heeft u het recht om uw persoonlijke gegevens in te zien, te rectificeren of te wissen (Recht om vergeten te worden). Om verwijdering van uw gegevens aan te vragen, stuurt u ons gewoon een e-mail. U heeft ook het recht om een klacht in te dienen bij een toezichthoudende autoriteit voor gegevensbescherming.\n\nBeleid voor inhoudspublicatie:\nGebruikers die hun eigen videomateriaal (Prompts / Skills) op onze service publiceren, moeten expliciet in de video-inhoud vermelden dat het materiaal is gepubliceerd en beschikbaar is op het AILinkB-platform. Door te uploaden geeft de gebruiker ook toestemming aan het AILinkB-platform om zijn/haar videomateriaal namens hem/haar te publiceren en promoten op onze social media-kanalen.",
      "cookie_title": "Deze website gebruikt cookies 🍪",
      "cookie_desc": "Wij gebruiken cookies om ervoor te zorgen dat u de beste ervaring op onze website krijgt. Door akkoord te gaan, accepteert u ons cookiebeleid. Toegang tot de site vereist uw toestemming.",
      "cookie_accept": "Ik Accepteer",
      "Find Service Near You": "Vind een service bij u in de buurt",
      "search_placeholder": "Waar bent u naar op zoek?",
      "search_services": "Diensten/Producten",
      "search_purchases": "Koopbehoeften",
      "search_jobs": "Vacatures",
      "title_services": "Vind diensten bij u in de buurt",
      "title_purchases": "Vind koopbehoeften bij u in de buurt",
      "title_jobs": "Vind vacatures bij u in de buurt",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Zoeken",
      "no_companies_found": "Nog geen bedrijven gevonden.",
      "address": "Adres:",
      "phone": "Telefoon:",
      "website": "Website:",
      "email": "E-mail:",
      "view_details": "Bekijk Details",
      "chat_ai": "Chat",
      "greeting": "Hallo! Ik ben de AI-assistent voor {{name}}.",
      "km_away": "km afstand",
      "company_details": "Bedrijfsgegevens",
      "about_company": "Over het bedrijf:",
      "offered_services": "Aangeboden Diensten:",
      "duration": "Duur",
      "mins": "min",
      "start_ai_consultation": "Start AI-consult",
      "no_details": "Geen details beschikbaar.",
      "typing": "Typen...",
      "type_message": "Typ uw bericht...",
      "more": "meer",
      "language": "Taal",
      "tab_map_of_partners": "Partnerkaart",
      "tab_dashboard": "Dashboard",
      "tab_system_logs": "Systeemlogboeken",
      "tab_phone_calls": "Telefoongesprekken",
      "tab_website": "Mijn Website",
      "tab_customers": "Klanten",
      "tab_appointments": "Afspraken",
      "tab_email": "E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Concepten (AI)",
      "tab_visitor_chats": "Bezoeker Chats",
      "tab_orders": "Bestellingen",
      "tab_mail_campaigns": "E-mail Campagnes",
      "tab_ad_campaigns": "Advertentiecampagnes (AI)",
      "tab_email_templates": "E-mail Sjablonen",
      "tab_blacklist": "Zwarte Lijst",
      "tab_services": "Diensten",
      "tab_events": "Evenementen",
      "chat_update_offline": "Software-update wordt uitgevoerd. U kunt het gesprek zo dadelijk voortzetten...",
      "tab_settings": "Instellingen",
      "tab_admin_panel": "Beheerderspaneel",
      "install_widget": "Widget Installeren",
      "unread_emails": "Ongelezen E-mails",
      "go_to_inbox": "Naar Postvak IN",
      "remaining_appointments": "Resterende Afspraken",
      "go_to_calendar": "Naar Kalender",
      "new_orders_today": "Nieuwe Bestellingen",
      "view_orders": "Bekijk Bestellingen",
      "total_customers": "Totaal Klanten",
      "view_database": "Bekijk Database",
      "dashboard_chat_title": "AILinkB Dashboard Chat",
      "dashboard_chat_desc": "Stel vragen op basis van uw gegevensbronnen.",
      "unread_chats": "Ongelezen Chats",
      "knowledge_sources": "KENNISBRONNEN:",
      "ai_searching": "AI doorzoekt uw kennisbank...",
      "cal_daily_appointments": "Dagelijkse Afspraken",
      "cal_new_appointment": "Nieuwe Afspraak",
      "cal_reminder": "Herinnering",
      "cal_meeting_details": "Vergaderdetails",
      "cal_time": "Tijd",
      "cal_agenda": "Agenda / Notities",
      "cal_no_notes": "Geen notities.",
      "cal_confirm": "Bevestigen",
      "cal_delete": "Verwijderen",
      "cal_delete_confirm": "Vergadering verwijderen?",
      "cal_schedule_new": "Nieuwe Vergadering Plannen",
      "cal_meeting_title": "Titel Vergadering",
      "cal_associated_lead": "Gekoppelde Lead",
      "cal_search_lead": "Zoek een lead...",
      "cal_no_leads": "Geen leads gevonden",
      "cal_start_time": "Starttijd",
      "cal_end_time": "Eindtijd",
      "cal_cancel": "Annuleren",
      "cal_schedule": "Plannen",
      "admin_title": "Beheerderspaneel - Gebruikers & Rollen",
      "admin_search_email": "Zoek E-mail",
      "admin_search_email_placeholder": "Zoeken op e-mail...",
      "admin_filter_role": "Filter op Rol",
      "admin_all_roles": "Alle Rollen",
      "admin_filter_status": "Filter op Status",
      "admin_filter_plan": "Filter op Plan",
      "admin_clear": "Wissen",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Rol",
      "admin_subscription": "Abonnement",
      "admin_plan": "Plan",
      "admin_no_users": "Geen overeenkomende gebruikers gevonden.",
      "admin_prompts_title": "Globale AI Prompts & Systeemgedrag (Admin Panel)",
      "admin_prompts_desc": "Configureer het algemene gedrag van de AI, de gesprekston en taalkundige regels. Voeg hier GEEN bedrijfsspecifieke gegevens toe (gebruik daarvoor het Klantprofiel).",
      "admin_global_rules_label": "Globale AI Regels & Natuurlijk Menselijke Toon",
      "admin_global_rules_desc": "Hoofdregels voor een natuurlijk en vriendelijk menselijk gedrag, bondigheid en correcte reacties op begroetingen.",
      "admin_default_system_prompt_label": "Standaard Systeemprompt (Voor Nieuwe Bedrijven)",
      "admin_default_system_prompt_desc": "Basisinstrumenten die bepalen hoe de AI samenwerkt met de RAG vector data.",
      "admin_autoreply_prompt_label": "E-mail Auto-Reply Prompt",
      "admin_autoreply_prompt_desc": "Instructies voor het analyseren van e-mails en het genereren van JSON concepten.",
      "admin_save_prompts": "Globale Prompts Opslaan",
      "admin_prompts_saved": "Globale AI prompt configuraties succesvol opgeslagen!",
      "vpsMonitor.tabName": "VPS Monitor",
      "vpsMonitor.title": "VPS Serverbronnen",
      "vpsMonitor.cpu": "CPU-gebruik",
      "vpsMonitor.ram": "RAM-gebruik",
      "vpsMonitor.disk": "Schijfgebruik",
      "vpsMonitor.cpuChart": "CPU-gebruik in de tijd",
      "vpsMonitor.ramChart": "RAM-gebruik in de tijd",
      "vpsMonitor.diskChart": "Schijfgebruik in de tijd",
      "vpsMonitor.range1h": "Laatste uur",
      "vpsMonitor.range6h": "Laatste 6 uur",
      "vpsMonitor.range24h": "Laatste 24 uur",
      "vpsMonitor.range7d": "Laatste 7 dagen",
      "vpsMonitor.range30d": "Laatste 30 dagen"
}
  },

        sv: {
    translation: {
        "social_publish_this_video": "Publicera denna video",
        "tab_social_sub_upload": "Ladda upp & Video",
        "tab_social_sub_skill_videos": "Skill-videor",
        "tab_social_sub_connectors": "API-anslutningar",
        "tab_social_sub_comments": "Kommentarer & AI-moderering",
        "tab_social_sub_history": "Publiceringshistorik",
        "social_tab_skill_videos": "Mina Skill-videor",
        "social_skill_videos_title": "Mina Skill-videor (Redo att Publiceras)",
        "social_skill_videos_empty": "Inga publicerade skills med en videofil hittades.",

        "gen_new_posts": "Skapa nya inlägg",
        "copy_content": "Kopiera innehåll",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% moms (engångs)",

        "pricing_options_title": "Publiceringsalternativ & Priser",
        "pricing_yt": "1. YouTube-länk (kräver PRO-plan)",
        "pricing_mp4": "2. Ladda upp MP4-fil till vår server",
        "pricing_mp4_non_pro": "1. Ladda upp MP4-fil till vår server",
        "pricing_order": "3. Beställ videoinspelning från oss",
        "pricing_order_non_pro": "2. Beställ videoinspelning från oss",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Presentationsvideo länk (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Skill-paket (.zip, .json, .py)",
      "skill_package_placeholder": "Välj skill-fil...",
      "skill_description": "Skillbeskrivning och instruktioner",
      "skill_description_placeholder": "Hur använder man denna skill?",
      "skill_tags": "Taggar / Teknologier",
      "skill_tags_placeholder": "Välj teknologier...",
      "login_action": "Logga in",
      "create_account_action": "Skapa konto",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "SEO Audit",
        "seo_audit_title": "Global SEO Audit",
        "seo_audit_desc": "Skannar alla kundwebbplatser för SEO-korrekthet, SSL, RWD och Google-indexering.",
        "seo_audit_resume": "Återuppta audit",
        "seo_audit_new": "Ny audit",
        "seo_audit_scanning": "Skannar...",
        "seo_audit_confirm": "Är du säker på att du vill starta en helt ny audit? Den föregående rapporten sparas som en arkivversion.", "btn_compose": "Skriv",
        ask_ai: "Fråga AI",
        btn_clear_to_trash: "Flytta till papperskorgen",
        empty_trash_btn: "Töm papperskorgen",
        filter_unread_btn: "🔵 Visa olästa",
        filter_unread_active: "🔵 Endast olästa (Aktiv)",
      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      calls_title: "Samtal och AI Voice",
      calls_description: "Konfigurera Twilio och OpenAI API.",
      calls_instruction_title: "Instruktioner",
      calls_instruction_desc: "Ladda ner vår guide: ",
      calls_instruction_link: "Ladda ner Guide (PDF)",
      twilio_phone_number: "Twilio Nummer",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instruktioner",
      ai_voice_system_prompt_desc: "Lämna tomt för standard.",
      ai_voice_system_prompt_placeholder: "Standard...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Kopiera URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopiera",
      btn_copied: "Kopierat",
      btn_save_config: "Spara",
      save_success_title: "Sparat",
      save_success_desc: "Sparat framgångsrikt.",
      save_error_title: "Fel",
      save_error_desc: "Fel.",
      tab_voice_config: "AI Voice Konfiguration",
      tab_voice_history: "Samtalshistorik",

      analytics_buy_tokens: "Köp AI-tokens", analytics_package_desc: "1 paket = 100 000 tokens (50 PLN netto)", analytics_buy_btn: "Köp för {{amount}} PLN",
      
      time_1h: "1t", time_24h: "24t", time_7d: "7 Dagar", time_30d: "30 Dagar", time_3m: "3 Mån", time_6m: "6 Mån",
      
      analytics_chart2_legend: "Aktiva samtal (Redis)",
      analytics_chart2_desc: "Antal aktiva Redis-röstsessioner över tid",
      analytics_chart2_title: "Aktiva röstsamtal live",
      analytics_chart1_legend_voice: "Röstsessions-tokens",
      analytics_chart1_legend_text: "Chat & Agent Tokens",
      analytics_chart1_desc: "Historisk och nuvarande uppdelning av textchatt- och röstsessionstokenanvändning",
      analytics_chart1_title: "Token Usage Over Time (Chat & Agents)",
      analytics_text_tokens_desc: "Tokens processed by assistant and background agents",
      analytics_text_tokens_title: "Tokens (Chat & Agents)",
      analytics_status_blocked: "Kontostatus: Blockerat (403)",
      analytics_status_ok: "Kontostatus: Aktiv (OK)",
      analytics_available_credits_title: "Tillgängliga AI-krediter",
      analytics_active_calls_desc: "Hämtad direkt från Redis (`VoiceSessionRedisService`)",
      analytics_active_calls: "Aktiva röstsessioner (Redis)",
      analytics_refresh: "Uppdatera mått",
      analytics_last_updated: "Senast uppdaterad: ",
      analytics_panel_desc: "Röstsessioners mått, AI-tokenanvändning och realtidssaldo",
      analytics_panel_title: "Analyspanel & Resursanvändning",
      analytics_model: "Modell",
      analytics_cost: "Kostnad (Krediter)",
      analytics_tokens_comp: "Kompletterande tokens",
      analytics_tokens_prompt: "Prompt-tokens",
      analytics_date: "Datum",
      analytics_history: "LLM Sökhistorik (Senaste 10)",
      analytics_limit_exceeded: "⚠️ Kreditgräns överskriden! AI-tjänster (Chat och Voice) har blockerats.",
      analytics_limit_total: "Total gräns: ",
      analytics_credits_used: "Använda krediter: ",
      analytics_credits_available: "Tillgängliga krediter: ",
      analytics_credits_available_pct: "Tillgängligt",
      analytics_credits_progress: "Användning av AI-krediter (Förloppsindikator)",
      analytics_voice_minutes_rate: "Konverterad minutavgift för telefonsessioner",
      analytics_voice_minutes: "Voice AI Minuter Användning",
      openai_api_key_voice: "OpenAI API-nyckel (Realtime Voice)",
      tab_calls: "Samtal",
      calls_title: "Inställningar för röstassistent",
      twilio_phone_number: "Twilio Telefonnummer",
      save_calls_settings: "Spara röstinställningar",
      add_product: "Lägg till Produkt / Tjänst",
  new_product_def: "Definition av ny produkt / tjänst",
  product_name: "Produkt- / Tjänstnamn",
  price: "Pris",
  currency: "Valuta",
  hidden_ai_only: "Dolt på offentlig profil (endast för AI)",
  ai_knowledge_desc: "Beskrivning (Vad ska AI lära sig om den här produkten?)",
  save_product: "Spara Produkt / Tjänst",
  update_product: "Spara ändringar",
  confirm_delete: "Är du säker på att du vill ta bort den här produkten?",
  delete: "Ta bort",
  no_products_yet: "Inga produkter eller tjänster än. Lägg till din första produkt.",
      "logout": "Logga ut",
      "bg_color_tab": "Bakgrundsfärg", "ai_image_tab": "AI Bild", "bg_color_label": "Välj rubrikfärg", "bg_color_placeholder": "t.ex. #4f46e5", "ai_image_title": "Generera AI-rubrik (ComfyUI)", "ai_image_desc": "Generera en rubrikbakgrund genom att ange din egen prompt. Bilden bifogas automatiskt till din profil.", "ai_image_prompt_placeholder": "t.ex. Modernt kontor, skyline, ljusa färger", "ai_image_btn": "Generera bild", "ai_image_email_req": "Vänligen ange din e-postadress i registreringsformuläret först.", "ai_image_timeout": "Väntetiden för bildgenerering har löpt ut.",
      "btn_activate_subscription": "Aktivera denna plan",
      "btn_active_current": "Nuvarande Plan",
      "error_accept_terms": "Du måste godkänna villkoren för att fortsätta.",
      "trial_expired_title": "🛑 Betalning Krävs",
      "trial_expired_desc": "För att fortsätta använda ditt AI-visitkort och verktyg, välj en plan nedan.",
      "plan_upgrade_success_basic": "Grattis! Plan aktiverad: AI-visitkort + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Grattis! Plan aktiverad: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Plan AI-visitkort + Chatbot",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN brutto) / månad",
      "plan_basic_desc": "Idealiskt startpaket. Inkluderar profilhantering och chatbot-träning:",
      "plan_basic_f1": "✅ AI-visitkort (Offentlig profil)",
      "plan_basic_f2": "✅ AI Chatbot träning",
      "plan_basic_f3": "✅ Jobbannonser och evenemang",
      "plan_basic_f4": "🔒 Annonser, CRM, Mail & Google Maps inaktiverade",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Börja tjäna pengar nu genom att sälja dina AI-färdigheter",
      "hero_title_discover": "Upptäck & Sälj",
      "hero_title_skills": "AI-Färdigheter",
      "marketplace_search_placeholder": "Vad letar du efter? Fråga AI...",
      "marketplace_popular_skills": "Populära Färdigheter",
      "marketplace_new_prompts": "Nya AI-Prompts",
      "plan_pro_f1": "✅ Allt i Basplanen",
      "plan_pro_f2": "⚡ Eget CRM med smarta e-postmeddelanden",
      "plan_pro_f3": "⚡ Annonskampanjgeneratorer (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps & Auto-Discovery B2B",
      "plan_pro_f5": "⚡ Social Media & Nyhetsbrevsgenerator",
      "ai_requests_stat_title": "AI-användning (Agentic AI)",
      "ai_requests_today": "Idag:",
      "ai_requests_btn": "AI-inställningar",
      ai_greeting: "Hej! Jag är din AI-assistent. Fråga om produkter och tjänster, eller låt mig skapa en professionell webbplats med en AI-Chatbot åt dig! Genom att fortsätta detta samtal samtycker du automatiskt till behandling och lagring av alla uppgifter som lämnas här.",
      search_results_title: "Sökresultat på kartan för",
      all_companies_list_title: "AILinkB Verifierad Katalog & Interaktiv Karta",
      landing_ai_title_simple: "Hur kan vi hjälpa dig idag? (Global sökning)",
      landing_ai_subtitle_simple: "Letar du efter ett företag, en tjänst eller en produkt? Fråga med röst eller text, så söker jag igenom hela AILinkB-databasen.",
      landing_ai_placeholder_simple: "Prata eller skriv vad du letar efter...",
      search_by_voice_title: "Sök med röst",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Bakgrundssynkronisering",
      sync_in_progress: "Synkroniserar e-post i bakgrunden...",
      sync_completed_refreshing: "Slutfört. Uppdaterar listan...",
      no_messages_found: "Inga meddelanden hittades.",
      welcome_back: "Välkommen tillbaka",
      login_to_dashboard: "Logga in på din instrumentpanel",
      email_address: "E-postadress",
      security_pin: "Säkerhets-PIN (6 siffror)",
      forgot_pin: "Glömt PIN?",
      login_with_pin: "Logga in med PIN",
      or: "ELLER",
      need_account: "Behöver du ett konto? Starta installationen",
      back_to_home: "← Tillbaka till start",
      cancel_edit: "← Avbryt redigering",
      save_profile: "Spara profil",
      save_profile_activate: "Spara profil & aktivera AI",
      sign_in: "Logga in",
      "bg_color_tab": "Bakgrundsfärg", "ai_image_tab": "AI Bild", "bg_color_label": "Välj rubrikfärg", "bg_color_placeholder": "t.ex. #4f46e5", "ai_image_title": "Generera AI-rubrik", "ai_image_desc": "Generera en rubrikbakgrund genom att ange din egen prompt. Bilden bifogas automatiskt till din profil.", "ai_image_prompt_placeholder": "t.ex. Modernt kontor, skyline, ljusa färger", "ai_image_btn": "Generera bild", "ai_image_email_req": "Vänligen ange din e-postadress i registreringsformuläret först.", "ai_image_timeout": "Väntetiden för bildgenerering har löpt ut.",
      "live_editor_title": "Live Editor: Skapa din företagsprofil",
      "preview_btn_top": "👁️ Förhandsgranska (Nytt fönster)",
      "preview_btn_bottom": "👁️ Live webbplatsförhandsgranskning (Nytt fönster)",
      "preview_banner_title": "REALTIDS LIVE WEBBPLATSFÖRHANDSGRANSKNING",
      "preview_banner_desc": "Så här kommer din färdiga webbplats att se ut på AILinkB efter att du har sparat formuläret.",
      "preview_banner_close": "✖ Stäng förhandsgranskning",
      "our_services": "Våra Tjänster",
      "about_us": "Om Oss",
      "about_us_placeholder": "Ange information för AI:n, t.ex.:\n• Arbetstider och regler\n• Prispolicy och rabatter\n• Ditt företags fördelar\n• FAQ (vanliga frågor)\n• Instruktioner för AI",
      "live_ai_chat": "Live AI Chatt-förhandsgranskning",
      "service_name": "Tjänstens namn",
      "brief_desc": "Kort beskrivning...",
      "add_service": "+ Lägg till tjänst",
      "install_widget": "Hur installerar man widgeten på din webbplats?",
      "profile_link": "Din dedikerade profillänk",
      "copy": "Kopiera",
      "ai_learn_note": "Obs: AI:n kommer bara att lära sig dina specifika detaljer efter att du klickat på Spara.",

      "chat_consent_label": "Jag accepterar ",
      "privacy_policy_link": "Integritetspolicy",
      "privacy_policy_title": "Integritetspolicy",
      "privacy_policy_content": "Personuppgiftsansvarig är QR-SYSTEM sp.z.o.o Płaza ul. Graniczna 13B, Aktiekapital 10 000 PLN. Genom att använda vår AI-chatt godkänner du att din e-post och dina konversationsdata behandlas. AI-assistenten ger svar baserat på tillgänglig kontext, och dess precision beror på systemets kapacitet. Enligt GDPR har du rätt att komma åt, rätta eller radera dina personuppgifter (Rätt att bli glömd). För att begära radering av dina uppgifter, skicka helt enkelt ett e-postmeddelande till oss. Du har också rätt att lämna in ett klagomål till en tillsynsmyndighet för dataskydd.\n\nPolicy för innehållspublicering:\nAnvändare som publicerar sina egna videomaterial (Prompts / Skills) på vår tjänst är skyldiga att uttryckligen ange i videoinnehållet att materialet är publicerat och tillgängligt på AILinkB-plattformen. Genom att ladda upp ger användaren även AILinkB-plattformen tillåtelse att publicera och marknadsföra deras videomaterial på våra sociala mediekanaler å deras vägnar.",
      "cookie_title": "Denna webbplats använder cookies 🍪",
      "cookie_desc": "Vi använder cookies för att säkerställa att du får den bästa upplevelsen på vår webbplats. Genom att godkänna accepterar du vår cookiepolicy. Åtkomst till webbplatsen kräver ditt samtycke.",
      "cookie_accept": "Jag Accepterar",
      "Find Service Near You": "Hitta tjänst nära dig",
      "search_placeholder": "Vad letar du efter?",
      "search_services": "Tjänster/Produkter",
      "search_purchases": "Köpebehov",
      "search_jobs": "Jobberbjudanden",
      "title_services": "Hitta tjänster nära dig",
      "title_purchases": "Hitta köpebehov nära dig",
      "title_jobs": "Hitta jobberbjudanden nära dig",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Sök",
      "no_companies_found": "Inga företag hittades.",
      "address": "Adress:",
      "phone": "Telefon:",
      "website": "Webbplats:",
      "email": "E-post:",
      "view_details": "Visa detaljer",
      "chat_ai": "Chat",
      "greeting": "Hej! Jag är AI-assistenten för {{name}}.",
      "km_away": "km bort",
      "company_details": "Företagsinformation",
      "about_company": "Om företaget:",
      "offered_services": "Erbjudna tjänster:",
      "duration": "Varaktighet",
      "mins": "min",
      "start_ai_consultation": "Starta AI-konsultation",
      "no_details": "Inga detaljer tillgängliga.",
      "typing": "Skriver...",
      "type_message": "Skriv ditt meddelande...",
      "more": "mer",
      "language": "Språk",
      "tab_map_of_partners": "Partnerkarta",
      "tab_dashboard": "Instrumentpanel",
      "tab_system_logs": "Systemloggar",
      "tab_phone_calls": "Telefonsamtal",
      "tab_website": "Min Webbplats",
      "tab_customers": "Kunder",
      "tab_appointments": "Tidsbokningar",
      "tab_email": "E-post",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Utkast (AI)",
      "tab_visitor_chats": "Besökarchatt",
      "tab_orders": "Beställningar",
      "tab_mail_campaigns": "E-postkampanjer",
      "tab_ad_campaigns": "Annonskampanjer (AI)",
      "tab_email_templates": "E-postmallar",
      "tab_blacklist": "Svartlista",
      "tab_services": "Tjänster",
      "tab_events": "Evenemang",
      "chat_update_offline": "Programuppdatering pågår. Du kan fortsätta konversationen om ett ögonblick...",
      "tab_settings": "Inställningar",
      "tab_admin_panel": "Administratörspanel",
      "install_widget": "Installera Widget",
      "unread_emails": "Olästa E-postmeddelanden",
      "go_to_inbox": "Gå till inkorgen",
      "remaining_appointments": "Återstående Tidsbokningar",
      "go_to_calendar": "Gå till kalender",
      "new_orders_today": "Nya Beställningar Idag",
      "view_orders": "Visa Beställningar",
      "total_customers": "Totalt Kunder",
      "view_database": "Visa Databas",
      "dashboard_chat_title": "AILinkB Instrumentpanel Chatt",
      "dashboard_chat_desc": "Ställ frågor baserat på dina datakällor.",
      "unread_chats": "Olästa Chattar",
      "knowledge_sources": "KUNSKAPSKÄLLOR:",
      "ai_searching": "AI söker i din kunskapsbas...",
      "cal_daily_appointments": "Dagliga Möten",
      "cal_new_appointment": "Nytt Möte",
      "cal_reminder": "Påminnelse",
      "cal_meeting_details": "Mötesdetaljer",
      "cal_time": "Tid",
      "cal_agenda": "Agenda / Anteckningar",
      "cal_no_notes": "Inga anteckningar.",
      "cal_confirm": "Bekräfta",
      "cal_delete": "Radera",
      "cal_delete_confirm": "Radera möte?",
      "cal_schedule_new": "Boka Nytt Möte",
      "cal_meeting_title": "Mötestitel",
      "cal_associated_lead": "Associerad Kund",
      "cal_search_lead": "Sök efter kund...",
      "cal_no_leads": "Inga kunder hittades",
      "cal_start_time": "Starttid",
      "cal_end_time": "Sluttid",
      "cal_cancel": "Avbryt",
      "cal_schedule": "Boka",
      "admin_title": "Administratörspanel - Användare & Roller",
      "admin_search_email": "Sök E-post",
      "admin_search_email_placeholder": "Sök med e-post...",
      "admin_filter_role": "Filtrera efter Roll",
      "admin_all_roles": "Alla Roller",
      "admin_filter_status": "Filtrera efter Status",
      "admin_filter_plan": "Filtrera efter Plan",
      "admin_clear": "Rensa",
      "admin_id": "ID",
      "admin_email": "E-post",
      "admin_role": "Roll",
      "admin_subscription": "Prenumeration",
      "admin_plan": "Plan",
      "admin_no_users": "Inga matchande användare hittades.",
      "admin_prompts_title": "Globala AI-prompter & Systembeteende (Adminpanel)",
      "admin_prompts_desc": "Konfigurera AI-systemets allmänna beteende, samtalston och språkregler. Lägg INTE till företagsspecifika data här (använd Klientprofilen).",
      "admin_global_rules_label": "Globala AI-regler & Naturlig Mänsklig Ton",
      "admin_global_rules_desc": "Huvudregler som tvingar fram ett naturligt, vänligt och mänskligt bemötande, korthet och smidig hantering av hälsningar.",
      "admin_default_system_prompt_label": "Standard-systemprompt (För Nya Företag)",
      "admin_default_system_prompt_desc": "Grundläggande instruktioner för hur AI söker i RAG-kunskapsbasen.",
      "admin_autoreply_prompt_label": "E-post Auto-Reply Prompt",
      "admin_autoreply_prompt_desc": "Instruktioner för att analysera e-postmeddelanden och skapa JSON-utkast.",
      "admin_save_prompts": "Spara Globala Prompter",
      "admin_prompts_saved": "Globala AI-promptkonfigurationer har sparats framgångsrikt!",
      "vpsMonitor.tabName": "VPS-övervakning",
      "vpsMonitor.title": "VPS-serverresurser",
      "vpsMonitor.cpu": "CPU-användning",
      "vpsMonitor.ram": "RAM-användning",
      "vpsMonitor.disk": "Diskanvändning",
      "vpsMonitor.cpuChart": "CPU-användning över tid",
      "vpsMonitor.ramChart": "RAM-användning över tid",
      "vpsMonitor.diskChart": "Diskanvändning över tid",
      "vpsMonitor.range1h": "Senaste timmen",
      "vpsMonitor.range6h": "Senaste 6 timmarna",
      "vpsMonitor.range24h": "Senaste 24 timmarna",
      "vpsMonitor.range7d": "Senaste 7 dagarna",
      "vpsMonitor.range30d": "Senaste 30 dagarna"
}
  },

        cs: {
    translation: {
        "social_publish_this_video": "Publikovat toto video",
        "tab_social_sub_upload": "Nahrát & Video",
        "tab_social_sub_skill_videos": "Videa Skillů",
        "tab_social_sub_connectors": "Konektory API",
        "tab_social_sub_comments": "Komentáře & AI Moderace",
        "tab_social_sub_history": "Historie Publikací",
        "social_tab_skill_videos": "Moje Videa Skillů",
        "social_skill_videos_title": "Moje Videa Skillů (Připraveno k Publikaci)",
        "social_skill_videos_empty": "Nebyly nalezeny žádné publikované skilly s video souborem.",

        "gen_new_posts": "Generovat nové příspěvky",
        "copy_content": "Kopírovat obsah",

        "free_skill_promo": "🎁 Publishing Prompts and Skills on our platform is completely FREE! You take no risk - we only take a 30% commission after a successful sale.",

        "pricing_mp4_price": "0 EUR (30% commission)",
        "pricing_order_price": "25 EUR + 23% DPH (jednorázově)",

        "pricing_options_title": "Možnosti publikování a ceny",
        "pricing_yt": "1. Odkaz na YouTube (vyžaduje tarif PRO)",
        "pricing_mp4": "2. Nahrát soubor MP4 na náš server",
        "pricing_mp4_non_pro": "1. Nahrát soubor MP4 na náš server",
        "pricing_order": "3. Objednat u nás nahrávání videa",
        "pricing_order_non_pro": "2. Objednat u nás nahrávání videa",

      "order_video_tab": "Order Video",
      "order_video_desc": "Don't have a video? We can record a professional presentation of your Skill for you! The cost is 25 EUR + 23% VAT. Just send us your files.",
      "skill_description_video": "Description & Instructions for the video",
      "proceed_to_payment_order_video": "Order video and Publish (25 EUR + 23% VAT)",

      "no_skills_yet": "You haven't published any skills for sale yet.",
      "preview": "Preview",
      "status_approved": "Published",
      "status_pending": "Pending Verification",
      "status_rejected": "Rejected",
      "chat_with_ai": "Ask AI about our offer",
      "no_skills_listed": "The seller hasn't listed any AI Skills yet.",
      "buy_skill": "Buy Skill",

      "filter_tags_title": "Filter by Tags",
      "filter_tags_desc": "Select AI technologies and models you are looking for in the database:",
      "apply_filters_btn": "Apply Filters",
      "enter_email_for_access": "Enter your email address to receive access:",
      "payment_error": "Payment error",
      "error_generic": "Error: ",
      "tab_publish_sell": "Publish / Sell",
      "tab_my_skills": "My Skills",
      "publish_sell_title": "Publish and Sell Your Prompt / Skill",
      "publish_sell_desc": "Choose how to upload a video showcasing your product or AI bot.",
      "my_published_skills": "My Published AI Skills",
      "publish_first_skill_desc": "Publish your first AI skill and start earning",
      "link_youtube": "YouTube Link",
      "upload_mp4": "Upload MP4",
      "skill_title": "Prompt / Skill Title",
      "skill_package_url": "Skill Package Link (Google Drive, GitHub, ZIP)",
      "skill_package_file": "Skill Package (.zip, .py, .json)",
      "skill_tags": "Tags / Technologies (e.g. Python, JS)",
      "skill_price": "Price (EUR)",
      "publish_for_verification": "Publish Prompt / Skill for Verification",
      "free_publish_pro_only": "Free unlimited YouTube publishing is available only for PRO subscribers.",
      "upload_fee_desc": "Video hosting on our servers is COMPLETELY FREE. We only take a 30% commission from each completed sale of your Prompt / Skill.",
      "table_video": "Video",
      "table_title_desc": "Title & Description",
      "table_price": "Price",
      "table_status": "Status",
      "table_actions": "Actions",
      "confirm_delete_skill": "Are you sure you want to delete this skill?",
      "fill_all_fields": "Please fill all fields!",
      "generic_error": "An error occurred",
      "connection_error": "Connection error: ",
      "select_video_file": "Select video file (MP4)",
      "click_to_select": "Click to select...",
      "proceed_to_payment_publish": "Proceed to payment (5 EUR) & Publish",
      "skill_video_link": "Odkaz na ukázkové video (YouTube/MP4)",
      "skill_video_placeholder": "https://...",
      "skill_package": "Balíček Skillu (.zip, .json, .py)",
      "skill_package_placeholder": "Vyberte soubor skillu...",
      "skill_description": "Popis skillu a instrukce",
      "skill_description_placeholder": "Jak používat tento skill?",
      "skill_tags": "Štítky / Technologie",
      "skill_tags_placeholder": "Vyberte technologie...",
      "login_action": "Přihlásit se",
      "create_account_action": "Vytvořit účet",

      "campaign_btn_create": "Utwórz kampanię / Create Campaign",
      "mcp_tools_console": "Konsola MCP / MCP Console",
      "mcp_select_tool": "Wybierz narzędzie / Select Tool",
      "mcp_active_badge": "Aktywne / Active",
      "mcp_json_params": "Parametry (JSON) / Params (JSON)",
      "mcp_test_btn": "Testuj / Test",
      "mcp_enter_pin_prompt": "Wpisz PIN / Enter PIN",
      "mcp_response_result": "Wynik / Result", 
        "tab_seo_audit": "SEO Audit",
        "seo_audit_title": "Globální SEO Audit",
        "seo_audit_desc": "Skenuje všechny klientské weby ohledně správnosti SEO, SSL, RWD a indexování v Google.",
        "seo_audit_resume": "Pokračovat v auditu",
        "seo_audit_new": "Nový audit",
        "seo_audit_scanning": "Skenování...",
        "seo_audit_confirm": "Jste si jisti, že chcete začít úplně nový audit? Předchozí zpráva bude uložena jako archivní verze.", "btn_compose": "Napsat",
        ask_ai: "Zeptat se AI",
        btn_clear_to_trash: "Přesunout do koše",
        empty_trash_btn: "Vysypat koš",
        filter_unread_btn: "🔵 Zobrazit nepřečtené",
        filter_unread_active: "🔵 Pouze nepřečtené (Aktivní)",
      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      calls_title: "Hovory a AI Voice",
      calls_description: "Nakonfigurujte Twilio a OpenAI API.",
      calls_instruction_title: "Instrukce",
      calls_instruction_desc: "Stáhněte si našeho průvodce: ",
      calls_instruction_link: "Stáhnout (PDF)",
      twilio_phone_number: "Twilio Číslo",
      openai_voice_api_key: "OpenAI API Key",
      ai_voice_system_prompt_label: "Instrukce",
      ai_voice_system_prompt_desc: "Pro výchozí nechte prázdné.",
      ai_voice_system_prompt_placeholder: "Výchozí...",
      webhook_config_title: "Twilio Webhook",
      webhook_config_desc: "Zkopírujte URL:",
      webhook_url: "Webhook URL",
      btn_copy: "Kopírovat",
      btn_copied: "Zkopírováno",
      btn_save_config: "Uložit",
      save_success_title: "Uloženo",
      save_success_desc: "Úspěšně uloženo.",
      save_error_title: "Chyba",
      save_error_desc: "Chyba.",
      tab_voice_config: "AI Voice Konfigurace",
      tab_voice_history: "Historie Hovorů",

      analytics_buy_tokens: "Koupit AI tokeny", analytics_package_desc: "1 balíček = 100 000 tokenů (50 PLN netto)", analytics_buy_btn: "Koupit za {{amount}} PLN",
      
      time_1h: "1h", time_24h: "24h", time_7d: "7 Dní", time_30d: "30 Dní", time_3m: "3 Měs.", time_6m: "6 Měs.",
      
      openai_api_key_voice: "OpenAI API Klíč (Realtime Voice)",
      tab_calls: "Hovory",
      calls_title: "Nastavení hlasového asistenta",
      twilio_phone_number: "Telefonní číslo Twilio",
      save_calls_settings: "Uložit hlasová nastavení",
      add_product: "Přidat Produkt / Službu",
  new_product_def: "Definice nového produktu / služby",
  product_name: "Název Produktu / Služby",
  price: "Cena",
  currency: "Měna",
  hidden_ai_only: "Skryto na veřejném profilu (pouze pro AI)",
  ai_knowledge_desc: "Popis (Co by se měla AI o tomto produktu naučit?)",
  save_product: "Uložit Produkt / Službu",
  update_product: "Uložit změny",
  confirm_delete: "Opravdu chcete tento produkt smazat?",
  delete: "Smazat",
  no_products_yet: "Zatím žádné produkty nebo služby. Přidejte svůj první produkt.",
      "logout": "Odhlásit se",
      "bg_color_tab": "Barva pozadí", "ai_image_tab": "AI Obrázek", "bg_color_label": "Vyberte barvu záhlaví", "bg_color_placeholder": "např. #4f46e5", "ai_image_title": "Generovat AI záhlaví (ComfyUI)", "ai_image_desc": "Vygenerujte pozadí záhlaví zadáním vlastní výzvy. Obrázek bude automaticky připojen k vašemu profilu.", "ai_image_prompt_placeholder": "např. Moderní kancelář, panorama, světlé barvy", "ai_image_btn": "Generovat obrázek", "ai_image_email_req": "Nejprve prosím uveďte svůj e-mail v registračním formuláři.", "ai_image_timeout": "Čekací doba na vygenerování obrázku vypršela.",
      "btn_activate_subscription": "Aktivovat tento plán",
      "btn_active_current": "Aktuální Plán",
      "error_accept_terms": "Pro pokračování musíte souhlasit s podmínkami.",
      "trial_expired_title": "🛑 Vyžadována Platba",
      "trial_expired_desc": "Chcete-li nadále používat svou AI vizitku a nástroje, vyberte si plán předplatného.",
      "plan_upgrade_success_basic": "Gratulujeme! Plán aktivován: AI Vizitka + Chatbot (100 PLN)",
      "plan_upgrade_success_pro": "Gratulujeme! Plán aktivován: Business PRO (2000 PLN)",
      "plan_basic_title": "🥉 Plán AI Vizitka + Chatbot",
      "plan_basic_price": "100 PLN + 23% VAT (123 PLN brutto) / měsíc",
      "plan_basic_desc": "Ideální startovací balíček. Zahrnuje správu profilu a školení chatbota:",
      "plan_basic_f1": "✅ AI Vizitka (Veřejný profil)",
      "plan_basic_f2": "✅ Školení AI Chatbota",
      "plan_basic_f3": "✅ Pracovní nabídky a události",
      "plan_basic_f4": "🔒 Reklamy, CRM, E-mail a Google Maps jsou deaktivovány",
      "plan_pro_title": "🥇 Creator / Seller Plan",
      "plan_pro_price": "5 EUR / month",
      "plan_pro_desc": "Unlock the ability to sell your Prompts and Skills in the Marketplace, upload videos, and earn money!",
      "marketplace_start_earning": "Začněte vydělávat nyní prodejem svých dovedností s AI",
      "hero_title_discover": "Objevujte & Prodávejte",
      "hero_title_skills": "AI Dovednosti",
      "marketplace_search_placeholder": "Co hledáte? Zeptejte se AI...",
      "marketplace_popular_skills": "Populární dovednosti",
      "marketplace_new_prompts": "Nové AI Prompty",
      "plan_pro_f1": "✅ Vše ze Základního plánu",
      "plan_pro_f2": "⚡ Vlastní CRM s inteligentními e-maily",
      "plan_pro_f3": "⚡ Generátory reklamních kampaní (Google & Meta)",
      "plan_pro_f4": "⚡ Google Maps a Auto-Discovery B2B Leady",
      "plan_pro_f5": "⚡ Generátor příspěvků na sociální sítě a newsletterů",
      "ai_requests_stat_title": "Využití AI (Agentic AI)",
      "ai_requests_today": "Dnes:",
      "ai_requests_btn": "Nastavení AI",
      ai_greeting: "Dobrý den! Jsem váš AI asistent. Zeptejte se na produkty a služby, nebo mi dovolte vytvořit profesionální webové stránky s AI Chatbotem pro vás! Pokračováním v této konverzaci automaticky souhlasíte se zpracováním a uložením všech zde poskytnutých údajů.",
      search_results_title: "Výsledky vyhledávání na mapě pro",
      all_companies_list_title: "Ověřený katalog AILinkB a interaktivní mapa",
      landing_ai_title_simple: "Jak vám můžeme dnes pomoci? (Globální vyhledávání)",
      landing_ai_subtitle_simple: "Hledáte firmu, službu nebo produkt? Zeptejte se hlasem nebo textem a já prohledám celou databázi AILinkB.",
      landing_ai_placeholder_simple: "Mluvte nebo napište, co hledáte...",
      search_by_voice_title: "Hledat hlasem",
      ai_crm_manager_title: "AI Assistant - CRM & Content Management",
      ai_crm_manager_desc: "Give commands via voice (Whisper STT) or text. Local Agentic AI executes operations via MCP Server.",
      ai_prompt_placeholder: "Click microphone or type command, e.g. 'Create website for newlead@company.com'...",
      ai_btn_execute: "Execute with Agentic AI & MCP",
      ai_voice_listening: "Listening for voice (Whisper)... Speak into the microphone.",
      ai_voice_speak_resp: "Listen to AI Response (XTTS Audio)",
      landing_ai_title: "Create your AI Website by Voice in 10 Seconds!",
      landing_ai_desc: "Speak into your microphone or type your instructions, and our local AI will instantly design your website preview via MCP.",
      landing_ai_placeholder: "Speak or type e.g.: 'I want a website for my firm, email contact@company.com'...",
      landing_btn_build: "Generate AI Website",
      ai_tts_generating: "Generating XTTS Voice...",
      ai_tts_played: "Voice response played (Local AI model).",
      ai_pin_required: "Enter your owner PIN for secure CRM modifications:",

      dashboard_welcome_title: "AILinkB CRM & AI Command Center",
      dashboard_welcome_desc: "Monitor live statistics and quickly navigate to key modules of your business.",
      dashboard_quick_actions: "Quick Actions",
      tab_crm_database: "Your Customer Database (CRM)",
      tab_public_discovery: "Company Search (Public Map & AI)",
      leads_stat_total: "Total Leads",
      leads_stat_scanned: "Scanned (Local)",
      leads_stat_enriched: "Enriched (AI)",
      leads_stat_email: "Ready with Email",
      leads_search_placeholder: "Search customer database (name, tax ID, email)...",

      tab_mcp: "MCP Server (AI)",
      mcp_title: "MCP Server & AI Gateway",
      mcp_subtitle: "Connect external AI models (Claude Desktop, Cursor, Custom Agents) directly to your CRM and Website Builder.",
      mcp_endpoint_label: "MCP Server Endpoint URL (JSON-RPC 2.0 & REST)",
      mcp_auth_title: "Authentication & Credentials",
      mcp_auth_desc: "Access to the MCP server requires your AILinkB Email (Login) and your 6-digit Security PIN.",
      mcp_login_label: "Your Login (Email)",
      mcp_pin_label: "Your Security PIN",
      mcp_pin_placeholder: "Enter 6-digit PIN to test tools...",
      mcp_tools_title: "Available MCP Tools & APIs",
      mcp_tools_desc: "These features can be invoked by AI agents to automate website generation, lead management, messages, and calendar scheduling.",
      mcp_test_btn: "Test Execution (Sandbox)",
      mcp_test_result: "Execution Result:",
      mcp_doc_title: "How to connect AI Agents via MCP?",
      mcp_doc_website: "Website Setup & Email Validation in MCP",
      mcp_doc_website_desc: "Using 'website_setup' tool, AI can generate a website profile. If an account/email already exists, the server returns a validation error preventing accidental overwriting unless explicit overwrite flag is set. To generate a live preview URL (https://www.ailinkb.com/?profile=...), invoke 'website_get_preview' with your email.",

      sync_in_background_title: "Synchronizace na pozadí",
      sync_in_progress: "Synchronizace e-mailů na pozadí...",
      sync_completed_refreshing: "Dokončeno. Aktualizuji seznam...",
      no_messages_found: "Nebyly nalezeny žádné zprávy.",
      "bg_color_tab": "Barva pozadí", "ai_image_tab": "AI Obrázek", "bg_color_label": "Vyberte barvu záhlaví", "bg_color_placeholder": "např. #4f46e5", "ai_image_title": "Generovat AI záhlaví", "ai_image_desc": "Vygenerujte pozadí záhlaví zadáním vlastní výzvy. Obrázek bude automaticky připojen k vašemu profilu.", "ai_image_prompt_placeholder": "např. Moderní kancelář, panorama, světlé barvy", "ai_image_btn": "Generovat obrázek", "ai_image_email_req": "Nejprve prosím uveďte svůj e-mail v registračním formuláři.", "ai_image_timeout": "Čekací doba na vygenerování obrázku vypršela.",
      "live_editor_title": "Živý Editor: Vytvořte si profil společnosti",
      "preview_btn_top": "👁️ Náhled (Nové okno)",
      "preview_btn_bottom": "👁️ Živý náhled webových stránek (Nové okno)",
      "preview_banner_title": "ŽIVÝ NÁHLED WEBOVÝCH STRÁNEK V REÁLNÉM ČASE",
      "preview_banner_desc": "Takto bude vypadat vaše dokončené webové stránky na AILinkB po uložení formuláře.",
      "preview_banner_close": "✖ Zavřít náhled",
      "our_services": "Naše Služby",
      "about_us": "O Nás",
      "about_us_placeholder": "Zadejte informace, které má AI používat, např.:\n• Pracovní doba a pravidla\n• Cenová politika a slevy\n• Výhody vaší společnosti\n• FAQ (často kladené dotazy)\n• Instrukce pro AI",
      "live_ai_chat": "Živý náhled AI chatu",
      "service_name": "Název služby",
      "brief_desc": "Stručný popis...",
      "add_service": "+ Přidat službu",
      "install_widget": "Jak nainstalovat widget na vaše stránky?",
      "profile_link": "Váš vyhrazený odkaz na profil",
      "copy": "Kopírovat",
      "ai_learn_note": "Poznámka: AI se vaše specifické údaje naučí až po kliknutí na Uložit.",

      "chat_consent_label": "Přijímám ",
      "privacy_policy_link": "Zásady ochrany osobních údajů",
      "privacy_policy_title": "Zásady ochrany osobních údajů",
      "privacy_policy_content": "Správcem údajů je QR-SYSTEM sp.z.o.o Płaza ul. Graniczna 13B, Základní kapitál 10 000 PLN. Používáním našeho AI chatu souhlasíte se zpracováním vašeho e-mailu a dat z konverzace. AI asistent poskytuje odpovědi na základě dostupného kontextu a jeho přesnost závisí na schopnostech systému. Podle GDPR máte právo na přístup ke svým osobním údajům, jejich opravu nebo výmaz (Právo být zapomenut). Chcete-li požádat o vymazání vašich údajů, jednoduše nám zašlete e-mail. Máte také právo podat stížnost u dozorového úřadu pro ochranu osobních údajů.\n\nZásady publikování obsahu:\nUživatelé publikující své vlastní videomateriály (Prompty / Dovednosti) v naší službě jsou povinni ve videoobsahu výslovně uvést, že materiál je publikován a dostupný na platformě AILinkB. Nahráním uživatel rovněž uděluje platformě AILinkB svolení publikovat a propagovat jeho videomateriály na našich kanálech sociálních médií jeho jménem.",
      "cookie_title": "Tyto webové stránky používají soubory cookie 🍪",
      "cookie_desc": "Používáme soubory cookie, abychom zajistili nejlepší zážitek na našich webových stránkách. Souhlasem přijímáte naše zásady týkající se souborů cookie. Přístup na stránky vyžaduje váš souhlas.",
      "cookie_accept": "Přijímám",
      "Find Service Near You": "Najít službu ve vašem okolí",
      "search_placeholder": "Co hledáte?",
      "search_services": "Služby/Produkty",
      "search_purchases": "Nákupní potřeby",
      "search_jobs": "Pracovní nabídky",
      "title_services": "Najděte služby ve svém okolí",
      "title_purchases": "Najděte nákupní potřeby ve svém okolí",
      "title_jobs": "Najděte pracovní nabídky ve svém okolí",
      "tab_announcements": "B2B Announcements",
      "b2b_announcements_board": "B2B Announcements Board",
      "add_announcement": "Add Announcement",
      "all_announcements": "All Announcements",
      "my_announcements": "My Announcements",
      "no_announcements_board": "No announcements on the board.",
      "no_announcements_mine": "You haven't added any announcements yet.",
      "new_announcement": "New Announcement",
      "announcement_type_label": "Announcement Type",
      "announcement_type_job": "Job Offer (Looking for an employee)",
      "announcement_type_purchase": "Purchase Need (Looking for a service/product)",
      "announcement_title_label": "Title",
      "announcement_title_placeholder": "e.g., Looking for server supplier / Hiring Frontend Developer",
      "announcement_desc_label": "Description and details",
      "announcement_desc_placeholder": "Describe exactly what you need or who you are looking for...",
      "announcement_save": "Save and Publish",
      "badge_purchase": "Buying Need",
      "badge_job": "Job Offer",
      "tab_job_offers": "Job Offers",
      "no_job_offers": "No job offers found.",
      "verify_cv": "Apply / Verify CV",
      "verify_cv_title": "AI CV Verification",
      "verify_cv_desc": "Paste your CV below, and our AI will evaluate how well you match this job offer. You will receive a match score and personalized feedback.",
      "paste_cv_label": "Paste your CV",
      "paste_cv_placeholder": "Paste your full CV text here...",
      "run_ai_evaluation": "Evaluate CV with AI",
      "ai_feedback": "AI Evaluation Feedback",
      "tab_report_bug": "Report a Bug",
      "report_bug_desc": "Found an issue? Please describe it as accurately as possible. It will be sent directly to our technical team.",
      "report_bug_label": "Bug description",
      "report_bug_placeholder": "What happened? What were you trying to do? Include error messages if possible...",
      "report_bug_submit": "Send Bug Report",
      "report_bug_success_title": "Thank you!",
      "report_bug_success_desc": "Your report has been sent to our team.",
      "report_bug_error_title": "Error",
      "report_bug_error_desc": "We couldn't send your report right now. Please try again later.",
      "search_button": "Hledat",
      "no_companies_found": "Zatím nebyly nalezeny žádné společnosti.",
      "address": "Adres:",
      "phone": "Telefon:",
      "website": "Webová stránka:",
      "email": "E-mail:",
      "view_details": "Zobrazit podrobnosti",
      "chat_ai": "Chat",
      "greeting": "Ahoj! Jsem AI asistent pro {{name}}.",
      "km_away": "km daleko",
      "company_details": "Detaily společnosti",
      "about_company": "O společnosti:",
      "offered_services": "Nabízené služby:",
      "duration": "Trvání",
      "mins": "min",
      "start_ai_consultation": "Zahájit AI konzultaci",
      "no_details": "Žádné podrobnosti.",
      "typing": "Píše...",
      "type_message": "Napište svou zprávu...",
      "more": "více",
      "language": "Jazyk",
      "tab_map_of_partners": "Mapa partnerů",
      "tab_dashboard": "Přístrojová deska",
      "tab_system_logs": "Systémové protokoly",
      "tab_phone_calls": "Telefonáty",
      "tab_website": "Moje Webstránka",
      "tab_customers": "Zákazníci",
      "tab_appointments": "Schůzky",
      "tab_email": "E-mail",
      "tab_whatsapp": "WhatsApp",
      "tab_drafts_ai": "Koncepty (AI)",
      "tab_visitor_chats": "Chaty návštěvníků",
      "tab_orders": "Objednávky",
      "tab_mail_campaigns": "E-mailové kampaně",
      "tab_ad_campaigns": "Reklamní kampaně (AI)",
      "tab_email_templates": "E-mailové šablony",
      "tab_blacklist": "Černá listina",
      "tab_services": "Služby",
      "tab_events": "Události",
      "chat_update_offline": "Probíhá aktualizace softwaru. Za chvíli budete moci pokračovat v konverzaci...",
      "tab_settings": "Nastavení",
      "tab_admin_panel": "Panel administrátora",
      "install_widget": "Instalovat widget",
      "unread_emails": "Nepřečtené e-maily",
      "go_to_inbox": "Přejít do doručené pošty",
      "remaining_appointments": "Zbývající schůzky",
      "go_to_calendar": "Přejít do kalendáře",
      "new_orders_today": "Nové objednávky dnes",
      "view_orders": "Zobrazit objednávky",
      "total_customers": "Celkem zákazníků",
      "view_database": "Zobrazit databázi",
      "dashboard_chat_title": "AILinkB Dashboard Chat",
      "dashboard_chat_desc": "Ptejte se na základě vašich datových zdrojů.",
      "unread_chats": "Nepřečtené Chaty",
      "knowledge_sources": "ZDROJE ZNALOSTÍ:",
      "ai_searching": "AI prohledává vaši znalostní bázi...",
      "cal_daily_appointments": "Denní Schůzky",
      "cal_new_appointment": "Nová Schůzka",
      "cal_reminder": "Připomínka",
      "cal_meeting_details": "Detaily Schůzky",
      "cal_time": "Čas",
      "cal_agenda": "Agenda / Poznámky",
      "cal_no_notes": "Žádné poznámky.",
      "cal_confirm": "Potvrdit",
      "cal_delete": "Smazat",
      "cal_delete_confirm": "Smazat schůzku?",
      "cal_schedule_new": "Naplánovat Novou Schůzku",
      "cal_meeting_title": "Název Schůzky",
      "cal_associated_lead": "Přidružený Kontakt",
      "cal_search_lead": "Hledat kontakt...",
      "cal_no_leads": "Žádné kontakty nenalezeny",
      "cal_start_time": "Čas Začátku",
      "cal_end_time": "Čas Konce",
      "cal_cancel": "Zrušit",
      "cal_schedule": "Naplánovat",
      "admin_title": "Panel Administrátora - Uživatelé a Role",
      "admin_search_email": "Hledat E-mail",
      "admin_search_email_placeholder": "Hledat podle e-mailu...",
      "admin_filter_role": "Filtrovat podle Role",
      "admin_all_roles": "Všechny Role",
      "admin_filter_status": "Filtrovat podle Stavu",
      "admin_filter_plan": "Filtrovat podle Plánu",
      "admin_clear": "Vymazat",
      "admin_id": "ID",
      "admin_email": "E-mail",
      "admin_company": "Firma",
      "admin_role": "Role",
      "admin_subscription": "Předplatné",
      "admin_plan": "Plán",
      "admin_no_users": "Nebyli nalezeni žádní odpovídající uživatelé.",
      "admin_prompts_title": "Globální AI Prompty a Chování Systému (Panel Administrátora)",
      "admin_prompts_desc": "Nakonfigurujte celkové chování AI, konverzování a jazykové reguly. Zde NENASTAVUJTE specifické údaje firem (k tomu slouží profil klienta).",
      "admin_global_rules_label": "Globální AI Pravidla a Přirozený Lidský Tón",
      "admin_global_rules_desc": "Hlavní pravidla vyžadující přirozené, přátelské chování jako člověk, stručnou komunikaci a plynulé reakce na pozdravy.",
      "admin_default_system_prompt_label": "Výchozí Systémový Prompt (Pro Nové Podměty)",
      "admin_default_system_prompt_desc": "Základní instrukce pro spolupráci AI se znalostní bází a vektorovým vyhledáváním RAG.",
      "admin_autoreply_prompt_label": "Prompt pro Automatické Odpovědi na E-maily",
      "admin_autoreply_prompt_desc": "Instrukce pro analýzu e-mailů a generování konceptů odpovědí v JSON formátu.",
      "admin_save_prompts": "Uložit Globální Prompty",
      "admin_prompts_saved": "Konfigurace globálních AI promptů byly úspěšně uloženy!",
      "vpsMonitor.tabName": "Monitor VPS",
      "vpsMonitor.title": "Zdroje serveru VPS",
      "vpsMonitor.cpu": "Využití CPU",
      "vpsMonitor.ram": "Využití RAM",
      "vpsMonitor.disk": "Využití disku",
      "vpsMonitor.cpuChart": "Využití CPU v čase",
      "vpsMonitor.ramChart": "Využití RAM v čase",
      "vpsMonitor.diskChart": "Využití disku v čase",
      "vpsMonitor.range1h": "Poslední hodina",
      "vpsMonitor.range6h": "Posledních 6 hodin",
      "vpsMonitor.range24h": "Posledních 24 hodin",
      "vpsMonitor.range7d": "Posledních 7 dní",
      "vpsMonitor.range30d": "Posledních 30 dní"
}
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie']
    },
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;

